/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum CriticalGeometryArtifactKind {
  PartAnalysis = "part_analysis",
  MoldResult = "mold_result",
  DependencyLayout = "dependency_layout",
  GroundTruth = "ground_truth",
}

export enum DependencySortField {
  Status = "status",
  Name = "name",
  Path = "path",
  Occurrences = "occurrences",
}

export enum DependencyFilter {
  All = "all",
  Missing = "missing",
  Available = "available",
}

export enum DependencyStatus {
  Matched = "matched",
  Resolved = "resolved",
  Missing = "missing",
}

export enum AssetsByStateSort {
  OldestFirst = "oldest-first",
  RecentlyUpdatedFirst = "recently-updated-first",
}

export enum MoldSide {
  Core = "core",
  Cavity = "cavity",
}

export enum RemediableFailureKind {
  Asset = "asset",
  PartFinderReport = "part-finder-report",
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum FolderContentsSortField {
  FolderNameAndAssetPath = "folderNameAndAssetPath",
  Name = "name",
  Path = "path",
  CreatedAt = "createdAt",
  CreatedBy = "createdBy",
  Label = "label",
}

export enum MetadataFieldType {
  Text = "text",
  Number = "number",
  Boolean = "boolean",
  Url = "url",
}

export enum PartFinderBatchInputMethod {
  Paste = "paste",
  Csv = "csv",
  FlisSelect = "flis-select",
  Images = "images",
}

export enum PartFinderFeedbackRating {
  Up = "up",
  Down = "down",
}

export enum PartFinderFeedbackTargetType {
  Recommendation = "recommendation",
  SourcingOpportunity = "sourcing_opportunity",
}

export enum PartRelationshipEvidenceKind {
  FlisDirect = "flis-direct",
  FlisDerived = "flis-derived",
  PartFinderObservation = "part-finder-observation",
  NsnNowProcurement = "nsn-now-procurement",
}

export enum PartRelationshipEdgeType {
  HAS_REFERENCE_NUMBER = "HAS_REFERENCE_NUMBER",
  REFERENCE_LISTED_BY = "REFERENCE_LISTED_BY",
  SHARES_REFERENCE_NUMBER = "SHARES_REFERENCE_NUMBER",
  SUPERSEDED_BY = "SUPERSEDED_BY",
  INTERCHANGEABLE_WITH = "INTERCHANGEABLE_WITH",
  SUBSTITUTE_FOR = "SUBSTITUTE_FOR",
  FABRICATED_FROM = "FABRICATED_FROM",
  LABELED_FOR_END_ITEM = "LABELED_FOR_END_ITEM",
  COMPONENT_OF = "COMPONENT_OF",
  SUPPLIED_BY = "SUPPLIED_BY",
  HAS_ACQUISITION_RECORD = "HAS_ACQUISITION_RECORD",
}

export enum PartRelationshipNodeType {
  Nsn = "nsn",
  PartNumber = "part-number",
  Cage = "cage",
  EndItem = "end-item",
  Supplier = "supplier",
  AcquisitionRecord = "acquisition-record",
}

export enum DocumentProvenance {
  LinkOnly = "link-only",
  ContentVerified = "content-verified",
  PublicDomain = "public-domain",
}

export enum DocumentType {
  Datasheet = "datasheet",
  Drawing = "drawing",
  Spec = "spec",
  Manual = "manual",
  Other = "other",
}

export enum PartFinderImageKind {
  Photo = "photo",
  Drawing = "drawing",
  SearchPhoto = "search-photo",
}

export enum ThumbnailMatchType {
  Exact = "exact",
  Related = "related",
}

export enum SupplierType {
  OEMManufacturer = "OEM Manufacturer",
  AuthorizedDistributor = "Authorized Distributor",
  GovernmentDefenseContractor = "Government/Defense Contractor",
}

export enum SourcingProvenance {
  VerifiedSupplier = "verified_supplier",
  WebDiscovered = "web_discovered",
}

export enum PartIdentifierType {
  Niin = "niin",
  PartNumber = "part-number",
}

export enum FlisPhraseRelation {
  ReplacedBy = "replaced-by",
  Replaces = "replaces",
  InterchangeableWith = "interchangeable-with",
  SubstituteFor = "substitute-for",
  WhenExhaustedUse = "when-exhausted-use",
  FabricateFrom = "fabricate-from",
}

export enum EndItemMatchKind {
  Nsn = "nsn",
  PartNumber = "part-number",
}

export enum PartImageEvidenceTier {
  Observed = "observed",
  ObservedUncertain = "observed-uncertain",
  Inferred = "inferred",
}

export enum PartImageIdentificationOutcome {
  ReportCreated = "report-created",
  NeedsSelection = "needs-selection",
  NoCandidates = "no-candidates",
  NoPart = "no-part",
  MultipleItems = "multiple-items",
}

export enum PartImageIdentificationStage {
  ReadingPhotos = "reading-photos",
  ZoomingLabels = "zooming-labels",
  MatchingFlis = "matching-flis",
  Finished = "finished",
}

export enum LabelingStatus {
  Pending = "pending",
  Skipped = "skipped",
  Assigned = "assigned",
  NoMatch = "no-match",
}

export enum AssetType {
  Document = "document",
  Image = "image",
  Model = "model",
  Manifest = "manifest",
  Scan = "scan",
  Scene = "scene",
  Mold = "mold",
}

export enum ReportType {
  DUPLICATION = "DUPLICATION",
  SIMPLIFICATION = "SIMPLIFICATION",
  CUSTOM = "CUSTOM",
}

/**
 * The v3-side ledger of one match question. `runKey` is content-addressed over everything that
 * changes the answer, and a question has one row: asking it again finds that row. Two different part
 * sets against one scene are two questions, and both may run at once.
 */
export enum SceneMatchRunStatus {
  Dispatched = "dispatched",
  Committed = "committed",
  Failed = "failed",
}

export enum DailyHealthStatus {
  Operational = "Operational",
  Degraded = "Degraded",
  MajorOutage = "MajorOutage",
  NoData = "NoData",
}

export enum JobStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum LabelSource {
  User = "user",
  PhysnaGenerated = "physna-generated",
  Propagated = "propagated",
}

export enum TenantType {
  Standard = "standard",
  Trial = "trial",
}

export enum TenantRole {
  Admin = "admin",
  Author = "author",
  Viewer = "viewer",
  Search = "search",
}

export enum GateKind {
  Direct = "direct",
  Edge = "edge",
}

export enum AssetState {
  Indexing = "indexing",
  Finished = "finished",
  Failed = "failed",
  Unsupported = "unsupported",
  No3DData = "no-3d-data",
  MissingDependencies = "missing-dependencies",
}

export enum BodyInterfaceRole {
  OvermoldCandidate = "overmold_candidate",
}

/**
 * Stringified UUIDv4 or UUIDv5.
 * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
 * @format uuid
 * @pattern [0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[45][0-9A-Fa-f]{3}-[89ABab][0-9A-Fa-f]{3}-[0-9A-Fa-f]{12}
 */
export type UUID = string;

export type Point3D = number[];

export interface Measurements {
  /** @format double */
  length: number;
  /** @format double */
  width: number;
  /** @format double */
  height: number;
  /** @format double */
  volume: number;
  /** @format double */
  area: number;
  center: Point3D;
  rotation_matrix: number[];
  obb_corners: Point3D[];
}

export interface Extents3D {
  /** @format double */
  x: number;
  /** @format double */
  y: number;
  /** @format double */
  z: number;
}

export interface UndercutInfo {
  release_vector: Point3D;
  centroid: Point3D;
  release_endpoint: Point3D;
  /** @format double */
  release_length: number;
  release_point_10pct: Point3D;
  /** @format double */
  surface_area: number;
  undercut_type:
    | "Straight Lifter"
    | "Mechanical Slide"
    | "Hydraulic Core Pull"
    | "Overmold";
  extents: Extents3D;
}

export interface UndercutGroup {
  triangles: Point3D[][];
  face_ids: number[];
  triangle_vertex_coordinates: Point3D[][];
  undercut_info: UndercutInfo;
}

export interface RibGroup {
  name: string;
  triangle_vertex_coordinates: Point3D[][];
  /** @format double */
  thickness?: number | null;
  /** @format double */
  length?: number | null;
  /** @format double */
  height?: number | null;
  is_insert?: boolean;
}

export interface Traceability {
  algorithm_build: string;
}

export interface BodyInterfaceComponent {
  /** @format double */
  id: number;
  /** @format double */
  vertex_count: number;
  /** @format double */
  triangle_count: number;
  /** @format double */
  surface_area_mm2: number;
  bbox: number[];
  /** @format double */
  median_edge_length_mm: number;
  role?: BodyInterfaceRole | null;
}

export interface BodyInterface {
  /** @format double */
  smaller_component_id: number;
  /** @format double */
  larger_component_id: number;
  /** @format double */
  interface_area_mm2: number;
  smaller_anti_parallel_triangle_runs: number[];
  smaller_parallel_triangle_runs: number[];
  /** @format double */
  eps_mm?: number | null;
}

export interface SingleBodySurfaceRegion {
  /** @format double */
  id: number;
  bbox: number[];
  axis: string;
  triangle_runs: number[];
  confidence: string;
  flags?: string[];
  triangle_vertex_coordinates?: Point3D[][] | null;
  /** @format double */
  boundary_axis_cut_position_mm?: number | null;
  cap_cut_bbox?: number[] | null;
  boundary_loop_coordinates?: Point3D[][] | null;
  cap_cut_triangle_vertex_coordinates?: Point3D[][] | null;
  cap_cut_contour_coordinates?: Point3D[][] | null;
  cap_cut_contour_polylines?: Point3D[][] | null;
  cap_cut_simplified_contour_polylines?: Point3D[][] | null;
  cap_cut_smoothed_contour_polylines?: Point3D[][] | null;
}

export interface BodyInterfaceConfig {
  /** @format double */
  fixed_distance_eps_mm: number;
  /** @format double */
  facing_threshold: number;
  /** @format double */
  proximity_offset_mm: number;
  /** @format double */
  orientation_deadzone: number;
  /** @format double */
  min_interface_area_mm2: number;
  /** @format double */
  min_interface_triangles: number;
  /** @format double */
  bbox_overlap_padding_mm: number;
  /** @format double */
  max_components: number;
}

export interface BodyInterfaceAnalysisResult {
  engine_version: string;
  /** @format double */
  result_schema_version: number;
  /** @format double */
  timing_s: number;
  components: BodyInterfaceComponent[];
  interfaces: BodyInterface[];
  single_body_surface_regions?: SingleBodySurfaceRegion[];
  overmold_candidate_component_ids?: number[];
  overmold_candidate_single_body_region_ids?: number[];
  /** @format double */
  non_manifold_edges_count: number;
  /** @format double */
  non_manifold_edges_per_1k_triangles: number;
  non_manifold_edges: number[];
  config: BodyInterfaceConfig;
}

export interface RfqFinish {
  hasGrain: boolean;
  textureType?: string;
  textureSource?: string;
  cavitySurfaceFinish?: string;
  coreSurfaceFinish?: string;
  source: string;
}

export interface PartAnalysisResult {
  measurements?: Measurements;
  release_direction?: Point3D;
  undercut_groups?: UndercutGroup[];
  parting_line_groups?: Point3D[][];
  rib_groups?: RibGroup[];
  draft_risk_inds?: number[];
  undercut_inds?: number[];
  traceability?: Traceability;
  bodyInterface?: BodyInterfaceAnalysisResult;
  rfqFinish?: RfqFinish;
}

export interface BoundingBoxExtents {
  /** @format double */
  z: number;
  /** @format double */
  y: number;
  /** @format double */
  x: number;
}

export interface ActionBox {
  clearanceExtents?: BoundingBoxExtents;
  clearanceCorners?: number[][];
  actionType: string;
  extents: BoundingBoxExtents;
  corners: number[][];
}

export interface OvermoldOverlayBox {
  corners: number[][];
}

export interface OvermoldOverlay {
  polylines: number[][][];
  meshes: number[][][][];
  boxes: OvermoldOverlayBox[];
}

export interface ManifestDependencyOccurrence {
  path: string;
  assetId?: string;
  assetState?: AssetState;
  status?: AssetState;
  mirrored?: boolean;
  transform: number[][];
  releaseVector?: number[];
  boundingBoxCorners?: number[][];
  boundingBoxExtents?: BoundingBoxExtents;
  /** @format double */
  zRotationDegrees?: number;
  actionBoxes?: ActionBox[];
  overmoldOverlay?: OvermoldOverlay;
  rfqFinish?: RfqFinish;
  interiorCeiling?: number[];
}

export interface DependencyLayoutAssembly {
  partingLine?: number[][][];
  boundingBoxExtents: BoundingBoxExtents;
  boundingBoxCorners: number[][];
}

export interface BoundingBoxDimensions {
  /** @format double */
  depth: number;
  /** @format double */
  height: number;
  /** @format double */
  width: number;
}

export type MoldBlockDimensions = BoundingBoxDimensions & {
  /** @format double */
  bSideDepth?: number;
  /** @format double */
  aSideDepth?: number;
};

export interface ChiralityGroupReference {
  path: string;
}

export interface ChiralityGroupComparison {
  /** @format double */
  matchScorePercent: number;
  relationshipToReference: "same-side" | "mirror-side";
  path: string;
}

export interface ChiralityGroup {
  relationshipsConsistent: boolean;
  /** @format double */
  confidencePercent: number;
  comparisons: ChiralityGroupComparison[];
  reference: ChiralityGroupReference;
  groupId: string;
}

export interface GateFeed {
  /** @format double */
  bodyIndex: number;
  path: string;
}

export interface GateLand {
  /** @format double */
  height: number;
  /** @format double */
  width: number;
  /** @format double */
  length: number;
}

export interface Gate {
  land?: GateLand;
  /** @format double */
  offset?: number;
  outward?: number[];
  contact?: number[];
  path?: string;
  /** @format double */
  partIndex?: number;
  feeds?: GateFeed[];
  /** @format double */
  height: number;
  /** @format double */
  radius: number;
  center: number[];
  kind?: GateKind;
}

export interface ManifestViewerFilesResponse {
  occurrences: ManifestDependencyOccurrence[];
  assembly?: DependencyLayoutAssembly;
  mmBlockDimensions?: MoldBlockDimensions;
  chiralityGroups?: ChiralityGroup[];
  gates: Gate[];
}

/** Construct a type with a set of properties K of type T */
export type RecordStringString = Record<string, string>;

export interface AssemblyTreePartResponse {
  type: "part" | "subassembly";
  relativePath: string;
  children: AssemblyTreePartResponse[];
}

export interface DependencyNodeMapResponse {
  /** Construct a type with a set of properties K of type T */
  nodeMap: RecordStringString;
  assemblyTree?: AssemblyTreePartResponse[];
  assetPath: string;
}

export interface Vector3 {
  /** @format double */
  x: number;
  /** @format double */
  y: number;
  /** @format double */
  z: number;
}

export interface HoleDescriptor {
  /** Hole center after alignment, in millimeters. */
  centerMm: Vector3;
  /** Unitless direction vector along the hole axis. */
  axis: Vector3;
  /**
   * Detected hole radius, in millimeters.
   * @format double
   */
  radiusMm: number;
}

export interface MismatchVolumeMm3 {
  /**
   * Volume of unmatched source geometry, in cubic millimeters.
   * @format double
   */
  sourceMissMm3: number;
  /**
   * Volume of unmatched target geometry, in cubic millimeters.
   * @format double
   */
  targetMissMm3: number;
  /**
   * Mismatch volume attributed to unmatched source holes, in cubic millimeters.
   * @format double
   */
  sourceHoleMissMm3: number;
  /**
   * Mismatch volume attributed to unmatched target holes, in cubic millimeters.
   * @format double
   */
  targetHoleMissMm3: number;
  /**
   * Total mismatch volume reported for the comparison, in cubic millimeters.
   * @format double
   */
  totalMm3: number;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringUnknown = Record<string, any>;

export interface TenantUserSettings {
  tenantId: string;
  tenantRole: TenantRole;
  userEnabled: boolean;
  tenantDisplayName?: string;
  tenantShortName?: string;
  /** @format double */
  assetLimit?: number;
  /** @format double */
  assetLimitWarningThresholdPercent?: number;
  /** @format date-time */
  trialExpiresAt?: string;
  tenantType?: TenantType;
  isRemoteSearchTenant?: boolean;
}

export interface User {
  email: string;
  settings: TenantUserSettings;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateUserRequest {
  /**
   * The email address of the user to create.
   *
   * * Must be a valid email format
   * * Must be unique
   * @minLength 1
   * @maxLength 320
   */
  email: string;
  /** The tenant role to assign to the user. */
  tenantRole: TenantRole;
}

export interface UpdateUserRequest {
  /**
   * The tenant role to assign to the user.
   * If not provided, the role will not be changed.
   */
  tenantRole?: TenantRole;
  /**
   * Whether the user should be enabled or disabled.
   * If not provided, the enabled status will not be changed.
   */
  enabled?: boolean;
}

export interface PageData {
  /** @format int32 */
  total: number;
  /** @format int32 */
  perPage: number;
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  lastPage: number;
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /**
   * True when the backend capped how much it would count, so `total` and `lastPage` are a ceiling
   * rather than the real number of matches. Not set on Postgres-backed listings (their total is
   * exact) or on responses forwarded from a remote search host, which are returned unmodified.
   */
  totalIsLowerBound?: boolean;
  /** @format int32 */
  totalExact?: number;
}

export interface DashboardVersionResponse {
  /**
   * Opaque token that changes when anything the dashboard reads has changed. Compare it with the
   * previous value; do not parse it.
   */
  version: string;
}

export interface SearchCountsByTypeResponse {
  /** @format double */
  text: number;
  /** @format double */
  visual: number;
  /** @format double */
  geometric: number;
  /** @format double */
  part: number;
  /** @format double */
  composite: number;
  /** @format double */
  metadata: number;
}

export interface ReportCountsByTypeResponse {
  /** @format double */
  DUPLICATION: number;
  /** @format double */
  SIMPLIFICATION: number;
  /** @format double */
  CUSTOM: number;
}

/** Actions per feature over the range, for a ranked "features used" view. */
export interface FeatureUsageResponse {
  /** @format double */
  search_text: number;
  /** @format double */
  search_visual: number;
  /** @format double */
  search_geometric: number;
  /** @format double */
  search_part: number;
  /** @format double */
  search_composite: number;
  /** @format double */
  search_metadata: number;
  /** @format double */
  compare: number;
  /** @format double */
  download: number;
  /**
   * Folder contents listed (browsing).
   * @format double
   */
  folder_browse: number;
  /**
   * Folders created, renamed, moved or deleted.
   * @format double
   */
  folder_manage: number;
  /**
   * Asset metadata set or removed, and metadata fields created, renamed or deleted.
   * @format double
   */
  metadata_edit: number;
  /**
   * 3D viewer files served.
   * @format double
   */
  viewer_open: number;
  /**
   * Taxonomies and taxonomy nodes created, renamed, moved, imported or deleted.
   * @format double
   */
  taxonomy_manage: number;
  /**
   * Labels applied to or removed from assets by a user.
   * @format double
   */
  taxonomy_label: number;
  /** @format double */
  upload: number;
  /** @format double */
  report: number;
}

export interface DailyTenantActivityResponse {
  /**
   * Searches of every type run against the tenant.
   * @format double
   */
  searches: number;
  /**
   * Asset comparisons opened in the compare viewer.
   * @format double
   */
  compares: number;
  /**
   * Asset file downloads.
   * @format double
   */
  downloads: number;
  /**
   * Assets uploaded by users (demo assets excluded).
   * @format double
   */
  uploads: number;
  /**
   * Reports created.
   * @format double
   */
  reports: number;
  /**
   * Distinct users who made at least one authenticated request to the tenant.
   * @format double
   */
  activeUsers: number;
  /** UTC day, `YYYY-MM-DD`. */
  date: string;
}

export interface TenantActivityMetricsResponse {
  /**
   * Searches of every type run against the tenant.
   * @format double
   */
  searches: number;
  /**
   * Asset comparisons opened in the compare viewer.
   * @format double
   */
  compares: number;
  /**
   * Asset file downloads.
   * @format double
   */
  downloads: number;
  /**
   * Assets uploaded by users (demo assets excluded).
   * @format double
   */
  uploads: number;
  /**
   * Reports created.
   * @format double
   */
  reports: number;
  /**
   * Distinct users who made at least one authenticated request to the tenant.
   * @format double
   */
  activeUsers: number;
  /**
   * How many of `activeUsers` have a Physna email address.
   * @format double
   */
  internalActiveUsers: number;
  searchesByType: SearchCountsByTypeResponse;
  reportsByType: ReportCountsByTypeResponse;
  /** Actions per feature over the range, for a ranked "features used" view. */
  featureUsage: FeatureUsageResponse;
  /** One entry per UTC day in the range, oldest first, with zeros for days without activity. */
  daily: DailyTenantActivityResponse[];
}

export interface TaxonomyNode {
  id: string;
  tenantId: string;
  taxonomyId: string;
  name: string;
  parentNodeId?: string;
  hasChildren: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateTaxonomyNodeResponse {
  node: TaxonomyNode;
}

export interface CreateTaxonomyNodeRequest {
  /**
   * The name of the node.
   * @minLength 1
   * @maxLength 255
   * @example "Fasteners"
   */
  name: string;
  /** The ID of the parent node. Omit for root nodes. */
  parentNodeId?: UUID;
}

export interface ImportTaxonomyNodesResponse {
  /** @format double */
  importedCount: number;
}

export interface ImportNodeInput {
  name: string;
  children: ImportNodeInput[];
}

export interface ImportTaxonomyNodesRequest {
  /** The tree of nodes to import. Each node has a name and optional children. */
  nodes: ImportNodeInput[];
}

export interface DiffTaxonomyImportResponse {
  additions: {
    hasChildren: boolean;
    parentName?: string;
    name: string;
  }[];
  removals: {
    /** @format double */
    labelCount: number;
    hasChildren: boolean;
    parentName?: string;
    name: string;
    nodeId: string;
  }[];
  moves: {
    newParentName?: string;
    currentParentName?: string;
    name: string;
    nodeId: string;
  }[];
  suggestedRenames: {
    /** @format double */
    similarity: number;
    /** @format double */
    labelCount: number;
    parentName?: string;
    additionName: string;
    removalName: string;
    removalNodeId: string;
  }[];
  /** @format double */
  unchangedCount: number;
}

export interface DiffTaxonomyImportRequest {
  /** The tree of nodes from the CSV to diff against existing taxonomy nodes. */
  nodes: ImportNodeInput[];
}

export interface ReimportTaxonomyNodesResponse {
  /** @format double */
  addedCount: number;
  /** @format double */
  removedCount: number;
  /** @format double */
  movedCount: number;
  /** @format double */
  renamedCount: number;
  /** @format double */
  deletedLabelCount: number;
}

export interface ReimportTaxonomyNodesRequest {
  /** The full tree of nodes representing the desired taxonomy state. */
  nodes: ImportNodeInput[];
  /** IDs of existing nodes the user chose to keep, even though they are not in the new tree. */
  keepNodeIds: string[];
  /** Map of existing node IDs to their new names. Used for renaming nodes instead of deleting and recreating. */
  renameMap: RecordStringString;
}

export interface ListTaxonomyNodesResponse {
  nodes: TaxonomyNode[];
  pageData: PageData;
}

export interface SearchTaxonomyNodesResponse {
  results: {
    ancestors: TaxonomyNode[];
    node: TaxonomyNode;
  }[];
  pageData: PageData;
}

export interface GetNodeAncestorsResponse {
  ancestors: TaxonomyNode[];
}

export interface GetTaxonomyNodeResponse {
  node: TaxonomyNode;
}

export interface Label {
  id: string;
  assetId: string;
  taxonomyId: string;
  taxonomyNodeId: string;
  source?: LabelSource;
  /** @format double */
  confidence?: number;
  assignedBy?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ListLabelsByNodeResponse {
  labels: Label[];
  pageData: PageData;
}

export interface UpdateTaxonomyNodeResponse {
  node: TaxonomyNode;
}

export interface RenameTaxonomyNodeRequest {
  /**
   * The new name for the node.
   * @minLength 1
   * @maxLength 255
   * @example "Bolts"
   */
  name: string;
}

export interface MoveTaxonomyNodeRequest {
  /**
   * The new parent node ID. Pass `root` to move to root.
   * @example "root"
   */
  parentNodeId: string;
}

export interface Taxonomy {
  id: string;
  tenantId: string;
  name: string;
  autoLabelOptedIn: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateTaxonomyResponse {
  taxonomy: Taxonomy;
}

export interface CreateTaxonomyRequest {
  /**
   * Optional name for the taxonomy. Defaults to "Taxonomy".
   * @maxLength 64
   * @example "Part Classification"
   */
  name?: string;
  /**
   * When true, newly indexed assets will be auto-labeled into this taxonomy.
   * Defaults to false — auto-labeling is opt-in.
   */
  autoLabelOptedIn?: boolean;
}

export interface UpdateTaxonomyResponse {
  taxonomy: Taxonomy;
}

export interface UpdateTaxonomyRequest {
  /**
   * New display name for the taxonomy. Leading/trailing whitespace is trimmed; blank
   * names are rejected.
   * @maxLength 64
   * @example "Part Classification"
   */
  name?: string;
  /** Whether newly indexed assets should be auto-labeled into this taxonomy. */
  autoLabelOptedIn?: boolean;
}

export interface ListTaxonomiesResponse {
  taxonomies: Taxonomy[];
}

export interface GetTaxonomyResponse {
  taxonomy: Taxonomy;
}

export interface StartAutoLabelLibraryResponse {
  jobId: string;
  status: JobStatus;
}

export interface AutoLabelLibraryRequest {
  /**
   * When true (default), assets that already have an AI-generated label are skipped —
   * only unlabeled assets get classified. Set to false to force re-classification of
   * every asset that doesn't have a user-assigned label.
   */
  skipAutoLabeled?: boolean;
}

export interface AutoLabelLibraryJobView {
  id: string;
  status: JobStatus;
  /** @format double */
  progress: number;
  /** @format double */
  queuedCount: number;
  /** @format double */
  skippedCount: number;
  /** @format double */
  completedCount: number;
}

export interface GetActiveAutoLabelLibraryJobResponse {
  /**
   * The currently active (PENDING or RUNNING) auto-label library job for the tenant,
   * or undefined if no job is currently in flight.
   */
  job?: AutoLabelLibraryJobView;
}

export interface GetAutoLabelLibraryJobResponse {
  job: AutoLabelLibraryJobView;
}

export interface DailyHealthSummary {
  date: string;
  status: DailyHealthStatus;
  incidentDescription?: string;
  /**
   * 0.0 to 1.0. Absent on a NoData day.
   * @format double
   */
  availability?: number;
}

export interface PlatformHealth {
  /**
   * Mean availability across the scored days. Absent when nothing in the window was scored.
   * @format double
   */
  overallAvailability?: number;
  dailyTimeline: DailyHealthSummary[];
  /**
   * Pass rate of the full canary suite. Absent when nothing in the window was scored.
   * @format double
   */
  apiChecksPassed?: number;
  /**
   * Pass rate of the core-ops subset, which carries the search and upload checks.
   * @format double
   */
  searchChecksPassed?: number;
  /**
   * Days in the window that carry a canary score. Zero means the source has nothing for this stack.
   * @format double
   */
  scoredDays: number;
}

export interface SystemHealthResponse {
  platform: PlatformHealth;
}

export interface SceneMatchRunResponse {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  runId: UUID;
  /**
   * The v3-side ledger of one match question. `runKey` is content-addressed over everything that
   * changes the answer, and a question has one row: asking it again finds that row. Two different part
   * sets against one scene are two questions, and both may run at once.
   */
  status: SceneMatchRunStatus;
  runKey: string;
  envelopeKey?: string;
  canonicalSha256?: string;
  /** @format double */
  nPlaced?: number;
  regime?: string;
  /** @format date-time */
  dispatchedAt: string;
  /** @format date-time */
  completedAt?: string;
  failureReason?: string;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringNumber = Record<string, number>;

export interface CreateSceneMatchRunRequest {
  /**
   * The part assets to match the scene against, in the order the auction should walk them. The order
   * is part of the run's identity: matching pursuit compounds the first difference through every
   * later round, so the same parts in a different order is a different question.
   */
  partAssetIds: UUID[];
  preset?: string;
  /** @format double */
  sceneUnits?: number;
  /** Construct a type with a set of properties K of type T */
  assetUnits?: RecordStringNumber;
}

export type MetadataValue = string | number | boolean;

export interface NumericFilter {
  /** @format double */
  lte?: number;
  /** @format double */
  lt?: number;
  /** @format double */
  gte?: number;
  /** @format double */
  gt?: number;
}

export type MetadataFilterValue = MetadataValue | NumericFilter | string[];

/** Construct a type with a set of properties K of type T */
export type RecordStringMetadataFilterValue = Record<
  string,
  MetadataFilterValue
>;

export interface Creator {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  email: string;
}

export interface Report {
  id: string;
  tenantId: string;
  status: JobStatus;
  /** @format double */
  progress: number;
  reportType: ReportType;
  name?: string;
  /** @format double */
  minThreshold: number;
  /** @format double */
  maxThreshold: number;
  searchQuery?: string;
  /** Construct a type with a set of properties K of type T */
  metadataFilters?: RecordStringMetadataFilterValue;
  folderPaths?: string[];
  folderIds?: string[];
  includeHomeFolderAssets?: boolean;
  excludedFolderIds?: string[];
  extensions?: string[];
  creator?: Creator;
  excludeAssemblies?: boolean;
  excludeExactDuplicates?: boolean;
  modelIndexConfigId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format double */
  groupCount: number;
}

export interface CreateReportResponse {
  report: Report;
}

export interface CreateDuplicationReportRequest {
  /**
   * The name of the duplication report
   * @example "Monthly Duplicates Report"
   */
  name?: string;
  /**
   * The minimum threshold for similarity detection
   * @format double
   * @min 0
   * @max 100
   * @example 70
   */
  minThreshold: number;
  /**
   * The maximum threshold for similarity detection
   * @format double
   * @min 0
   * @max 100
   * @example 90
   */
  maxThreshold: number;
  /**
   * Text search query to filter the results
   * @example "gear"
   */
  searchQuery?: string;
  /** Metadata filters to apply to the search */
  metadataFilters?: RecordStringMetadataFilterValue;
  /**
   * (Deprecated) Folder paths to include in the search. Use folderIds instead. When folderIds or includeHomeFolderAssets is set, folderPaths is ignored.
   * @example ["/engineering/mechanical"]
   */
  folderPaths?: string[];
  /**
   * Folder IDs to include in the search. Includes assets in subfolders, except those under excludedFolderIds. Takes precedence over folderPaths.
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  folderIds?: string[];
  /**
   * Whether to include assets in the home (root) folder that have no folder assignment
   * @default false
   */
  includeHomeFolderAssets?: boolean;
  /**
   * Subfolders of folderIds to leave out, along with their own subfolders. A folder listed in folderIds inside an excluded folder is included again.
   * @example ["550e8400-e29b-41d4-a716-446655440001"]
   */
  excludedFolderIds?: string[];
  /**
   * File extensions to include in the search
   * @example [".step",".stl"]
   */
  extensions?: string[];
  /**
   * Whether to exclude assembly assets from the generated report groups
   * @default false
   */
  excludeAssemblies?: boolean;
  /**
   * Whether to exclude exact duplicate matches (100% match with same file name) from the generated report groups
   * @default false
   */
  excludeExactDuplicates?: boolean;
}

export interface CreateSimplificationReportRequest {
  /**
   * The name of the simplification report
   * @example "Weekly Simplification Report"
   */
  name?: string;
  /**
   * The minimum threshold for simplification detection
   * @format double
   * @min 0
   * @max 100
   * @example 70
   */
  minThreshold: number;
  /**
   * The maximum threshold for simplification detection
   * @format double
   * @min 0
   * @max 100
   * @example 90
   */
  maxThreshold: number;
  /**
   * Text search query to filter the results
   * @example "simplified"
   */
  searchQuery?: string;
  /** Metadata filters to apply to the search */
  metadataFilters?: RecordStringMetadataFilterValue;
  /**
   * Folder paths to include in the search
   * @example ["/engineering/simplified"]
   */
  folderPaths?: string[];
  /**
   * Folder IDs to include in the search. Includes assets in subfolders, except those under excludedFolderIds. Takes precedence over folderPaths.
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  folderIds?: string[];
  /**
   * Whether to include assets in the home (root) folder that have no folder assignment
   * @default false
   */
  includeHomeFolderAssets?: boolean;
  /**
   * Subfolders of folderIds to leave out, along with their own subfolders. A folder listed in folderIds inside an excluded folder is included again.
   * @example ["550e8400-e29b-41d4-a716-446655440001"]
   */
  excludedFolderIds?: string[];
  /**
   * File extensions to include in the search
   * @example [".step",".stl"]
   */
  extensions?: string[];
  /**
   * Whether to exclude assembly assets from the generated report groups
   * @default false
   */
  excludeAssemblies?: boolean;
  /**
   * Whether to exclude exact duplicate matches (100% match with same file name) from the generated report groups
   * @default false
   */
  excludeExactDuplicates?: boolean;
}

export interface CreateCustomReportRequest {
  /**
   * The name of the custom report
   * @example "Custom Analysis Report"
   */
  name?: string;
  /**
   * The minimum threshold for the analysis
   * @format double
   * @min 0
   * @max 100
   * @example 50
   */
  minThreshold: number;
  /**
   * The maximum threshold for the analysis
   * @format double
   * @min 0
   * @max 100
   * @example 95
   */
  maxThreshold: number;
  /**
   * Text search query to filter the results
   * @example "custom filter"
   */
  searchQuery?: string;
  /** Metadata filters to apply to the search */
  metadataFilters?: RecordStringMetadataFilterValue;
  /**
   * Folder paths to include in the search
   * @example ["/custom/analysis"]
   */
  folderPaths?: string[];
  /**
   * Folder IDs to include in the search. Includes assets in subfolders, except those under excludedFolderIds. Takes precedence over folderPaths.
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  folderIds?: string[];
  /**
   * Whether to include assets in the home (root) folder that have no folder assignment
   * @default false
   */
  includeHomeFolderAssets?: boolean;
  /**
   * Subfolders of folderIds to leave out, along with their own subfolders. A folder listed in folderIds inside an excluded folder is included again.
   * @example ["550e8400-e29b-41d4-a716-446655440001"]
   */
  excludedFolderIds?: string[];
  /**
   * File extensions to include in the search
   * @example [".step",".stl",".iges"]
   */
  extensions?: string[];
  /**
   * Whether to exclude assembly assets from the generated report groups
   * @default false
   */
  excludeAssemblies?: boolean;
  /**
   * Whether to exclude exact duplicate matches (100% match with same file name) from the generated report groups
   * @default false
   */
  excludeExactDuplicates?: boolean;
}

export interface ListReportsResponse {
  reports: Report[];
  pageData: PageData;
}

export interface GetReportResponse {
  report: Report;
}

export interface FailureDiagnosticsResponse {
  /**
   * `found` when a matching failure log entry was located, `not-found` when the record is not
   * failed or the entry has aged out of log retention, `unavailable` when log search is not
   * configured for this environment.
   */
  status: "found" | "not-found" | "unavailable";
  /**
   * `user` for a failure the requester can act on, carrying a customer-facing `summary`.
   * `internal` for a failure on our side: `summary` is a fixed string and the `traceId` is
   * the actionable part. Mirrors how error-middleware treats 4xx versus 500.
   */
  kind?: "user" | "internal";
  summary?: string;
  traceId?: string;
  /** @format date-time */
  occurredAt?: string;
}

export interface UpdateReportResponse {
  report: Report;
}

export interface UpdateReportRequest {
  /**
   * The new name for the report
   * @example "Q4 Duplicates Review"
   */
  name: string;
}

export interface ReportGroup {
  id: string;
  reportId: string;
  groupId: string;
  name?: string;
  tenantId: string;
  assetIds: string[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ListReportGroupsResponse {
  groups: ReportGroup[];
  pageData: PageData;
}

export interface CreateReportGroupResponse {
  group: ReportGroup;
}

export interface CreateReportGroupRequest {
  /**
   * The name for the group
   * @example "Similar Gears"
   */
  name?: string;
}

export interface UpdateReportGroupResponse {
  group: ReportGroup;
}

export interface UpdateReportGroupRequest {
  /**
   * The new name for the group
   * @example "Similar Gears"
   */
  name: string;
}

export interface FilterDataPointMetadataValue {
  filter: MetadataValue;
  /** @format double */
  count: number;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringFilterDataPointMetadataValueArray = Record<
  string,
  FilterDataPointMetadataValue[]
>;

export type FilterMetadata = RecordStringFilterDataPointMetadataValueArray;

export interface GetReportGroupFiltersResponse {
  filterData: {
    metadata: FilterMetadata;
  };
}

/** Construct a type with a set of properties K of type T */
export type RecordStringMetadataValue = Record<string, MetadataValue>;

export interface AssetLabelSummary {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  taxonomyNodeId: UUID;
  name: string;
  /** @format double */
  depth: number;
  source?: LabelSource;
  /** @format double */
  confidence?: number;
}

export interface AssetLabel {
  status: LabelingStatus;
  summary?: AssetLabelSummary;
}

export interface Asset {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  folderId?: UUID;
  path: string;
  type: AssetType;
  /** Construct a type with a set of properties K of type T */
  metadata: RecordStringMetadataValue;
  state: AssetState;
  isMissingDependencies?: boolean;
  hasDependencies?: boolean;
  hasSupplementalAssets?: boolean;
  isAssembly?: boolean;
  isRootAssembly?: boolean;
  creator?: Creator;
  label?: AssetLabel;
  semanticDescription?: string;
}

export interface AssetMatchResponse {
  /** @format double */
  matchPercentage: number;
  asset: Asset;
}

export interface ListReportGroupAssetsResponse {
  assets: (Asset & {
    matches: AssetMatchResponse[];
  })[];
  pageData: PageData;
}

export interface AddAssetToGroupRequest {
  /**
   * The ID of the asset to add to the group
   * @example "550e8400-e29b-41d4-a716-446655440001"
   */
  assetId: string;
}

export interface PartImageReadText {
  kind: string;
  text: string;
}

export interface PartImageLabelFieldReading {
  value: string;
  confidence: "high" | "medium" | "low";
}

export interface PartImageLabelFieldReadings {
  nsn?: PartImageLabelFieldReading;
  partNumber?: PartImageLabelFieldReading;
  cage?: PartImageLabelFieldReading;
  manufacturer?: PartImageLabelFieldReading;
  serial?: PartImageLabelFieldReading;
  contract?: PartImageLabelFieldReading;
  lotDate?: PartImageLabelFieldReading;
}

export interface PartImageLabelChecks {
  nsnFormat?: boolean;
  nsnInFlis?: boolean;
  cageInFlis?: boolean;
  partNumberWithCageInFlis?: boolean;
}

export interface PartImageLabelEvidence {
  /**
   * Zero-based index of the label's crop, served at `labels/{index}.jpg`.
   * @format double
   */
  index: number;
  /**
   * The photo the label is on, numbered from 1.
   * @format double
   */
  photoNumber: number;
  kind: "label" | "nameplate" | "stamping";
  readable: boolean;
  fields: PartImageLabelFieldReadings;
  checks: PartImageLabelChecks;
}

export interface PartImagePendingLabel {
  /**
   * The photo the label is on, numbered from 1.
   * @format double
   */
  photoNumber: number;
  kind: "label" | "nameplate" | "stamping";
}

export interface PartImageCandidate {
  niin: string;
  nsn: string;
  itemName?: string;
  partNumber: string;
  /** @format double */
  score: number;
  evidenceTier: PartImageEvidenceTier;
  reasons: string[];
  /** Found by narrowing on the user's measurements, rather than one of the photo search's own candidates. */
  measured?: boolean;
}

export interface PartImageItemRegion {
  /**
   * The photo the item is in, numbered from 1.
   * @format double
   */
  photoNumber: number;
  /**
   * Box around the item as fractions from 0 to 1 of the photo's width and height, from its top-left corner.
   * @format double
   */
  left: number;
  /** @format double */
  top: number;
  /** @format double */
  width: number;
  /** @format double */
  height: number;
  /** The user fitted this box to the photo's segments. It is not snapped again. */
  fitted?: boolean;
}

export interface PartImageItem {
  /** The photos the item is in, numbered from 1. */
  photoNumbers: number[];
  regions: PartImageItemRegion[];
  description: string;
  readText: PartImageReadText[];
  candidates: PartImageCandidate[];
  /** The candidate that wins clearly on an identifier read from this item's photos, if one does. */
  suggestedNiin?: string;
  /** Made by merging other items. Unmerging puts them back as they were. */
  merged: boolean;
  /** A new crop was saved and is being read again. Candidates are from before the crop until it finishes. */
  readingCrop: boolean;
  /** The last crop could not be read. The item keeps its earlier reading. */
  cropFailed: boolean;
}

export interface PartImageItemOverLimit {
  photoNumbers: number[];
  description: string;
}

export interface PartImageIdentification {
  id: string;
  /** @format date-time */
  createdAt: string;
  status: JobStatus;
  /**
   * How far a running identification has got. Each stage saves what it found, so the description and what was
   * read appear once the photos are read, and the labels once they are zoomed into.
   */
  stage: PartImageIdentificationStage;
  outcome?: PartImageIdentificationOutcome;
  /** @format double */
  imageCount: number;
  description?: string;
  readText: PartImageReadText[];
  labels: PartImageLabelEvidence[];
  /** Labels the photos showed that are still being re-read at full resolution. */
  pendingLabels: PartImagePendingLabel[];
  candidates: PartImageCandidate[];
  /** The distinct items found when the photos show more than one part. Empty for a single part. */
  items: PartImageItem[];
  /**
   * Everything in the photos searched as one part, such as a whole kit. Only set alongside items, when the search
   * split the photos into parts.
   */
  wholePhoto?: PartImageItem;
  /** Items found beyond the per-search limit. They were not searched. */
  itemsOverLimit: PartImageItemOverLimit[];
  reportId?: string;
  batchId?: string;
  failureReason?: string;
}

export interface PartImageIdentificationResponse {
  partImageIdentification: PartImageIdentification;
}

export interface EndItemReferenceEvidence {
  sourceColumn: "end_item_name";
  matchKind: EndItemMatchKind;
  matchedToken: string;
}

export interface EndItemReference {
  nsn: string;
  itemName?: string;
  endItemName: string;
  evidence: EndItemReferenceEvidence[];
}

export interface EndItemReferences {
  status: "found" | "unavailable";
  truncated: boolean;
  matches: EndItemReference[];
}

export interface NsnManufacturer {
  partNumber: string;
  cageCode: string;
  cageStatus: string;
  cageType: string;
  company: string;
}

export interface NsnAlternatePartNumber {
  partNumber: string;
  cageCode: string;
  company: string;
}

export interface NsnAcquisitionRecord {
  contractNumber: string;
  deliveryOrder?: string;
  awardeeCageCode: string;
  awardeeCompany: string;
  awardDate?: string;
  /** @format double */
  quantity?: number;
  /** @format double */
  unitPrice?: number;
  /** @format double */
  totalPrice?: number;
  /** @format double */
  offers?: number;
  foreignMilitarySaleCountry?: string;
}

export interface NsnAcquisitionRecords {
  /** @format double */
  total: number;
  records: NsnAcquisitionRecord[];
}

export interface NsnPhraseLink {
  relation: FlisPhraseRelation;
  nsn: string;
  itemName?: string;
  /** @format double */
  quantity?: number;
  phraseStatement: string;
}

export interface NsnReport {
  nsn: string;
  description?: string;
  endItemDescription?: string;
  endItemReferences?: EndItemReferences;
  assignDate?: string;
  /** @format double */
  managementPrice?: number;
  agencyUsage: string[];
  technicalCharacteristics: {
    value: string;
    key: string;
    mrc: string;
  }[];
  criticality: string;
  manufacturers: NsnManufacturer[];
  nsnNowAlternates?: NsnAlternatePartNumber[];
  acquisitionRecords?: NsnAcquisitionRecords;
  supersedes?: string[];
  phraseLinks?: NsnPhraseLink[];
  searchedNsn?: string;
}

export interface SupplierAddress {
  street?: string;
  city?: string;
  stateProvince?: string;
  postalCode?: string;
  country?: string;
}

export interface SupplierContact {
  name?: string;
  email?: string;
  phone?: string;
  title?: string;
}

export interface SourcingOpportunity {
  id: string;
  tenantId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  partFinderReportId: string;
  partIdentifier: string;
  partIdentifierType: PartIdentifierType;
  supplier: string;
  provenance: SourcingProvenance;
  url?: string;
  supplierType?: SupplierType;
  partNumber?: string;
  /** @format double */
  price?: number | null;
  availability?: string;
  /** @format double */
  confidenceScore?: number;
  reasoning?: string;
  matchedOn?: string[];
  cageCode?: string;
  conditionCode?: string;
  /** @format double */
  quantityAvailable?: number;
  accreditedVendorLevel?: string;
  isPreferredVendor?: boolean;
  supplierAddress?: SupplierAddress;
  rfqContact?: SupplierContact;
}

export interface PartFinderReportImageInfo {
  /** @format double */
  index: number;
  matchType: ThumbnailMatchType;
  kind: PartFinderImageKind;
}

export interface DocumentLead {
  url: string;
  title: string;
  docType: DocumentType;
  matchedPartNumber: string;
  provenance: DocumentProvenance;
  evidenceQuote?: string;
  evidenceQuoteVerified?: boolean;
  section?: string;
  distributionStatement?: string;
  supersededBy?: string;
  pdfUrl?: string;
  hasHostedPdf?: boolean;
  hasPreview?: boolean;
}

export interface IlsSearchSummary {
  term: string;
  failed: boolean;
  /** @format double */
  supplierCount: number;
}

export interface PartFinderReport {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  tenantId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: JobStatus;
  /** @format double */
  progress: number;
  partNumber: string;
  niin?: string;
  description?: string;
  batchId?: string;
  /** The image search this report was created from, if any. */
  imageIdentificationId?: string;
  creator?: Creator;
  nsnReport?: NsnReport;
  /** The user chose to skip FLIS and search by the part number alone. */
  partNumberOnly?: boolean;
  sourcingOpportunities?: SourcingOpportunity[];
  finalRecommendation?: string;
  aiSuggestedRecommendation?: string;
  hasThumbnail: boolean;
  thumbnailMatchType?: ThumbnailMatchType;
  thumbnailKind?: PartFinderImageKind;
  images?: PartFinderReportImageInfo[];
  documents?: DocumentLead[];
  ilsSearch?: IlsSearchSummary;
  /**
   * When the worker began generating the report. Reset on every rerun.
   * @format date-time
   */
  startedAt?: string;
  /**
   * When the worker stopped generating the report, whether it succeeded or failed.
   * @format date-time
   */
  completedAt?: string;
}

export interface CreateReportFromPartImageCandidateResponse {
  partFinderReport: PartFinderReport;
}

export interface CreateReportFromPartImageCandidateRequest {
  niin: string;
}

export interface MergePartImageItemsRequest {
  itemIndices: number[];
}

export interface PartImageItemBox {
  /** @format double */
  left: number;
  /** @format double */
  top: number;
  /** @format double */
  width: number;
  /** @format double */
  height: number;
}

export interface CropPartImageItemRequest {
  /**
   * The photo the crop is on, counted from 1.
   * @format int32
   * @min 1
   */
  photoNumber: number;
  /** The item's new box on that photo, as fractions of the photo. */
  box: PartImageItemBox;
}

export interface CreateBatchFromPartImageItemsResponse {
  partFinderBatchId: string;
}

export interface PartImageItemSelection {
  /** @format double */
  itemIndex: number;
  niin: string;
  /**
   * The item's box on its first photo as the browser tightened it, as fractions of the photo. Used for the
   * report's thumbnail in place of the model's box.
   */
  box?: PartImageItemBox;
}

export interface CreateBatchFromPartImageItemsRequest {
  selections: PartImageItemSelection[];
  /** A candidate of the whole photo, searched as one part. Adds one more report to the batch. */
  wholePhotoNiin?: string;
}

export interface PartImageItemTypeOption {
  itemName: string;
  federalSupplyClass: string;
}

export interface PartImageCharacteristicQuestion {
  code: string;
  label: string;
  kind: "dimension" | "text";
  options: string[];
}

export interface PartImageCharacteristicQuestions {
  itemName?: string;
  federalSupplyClass?: string;
  itemTypes: PartImageItemTypeOption[];
  /** @format double */
  familySize: number;
  questions: PartImageCharacteristicQuestion[];
}

export interface PartImageCharacteristicQuestionsResponse {
  characteristicQuestions: PartImageCharacteristicQuestions;
}

export interface FlisItemTypeCount {
  itemName: string;
  federalSupplyClass: string;
  /** @format double */
  partCount: number;
}

export interface PartImageItemTypesResponse {
  itemTypes: FlisItemTypeCount[];
}

export interface NarrowPartImageCandidatesResponse {
  /** @format double */
  total: number;
  candidates: PartImageCandidate[];
}

export interface PartImageDimensionAnswer {
  code: string;
  /** @format double */
  inches: number;
}

export interface PartImageTextAnswer {
  code: string;
  contains: string;
}

export interface PartImageTolerance {
  /** @format double */
  percent: number;
  /** @format double */
  minInches: number;
}

export interface NarrowPartImageCandidatesRequest {
  itemName?: string;
  federalSupplyClass?: string;
  dimensions: PartImageDimensionAnswer[];
  texts: PartImageTextAnswer[];
  tolerance?: PartImageTolerance;
  /**
   * Narrows one item of a search that found several. Leave out to narrow the search as a whole.
   * @format int32
   * @min 0
   */
  itemIndex?: number;
  /** Narrows the whole photo, searched as one part beside its items. */
  wholePhoto?: boolean;
}

export interface PartRelationshipNode {
  id: string;
  type: PartRelationshipNodeType;
  label: string;
  subtitle?: string;
  reportId?: string;
  hasThumbnail?: boolean;
  thumbnailMatchType?: ThumbnailMatchType;
  thumbnailKind?: PartFinderImageKind;
  sourcingOpportunityId?: string;
  url?: string;
}

export interface PartRelationshipEvidence {
  kind: PartRelationshipEvidenceKind;
  source: string;
  /** @format double */
  confidence: number;
  matchedOn?: string[];
}

export interface PartRelationshipEdge {
  id: string;
  type: PartRelationshipEdgeType;
  sourceNodeId: string;
  targetNodeId: string;
  evidence: PartRelationshipEvidence;
}

export interface PartRelationshipGraphCaps {
  /** @format double */
  maxNodes: number;
  /** @format double */
  maxEdges: number;
}

export interface PartRelationshipComponents {
  /** @format double */
  total: number;
  /** @format double */
  shown: number;
}

export interface PartRelationshipGraph {
  seedNodeId: string;
  nodes: PartRelationshipNode[];
  edges: PartRelationshipEdge[];
  truncated: boolean;
  caps: PartRelationshipGraphCaps;
  components: PartRelationshipComponents;
}

export interface GetPartFinderReportRelationshipsResponse {
  partRelationshipGraph: PartRelationshipGraph;
}

export interface CreatePartFinderReportResponse {
  partFinderReport: PartFinderReport;
}

export interface CreatePartFinderReportRequest {
  /**
   * The part number to search for: an NSN, a NIIN, or any manufacturer part number.
   * Punctuation and case are ignored when matching FLIS.
   * @example "1234-12-345-6789"
   */
  partNumber: string;
  /**
   * The NIIN to use when the part number matches more than one NSN in FLIS.
   * @example "011728001"
   */
  niin?: string;
  /** Skip FLIS and search ILS and the web by the part number alone. */
  partNumberOnly?: boolean;
  /**
   * Description of the part to search for.
   * @example "Hydraulic pump assembly"
   */
  description?: string;
}

export interface CandidateCharacteristic {
  label: string;
  value: string;
}

export interface NsnCandidate {
  nsn: string;
  niin: string;
  itemName?: string;
  endItemName?: string;
  cageCode: string;
  companyName?: string;
  unitOfIssue?: string;
  /** @format double */
  unitPrice?: number;
  /** Up to two characteristics that differ between the candidates, to tell this NSN apart. */
  distinguishingCharacteristics: CandidateCharacteristic[];
}

export interface ListNsnCandidatesResponse {
  /** FLIS NSNs whose part numbers match the given part number. Empty when the input is an NSN or NIIN. */
  nsnCandidates: NsnCandidate[];
  /** Characteristics every candidate has in common. */
  sharedCharacteristics: CandidateCharacteristic[];
}

export interface ListPartFinderReportsResponse {
  partFinderReports: PartFinderReport[];
  pageData: PageData;
}

export interface GetPartFinderReportResponse {
  partFinderReport: PartFinderReport;
}

export interface UpdatePartFinderReportRecommendationResponse {
  partFinderReport: PartFinderReport;
}

export interface UpdatePartFinderReportRecommendationRequest {
  /**
   * The user-authored final recommendation. Must be non-empty after trimming;
   * use `DELETE /…/final-recommendation` to clear an existing value.
   * @minLength 1
   * @maxLength 8000
   * @example "Recommend sourcing from Acme (CAGE 1ABC2) — lead time 3 wks, fully in-spec."
   */
  finalRecommendation: string;
}

export interface RetryPartFinderReportResponse {
  partFinderReport: PartFinderReport;
}

export interface CancelPartFinderReportResponse {
  partFinderReport: PartFinderReport;
}

export interface UpdatePartFinderReportDescriptionResponse {
  partFinderReport: PartFinderReport;
}

export interface UpdatePartFinderReportDescriptionRequest {
  /**
   * The part description. Must be non-empty after trimming;
   * use `DELETE /…/description` to clear an existing value.
   * @minLength 1
   * @maxLength 1000
   * @example "Hydraulic pump assembly"
   */
  description: string;
}

export interface PartFinderFeedback {
  id: string;
  reportId: string;
  targetType: PartFinderFeedbackTargetType;
  targetId: string;
  rating: PartFinderFeedbackRating;
  note?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ListPartFinderFeedbackResponse {
  feedback: PartFinderFeedback[];
}

export interface PartFinderFeedbackResponse {
  feedback: PartFinderFeedback;
}

export interface SetPartFinderFeedbackRequest {
  /** The reviewer's rating of the AI output (recommendation or sourcing opportunity). */
  rating: PartFinderFeedbackRating;
  /**
   * Optional free-text note explaining the rating.
   * @maxLength 2000
   */
  note?: string;
}

export interface ExportPartFinderReportsRequest {
  /**
   * IDs of individually selected reports to include in the export.
   * @maxItems 1000
   */
  reportIds?: UUID[];
  /**
   * IDs of selected batches; every child report of each batch is included in the export.
   * @maxItems 1000
   */
  batchIds?: UUID[];
}

export interface PartFinderBatchChildBreakdown {
  /** @format double */
  total: number;
  /** @format double */
  completed: number;
  /** @format double */
  running: number;
  /** @format double */
  pending: number;
  /** @format double */
  failed: number;
  /** @format double */
  cancelled: number;
}

export interface PartFinderBatch {
  id: string;
  tenantId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  cancelledAt?: string;
  status: JobStatus;
  /** @format double */
  progress: number;
  inputMethod: PartFinderBatchInputMethod;
  name?: string;
  sourceFilename?: string;
  creator?: Creator;
  breakdown: PartFinderBatchChildBreakdown;
}

export interface InvalidPartFinderBatchEntry {
  partNumber: string;
  reason: string;
}

export interface CreatePartFinderBatchResponse {
  partFinderBatch: PartFinderBatch;
  /** @format double */
  duplicatesRemoved: number;
  /** Submitted part numbers that failed validation and were not added to the batch, such as a NIIN the part number doesn't map to. */
  invalidEntries: InvalidPartFinderBatchEntry[];
}

export interface CreatePartFinderBatchEntry {
  /**
   * @minLength 1
   * @maxLength 64
   */
  partNumber: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
  /**
   * The NSN to use when the part number matches several in FLIS. Without it, the lowest NIIN is used.
   * @pattern ^\d{9}$
   */
  niin?: string;
  /** Skip FLIS and search ILS and the web by the part number alone. */
  partNumberOnly?: boolean;
}

export interface CreatePartFinderBatchRequest {
  /**
   * Part numbers to process, optionally with per-row descriptions and NIINs. Duplicates by part number and NIIN are removed.
   * @maxItems 1000
   * @minItems 1
   */
  entries: CreatePartFinderBatchEntry[];
  inputMethod?: PartFinderBatchInputMethod;
  /**
   * Optional human-readable name for the batch, shown in the activity feed and batch detail.
   * @maxLength 512
   */
  name?: string;
  /** @maxLength 512 */
  sourceFilename?: string;
}

export interface UpdatePartFinderBatchNameResponse {
  partFinderBatch: PartFinderBatch;
}

export interface UpdatePartFinderBatchNameRequest {
  /**
   * The batch name. Must be non-empty after trimming.
   * @minLength 1
   * @maxLength 512
   * @example "Q2 hydraulics sourcing"
   */
  name: string;
}

export interface ListPartFinderBatchesResponse {
  partFinderBatches: PartFinderBatch[];
  pageData: PageData;
}

export interface GetPartFinderBatchResponse {
  partFinderBatch: PartFinderBatch;
}

export type PartFinderActivityEntry =
  | {
      report: PartFinderReport;
      type: "report";
    }
  | {
      batch: PartFinderBatch;
      type: "batch";
    };

export interface ListPartFinderActivityResponse {
  activity: PartFinderActivityEntry[];
  pageData: PageData;
}

export interface MetadataField {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  type: MetadataFieldType;
  creator?: Creator;
}

export interface CreateMetadataFieldResponse {
  metadataField: MetadataField;
}

/**
 * Metadata field name with API validation constraints.
 * @minLength 1
 * @maxLength 255
 */
export type MetadataFieldName = string;

export interface CreateMetadataFieldRequest {
  /** The name of the metadata field. The name must be unique. */
  name: MetadataFieldName;
  /** The type of the metadata field. */
  type: MetadataFieldType;
}

export interface ListMetadataFieldsResponse {
  metadataFields: MetadataField[];
  pageData: PageData;
}

export interface GetMetadataFieldResponse {
  metadataField: MetadataField;
}

export interface UpdateMetadataFieldRequest {
  /** The name used to update the metadata field. The name must be unique. */
  name: MetadataFieldName;
}

export interface ListAssetsUsingMetadataFieldResponse {
  assets: Asset[];
  pageData: PageData;
}

export interface GetLabelResponse {
  label: Label;
}

export interface AssignLabelResponse {
  label: Label;
}

export interface AssignLabelRequest {
  /** The ID of the taxonomy node to assign the asset to. */
  taxonomyNodeId: UUID;
}

export interface Folder {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  description?: string;
  /** The ID of the parent folder or undefined for root folders. */
  parentFolderId?: UUID;
  /**
   * Number of assets in this folder
   * @format double
   */
  assetsCount: number;
  /**
   * Number of subfolders in this folder
   * @format double
   */
  foldersCount: number;
  /**
   * Number of indexing assets in this folder
   * @format double
   */
  indexingCount: number;
  creator?: Creator;
}

/** Response for creating a folder */
export interface CreateFolderResponse {
  /** The created folder */
  folder: Folder;
}

/** Request for creating a folder */
export interface CreateFolderRequest {
  /**
   * The name of the folder.
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * An optional description for the folder.
   * @maxLength 255
   */
  description?: string;
  /** The ID of the parent folder when creating a subfolder. Not required for root folders. */
  parentFolderId?: UUID;
}

/** Response for listing folders */
export interface ListFoldersResponse {
  /** The list of folders */
  folders: Folder[];
  /** Pagination information */
  pageData: PageData;
}

/** Response for getting a folder */
export interface GetFolderResponse {
  /** The requested folder */
  folder: Folder;
}

/** Response for renaming a folder */
export interface RenameFolderResponse {
  /** The renamed folder */
  folder: Folder;
}

/** Request for renaming a folder */
export interface RenameFolderRequest {
  /**
   * The new name for the folder.
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

/** Response for moving a folder */
export interface MoveFolderResponse {
  /** The moved folder */
  folder: Folder;
}

/** Request for moving a folder */
export interface MoveFolderRequest {
  /** The ID of the new parent folder, or null to move to root. */
  parentFolderId: UUID | null;
}

/** Response for updating a folder's description */
export interface UpdateFolderDescriptionResponse {
  /** The updated folder */
  folder: Folder;
}

/** Request for updating a folder's description */
export interface UpdateFolderDescriptionRequest {
  /**
   * The description for the folder. Must not be empty. Use DELETE to remove a description.
   * @minLength 1
   * @maxLength 255
   */
  description: string;
}

/** Response for deleting a folder's description */
export interface DeleteFolderDescriptionResponse {
  /** The updated folder */
  folder: Folder;
}

/** Response for getting folder filters */
export interface GetFolderFiltersResponse {
  /** Filter data including metadata fields available in the folder */
  filterData: {
    /** Available metadata field values with counts */
    metadata: FilterMetadata;
  };
}

/** Response for getting metadata field names with data in a folder */
export interface GetMetadataFieldsWithDataResponse {
  /** Names of metadata fields that have at least one value in this folder */
  metadataFieldNames: string[];
}

/** Response for checking if subfolders have descriptions */
export interface HasSubfolderDescriptionsResponse {
  /** Whether any subfolders in this scope have a description set */
  hasDescriptions: boolean;
}

export interface LabelOption {
  name: string;
  /** @format double */
  depth: number;
  /** @format double */
  count: number;
}

/** Response for getting label options available in a folder */
export interface FolderLabelOptionsResponse {
  /** Distinct labels applied to assets in this folder, with depth for color rendering */
  labels: LabelOption[];
}

/** Combined response for column-visibility signals used by the assets table */
export interface FolderColumnVisibilityResponse {
  /** Whether any subfolders in this scope have a description set */
  hasDescriptions: boolean;
  /** Distinct labels applied to assets in this folder, with depth for color rendering */
  labels: LabelOption[];
  /** Names of metadata fields that have at least one value in this folder */
  metadataFieldNames: string[];
}

export type FolderContent =
  | (Folder & {
      contentType: "folder";
    })
  | (Asset & {
      contentType: "asset";
    });

/** Response for listing folder contents */
export interface ListFolderContentsResponse {
  /** The list of folder contents */
  contents: FolderContent[];
  /** Pagination information */
  pageData: PageData;
}

export interface FlisRecordResult {
  /**
   * 9-digit National Item Identification Number.
   * @example "015253989"
   */
  niin: string;
  /**
   * National Stock Number, formatted `FSC-NN-NNN-NNNN`.
   * @example "5985-01-525-3989"
   */
  nsn: string;
  /**
   * Item name (military nomenclature).
   * @example "ANTENNA,OMNIDIRECTIONAL"
   */
  itemName?: string;
}

export interface SearchFlisRecordsResponse {
  flisRecords: FlisRecordResult[];
}

/** Construct a type with a set of properties K of type T */
export type RecordStringBoolean = Record<string, boolean>;

export interface LastRemediationAttempt {
  /**
   * When the failure was last sent through self-service.
   * @format date-time
   */
  attemptedAt: string;
  /** Who requested it. Omitted when the user no longer exists. */
  requestedByEmail?: string;
  /**
   * How many failures that request re-queued.
   * @format double
   */
  batchSize: number;
}

export interface RecentFailureItem {
  /** Which surface the failure came from, so the caller can link and diagnose accordingly. */
  kind: "asset" | "report" | "part-finder-report";
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  name: string;
  /**
   * When the record last changed. Nothing persists the moment of failure, so this is the
   * closest available signal and is used consistently across every kind.
   * @format date-time
   */
  failedAt: string;
  /** Present when the record failed again after a self-service attempt. */
  lastAttempt?: LastRemediationAttempt;
}

export interface ListRecentFailuresResponse {
  failures: RecentFailureItem[];
  /** Totals for the whole tenant, not just this page. */
  countsByKind: {
    /** @format double */
    "part-finder-report": number;
    /** @format double */
    report: number;
    /** @format double */
    asset: number;
  };
  /** When the newest failure of each kind last changed, for the whole tenant. Omitted for a kind with no failures. */
  mostRecentByKind: {
    /** @format date-time */
    "part-finder-report"?: string;
    /** @format date-time */
    report?: string;
    /** @format date-time */
    asset?: string;
  };
  pageData: PageData;
}

export interface RemediationCandidate {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  name: string;
  /**
   * `retry` for a failure classified as ours, `file-problem` for one caused by the input,
   * which is never re-queued, and `unclassified` when no classification exists; those are
   * retried.
   */
  verdict: "retry" | "unclassified" | "file-problem";
  /** Why a file problem failed, in words the requester can act on. */
  reason?: string;
}

export interface FailureRemediationPlanResponse {
  kind: RemediableFailureKind;
  candidates: RemediationCandidate[];
  /**
   * Failures of this kind not yet tried. `candidates` holds the most recent of them.
   * @format double
   */
  totalMatching: number;
  /**
   * Failures of this kind that failed again after a retry. A batch leaves them out; they can be retried one at a time.
   * @format double
   */
  alreadyTried: number;
}

export interface FailedRemediation {
  candidate: RemediationCandidate;
  message: string;
}

export interface FailureRemediationResponse {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  batchId: UUID;
  queued: RemediationCandidate[];
  skipped: RemediationCandidate[];
  failed: FailedRemediation[];
}

export interface CreateFailureRemediationRequest {
  kind: RemediableFailureKind;
  /**
   * Failures to fix. Omit to fix the most recent failures of `kind` not yet tried.
   * @maxItems 50
   */
  ids?: UUID[];
}

export interface MyUser {
  displayName: string;
  settings: TenantUserSettings[];
  /** True for Physna staff. Gates internal-only surfaces such as the System Health tile. */
  isInternal: boolean;
}

export interface UserServiceAccountWithSecret {
  userId: string;
  name: string;
  clientId: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  secret: string;
}

export interface CreateUserServiceAccountRequest {
  /**
   * The name of the service account to create.
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface UserServiceAccount {
  userId: string;
  name: string;
  clientId: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TokenResponse {
  token: string;
}

/** Manifest dependency definition */
export interface ManifestDependency {
  /**
   * Relative path to the dependency file
   * @minLength 1
   * @maxLength 1024
   */
  path: string;
  /**
   * Number of occurrences in the manifest layout
   * @format double
   * @min 1
   * @max 100
   */
  occurrences: number;
  /** Also place a mirrored copy of each occurrence, reflected across the YZ plane. Defaults to false. */
  hasMirror?: boolean;
}

/** Manifest standards definition */
export interface ManifestStandards {
  /**
   * Steel buffer in millimeters
   * @format float
   * @min 0
   */
  mmSteelBuffer: number;
  /**
   * Gates dropping onto part top surfaces. Optional on creation; may be filled in later via PATCH.
   * @format int32
   * @min 0
   */
  directGate?: number;
  /**
   * Gates seated in the parting line plane. Optional on creation; may be filled in later via PATCH.
   * @format int32
   * @min 0
   */
  edgeGate?: number;
  /**
   * Alias for `edgeGate`. Cannot be combined with `directGate` or `edgeGate`.
   * @deprecated
   * @format int32
   * @min 0
   */
  dropCount?: number;
}

/** Make all properties in T optional */
export interface PartialManifestStandards {
  /**
   * Steel buffer in millimeters
   * @format float
   * @min 0
   */
  mmSteelBuffer?: number;
  /**
   * Gates dropping onto part top surfaces. Optional on creation; may be filled in later via PATCH.
   * @format int32
   * @min 0
   */
  directGate?: number;
  /**
   * Gates seated in the parting line plane. Optional on creation; may be filled in later via PATCH.
   * @format int32
   * @min 0
   */
  edgeGate?: number;
  /**
   * Alias for `edgeGate`. Cannot be combined with `directGate` or `edgeGate`.
   * @deprecated
   * @format int32
   * @min 0
   */
  dropCount?: number;
}

export interface FilterDataPointString {
  filter: string;
  /** @format double */
  count: number;
}

/** Make all properties in T optional */
export interface PartialFilterData {
  extensions?: FilterDataPointString[];
  labels?: FilterDataPointString[];
  folders?: FilterDataPointString[];
  metadata?: FilterMetadata;
  /** @format double */
  sizeThreshold?: number;
}

export interface ListAssetsResponse {
  assets: Asset[];
  /**
   * Standard offset-pagination metadata. Returned only for offset (`page`/`perPage`) requests;
   * omitted entirely in stable-cursor (`cursor`) mode, where `nextCursor` drives pagination.
   */
  pageData?: PageData;
  /** Make all properties in T optional */
  filterData?: PartialFilterData;
  /** @deprecated */
  folderPaths?: string[];
  /**
   * Opaque cursor for the next page when using stable-cursor pagination. Present only when the
   * request supplied a `cursor` and more results exist. Absent when there are no further pages,
   * and never returned for offset (`page`/`perPage`) requests.
   */
  nextCursor?: string;
}

/** Mold analysis data structure (explicit interface for tsoa) */
export interface MoldAnalysisData {
  mmBlockDimensions: {
    /** @format double */
    depth: number;
    /** @format double */
    height: number;
    /** @format double */
    width: number;
  };
  actions: {
    /** Which side of the mold (core or cavity) */
    moldSide?: MoldSide;
    mmDimensions: {
      /** @format double */
      depth: number;
      /** @format double */
      height: number;
      /** @format double */
      width: number;
    };
    /** @format double */
    quantity: number;
    type: string;
  }[];
}

export interface MoldAnalysisResultResponse {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  id: UUID;
  /** @format double */
  version: number;
  /** Mold analysis data structure (explicit interface for tsoa) */
  analysis: MoldAnalysisData;
}

/** Response for GET mold analysis result */
export type GetMoldAnalysisResponse = MoldAnalysisData;

export interface BatchGetAssetsResponse {
  assets: Asset[];
}

export interface BatchGetAssetsRequest {
  /**
   * Array of asset IDs to retrieve.
   * @maxItems 1000
   * @minItems 1
   * @example ["asset-id-1","asset-id-2"]
   */
  assetIds: UUID[];
}

/**
 * Asset path with API validation constraints.
 * @minLength 1
 * @maxLength 1024
 */
export type AssetPath = string;

export interface FindExistingAssetPathsResponse {
  /** The requested paths that an asset already occupies. Creating an asset at one of these paths returns 409. */
  existingPaths: AssetPath[];
}

export interface FindExistingAssetPathsRequest {
  /**
   * Asset paths to check, as they would be sent to create an asset.
   * @maxItems 1000
   * @minItems 1
   * @example ["widgets/bolt.step","widgets/nut.step"]
   */
  paths: AssetPath[];
}

export interface AssetStateCountsResponse {
  /** @format double */
  indexing: number;
  /** @format double */
  finished: number;
  /** @format double */
  failed: number;
  /** @format double */
  unsupported: number;
  /** @format double */
  "no-3d-data": number;
  /** @format double */
  "missing-dependencies": number;
  /** @format double */
  assetLimit?: number;
}

export interface AssetTypeCountsResponse {
  /** @format double */
  model?: number;
  /** @format double */
  image?: number;
  /** @format double */
  document?: number;
  /** @format double */
  manifest?: number;
  /** @format double */
  scan?: number;
  /** @format double */
  scene?: number;
  /** @format double */
  mold?: number;
}

export interface AssetFileTypeCount {
  /**
   * Stable key for the file format. An extension shared by several formats, such as `.prt`,
   * is keyed by all of them joined with `-`, for example `creo-nx`.
   */
  fileType: string;
  /** Human-readable format name. */
  name: string;
  /** @format double */
  count: number;
  /** Lowercased extensions counted in this row, version suffixes dropped, for example `.step` and `.stp`. */
  extensions: string[];
}

export interface AssetFileTypeCountsResponse {
  /** Counts per file format, largest first. */
  fileTypes: AssetFileTypeCount[];
  /**
   * Assets whose extension matches no supported file format.
   * @format double
   */
  unrecognized: number;
}

export interface MetadataCoverageResponse {
  /**
   * Count of the tenant's assets that have at least one metadata value.
   * @format double
   */
  coveredAssets: number;
  /**
   * Total count of the tenant's assets.
   * @format double
   */
  totalAssets: number;
}

export interface LabelingCoverageResponse {
  /**
   * Count of the tenant's assets that carry at least one taxonomy label.
   * @format double
   */
  labeledAssets: number;
  /**
   * Total count of the tenant's assets.
   * @format double
   */
  totalAssets: number;
}

export interface ListAssetsWithoutMetadataResponse {
  assets: Asset[];
  pageData: PageData;
  /** Make all properties in T optional */
  filterData?: PartialFilterData;
}

export interface ListAssetsWithoutLabelsResponse {
  assets: Asset[];
  pageData: PageData;
  /** Make all properties in T optional */
  filterData?: PartialFilterData;
}

export interface ListAssetsByStateResponse {
  assets: Asset[];
  pageData: PageData;
  /** Make all properties in T optional */
  filterData?: PartialFilterData;
  /** @deprecated */
  folderPaths?: string[];
}

export interface FailureDiagnosticsAvailabilityResponse {
  /**
   * Whether this environment has failure log search configured. False on stacks that do not
   * set ASSET_FAILURE_LOG_GROUPS, such as customer-managed and enclave deployments, where
   * every lookup would answer `unavailable`.
   */
  available: boolean;
}

export interface GetAssetResponse {
  asset: Asset;
}

export interface UpdateAssetRequest {
  /**
   * Metadata to assign to the asset. Metadata fields need to exist before assigning values.
   * This can be used to create or update existing metadata values.
   * @maxLength 50000
   * @maxItems 50
   * @example {}
   */
  metadata?: Record<string, MetadataValue>;
  /**
   * Array of supplemental asset IDs to add as supplemental assets of this asset.
   * These IDs will be added to existing supplemental assets (additive behavior).
   * Requires SUPPLEMENTAL_ASSETS feature flag.
   * @maxItems 100
   */
  supplementalAssetIds?: UUID[];
}

export interface MoveAssetResponse {
  asset: Asset;
}

export interface MoveAssetRequest {
  /** The ID of the target folder, or null to move to root. */
  folderId: UUID | null;
}

export interface AssetDependency {
  path: string;
  asset?: Asset;
  /** @format double */
  occurrences: number;
  hasDependencies: boolean;
  status: DependencyStatus;
}

export interface GetAssetDependenciesResponse {
  /** Asset IDs that would create a circular dependency if selected as a resolution target. Only present when `includeExcludedResolveTargets` is true. */
  excludedResolveTargetIds?: string[];
  pageData: PageData;
  dependencies: AssetDependency[];
}

export interface DeleteMetadataFromAssetRequest {
  /** @maxItems 50 */
  metadataFieldNames: MetadataFieldName[];
}

export interface GeometricSearchMatch {
  asset: Asset;
  /**
   * How similar is the asset to the match. A 100% match means the asset is the match.
   * @format double
   * @min 0
   * @max 100
   */
  matchPercentage: number;
}

export interface FilterData {
  extensions: FilterDataPointString[];
  labels: FilterDataPointString[];
  folders: FilterDataPointString[];
  metadata: FilterMetadata;
  /** @format double */
  sizeThreshold?: number;
}

export interface GeometricSearchResponse {
  matches: GeometricSearchMatch[];
  pageData: PageData;
  filterData: FilterData;
  degraded?: boolean;
}

export interface GeometricSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * The minimum threshold for the match percentage.
   * @format double
   * @min 0
   * @max 100
   */
  minThreshold: number;
}

/**
 * Volumetric comparison results after alignment. Source refers to assetId and target to targetAssetId.
 * Additional mismatch details are optional; an omitted field does not mean its value is zero.
 */
export interface VolumetricScores {
  /**
   * Overall volumetric similarity after alignment, expressed as a percentage from 0 to 100.
   * Higher values indicate a closer match.
   * @format double
   * @min 0
   * @max 100
   */
  matchPercentage: number;
  /** Unmatched holes detected in the source asset. An empty array means no unmatched source holes were reported. */
  sourceHoleMisses?: HoleDescriptor[];
  /** Unmatched holes detected in the target asset. An empty array means no unmatched target holes were reported. */
  targetHoleMisses?: HoleDescriptor[];
  /**
   * Sum of the distances between corresponding matched hole centers after alignment, in millimeters; not an average.
   * @format double
   */
  matchedHoleCenterDistanceTotalMm?: number;
  /** Breakdown of mismatch volumes for geometry and holes on each asset, in cubic millimeters. */
  mismatchVolumeMm3?: MismatchVolumeMm3;
}

export interface MatchScoresResponse {
  /** Geometric similarity scores between the two assets. */
  geometric: {
    /**
     * How much of the target asset's geometry exists in the source asset. A 100% reverse match means the target is fully contained in the source.
     * @format double
     * @min 0
     * @max 100
     */
    reverseMatchPercentage: number;
    /**
     * How much of the source asset's geometry exists in the target asset. A 100% forward match means the source is fully contained in the target.
     * @format double
     * @min 0
     * @max 100
     */
    forwardMatchPercentage: number;
    /**
     * Overall geometric similarity. A 100% match means the two assets are geometrically identical.
     * @format double
     * @min 0
     * @max 100
     */
    matchPercentage: number;
  };
  /**
   * Volumetric similarity and optional mismatch details after aligning the two assets.
   * Source refers to assetId; target refers to targetAssetId.
   * Distances and hole dimensions are in millimeters; mismatch volumes are in cubic millimeters.
   * Omitted when volumetric comparison is not enabled. Contact sales to enable it.
   */
  volumetric?: VolumetricScores;
}

export interface PartSearchMatch {
  asset: Asset;
  /**
   * How much of the asset exists in the match. A 100% forward match means 100% of the asset's geometry was found in the match; Ie. the asset is a part of the match.
   * @format double
   * @min 0
   * @max 100
   */
  forwardMatchPercentage: number;
  /**
   * How much of the match was found in the asset. A 100% reverse match means 100% of the match's geometry was found in the asset; Ie. the match is a part of the asset.
   * @format double
   * @min 0
   * @max 100
   */
  reverseMatchPercentage: number;
}

export interface PartSearchResponse {
  matches: PartSearchMatch[];
  pageData: PageData;
  filterData: FilterData;
  degraded?: boolean;
}

export interface PartSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * The minimum threshold for the match percentage.
   * @format double
   * @min 0
   * @max 100
   */
  minThreshold: number;
}

export interface VisualSearchMatch {
  asset: Asset;
}

export interface AssetSearchResponse {
  matches: VisualSearchMatch[];
  pageData: PageData;
  filterData: FilterData;
  degraded?: boolean;
}

export interface AssetVisualSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * A percentage value that controls how strictly the search filters results based on the geometric size of 3D models.
   * Higher values = Stricter filtering. A sizeThreshold of 90% means only models within ±10% of the original size. A 10 unit model with a sizeThreshold of 90% will match models between 9 and 11 units.
   * Lower values = More permissive filtering. A sizeThreshold of 10% means only models within ±90% of the original size. A 10 unit model with a sizeThreshold of 10% will match models between 1 and 19 units.
   * A sizeThreshold of 0% means no size filtering at all.
   * @format double
   * @min 0
   * @max 100
   */
  sizeThreshold?: number;
}

export interface SearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
}

export interface CrossTenantAssetVisualSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * The ID of the asset to search for visual matches.
   * @example ""
   */
  assetId: UUID;
  /**
   * The ID of the tenant that owns the asset to search for visual matches.
   * @example ""
   */
  assetTenantId: UUID;
  /**
   * The ID of the tenant to search for visual matches.
   * @example ""
   */
  searchTenantId: UUID;
  /**
   * A percentage value that controls how strictly the search filters results based on the geometric size of 3D models.
   * Higher values = Stricter filtering. A sizeThreshold of 90% means only models within ±10% of the original size. A 10 unit model with a sizeThreshold of 90% will match models between 9 and 11 units.
   * Lower values = More permissive filtering. A sizeThreshold of 10% means only models within ±90% of the original size. A 10 unit model with a sizeThreshold of 10% will match models between 1 and 19 units.
   * A sizeThreshold of 0% means no size filtering at all.
   * @format double
   * @min 0
   * @max 100
   */
  sizeThreshold?: number;
}

export interface CrossTenantGeometricSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * The ID of the asset to search for visual matches.
   * @example ""
   */
  assetId: UUID;
  /**
   * The ID of the tenant that owns the asset to search for visual matches.
   * @example ""
   */
  assetTenantId: UUID;
  /**
   * The ID of the tenant to search for visual matches.
   * @example ""
   */
  searchTenantId: UUID;
  /**
   * The minimum threshold for the match percentage.
   * @format double
   * @min 0
   * @max 100
   * @default 100
   */
  minThreshold?: number;
}

export interface CrossTenantPartSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * The ID of the asset to search for visual matches.
   * @example ""
   */
  assetId: UUID;
  /**
   * The ID of the tenant that owns the asset to search for visual matches.
   * @example ""
   */
  assetTenantId: UUID;
  /**
   * The ID of the tenant to search for visual matches.
   * @example ""
   */
  searchTenantId: UUID;
  /**
   * The minimum threshold for the match percentage.
   * @format double
   * @min 0
   * @max 100
   */
  minThreshold: number;
}

export interface CrossTenantSearchRequest {
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  perPage?: number;
  /**
   * Text search query to filter the results.
   * @maxLength 1000
   * @example ""
   */
  searchQuery?: string;
  /** Filters to apply to the search. */
  filters?: {
    /**
     * Free-text query that matches label tokens (partial / prefix). Returns
     * assets whose labels contain the text — e.g. "Plumb" matches "Plumbing
     * fixture". Case-insensitive.
     * @maxLength 256
     * @example "Plumb"
     */
    labelQuery?: string;
    /**
     * Label names to filter by.
     * @example []
     */
    labels?: string[];
    /**
     * Array of folder IDs for filtering. Includes assets in the specified folders and all subfolders.
     * @maxItems 100
     * @example []
     */
    folderIds?: string[];
    /**
     * Array of folder paths for filtering. Each folder path must be 1024 characters or less.
     * @min 1
     * @maxItems 100
     * @example []
     */
    folders?: string[];
    /**
     * Filters to apply to the search.
     * @example {}
     */
    metadata: Record<string, MetadataFilterValue>;
    /** Filters to apply to the search. */
    extensions?: string[];
  };
  /**
   * The ID of the asset to search for visual matches.
   * @example ""
   */
  assetId: UUID;
  /**
   * The ID of the tenant that owns the asset to search for visual matches.
   * @example ""
   */
  assetTenantId: UUID;
  /**
   * The ID of the tenant to search for visual matches.
   * @example ""
   */
  searchTenantId: UUID;
}

export interface CriticalGeometryArtifactEntry {
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  artifactId: UUID;
  kind: CriticalGeometryArtifactKind;
  /** @format double */
  version: number;
  name: string;
  /** @format date-time */
  createdAt: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  supersededSupplementalAssetId?: UUID;
}

export interface ManifestReprocessResponse {
  analysisAssetId: string;
}

export interface SegmentationRegion {
  /** @format double */
  pixelCount: number;
  /** @format double */
  id: number;
}

export interface SegmentationResult {
  regions: SegmentationRegion[];
  /** @format double */
  height: number;
  /** @format double */
  width: number;
  regionMap: string;
}

export interface ArchiveDownloadPreviewResponse {
  /**
   * Total number of files (fully recursive through subfolders) that will be archived.
   * @format double
   */
  fileCount: number;
  /**
   * Number of descendant subfolders below the directly-selected folders.
   * @format double
   */
  subfolderCount: number;
  /**
   * Hard cap on file count. Selections exceeding this will be rejected at download time.
   * @format double
   */
  maxFiles: number;
  /**
   * Hard cap on total archive bytes.
   * @format double
   */
  maxBytes: number;
}

export interface ArchiveDownloadRequest {
  /** IDs of folders to archive. All assets in the folder and its descendant subfolders are included. */
  folderIds?: UUID[];
  /** IDs of individual assets to include. */
  assetIds?: UUID[];
  /** Optional base name for the downloaded archive (defaults to `archive`). */
  archiveName?: string;
}

export interface ModelViewerParams {
  /**
   * The ID of the asset to embed.
   *
   * * Must be a UUID
   */
  assetId: UUID;
  /** The token returned from the `/viewer/token` endpoint. */
  token: string;
  /** Color scheme for the viewer. Defaults to `light`. */
  _theme?: "light" | "dark";
  /**
   * Origin of the parent window embedding this viewer iframe.
   * Used for secure cross-origin postMessage communication.
   */
  parentOrigin?: string;
  /**
   * The ID of the tenant for the asset.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface ComparisonParams {
  /**
   * The ID of the first asset to compare.
   *
   * * Must be a UUID
   */
  asset1Id: UUID;
  /**
   * The ID of the second asset to compare.
   *
   * * Must be a UUID
   */
  asset2Id: UUID;
  /** The token returned from the `/viewer/token` endpoint. */
  token: string;
  /**
   * Optional ID of a second tenant if the second asset is not in the same tenant as the first.
   *
   * * Must be a UUID
   */
  tenant2Id?: UUID;
  /** Color scheme for the viewer. Defaults to `light`. */
  _theme?: "light" | "dark";
  /**
   * Origin of the parent window embedding this viewer iframe.
   * Used for secure cross-origin postMessage communication.
   */
  parentOrigin?: string;
  /**
   * The ID of the tenant for the first asset.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface ListTenantUsersParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format double
   * @default 1
   */
  page?: number;
  /**
   * The number of users to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format double
   * @default 20
   */
  perPage?: number;
  /** The ID of the tenant. */
  tenantId: UUID;
}

export interface GetTenantActivityMetricsParams {
  /**
   * First UTC day of the range, `YYYY-MM-DD`.
   * @pattern ^\d{4}-\d{2}-\d{2}$
   */
  from: string;
  /**
   * Last UTC day of the range, `YYYY-MM-DD`. Must not be before `from`.
   * @pattern ^\d{4}-\d{2}-\d{2}$
   */
  to: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface ListTaxonomyNodesParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   * * Defaults to 1
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of nodes to include in each page.
   *
   * * Must be an integer
   * * Defaults to 20
   * * Must be between 1 and 100
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  perPage?: number;
  /**
   * Filter by parent node. Pass `root` to get only root nodes,
   * or a node ID to get children of that node. Omit to get all nodes.
   */
  parentNodeId?: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  taxonomyId: UUID;
}

export interface SearchTaxonomyNodesParams {
  /** The search text to match against node names (case-insensitive substring match). */
  query: string;
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   * * Defaults to 1
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of results to include in each page.
   *
   * * Must be an integer
   * * Defaults to 20
   * * Must be between 1 and 100
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  perPage?: number;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  taxonomyId: UUID;
}

export interface ExportTaxonomyNodesParams {
  /** Format of the export. Supports 'csv' for CSV files and 'xlsx' for Excel files. */
  format: "csv" | "xlsx";
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  taxonomyId: UUID;
}

export interface ListLabelsByNodeParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   * * Defaults to 1
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of labels to include in each page.
   *
   * * Must be an integer
   * * Defaults to 20
   * * Must be between 1 and 100
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  perPage?: number;
  /**
   * When true, includes labels from all descendant nodes.
   * @default false
   */
  includeDescendants?: boolean;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  taxonomyId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  nodeId: UUID;
}

export interface ListReportsParams {
  /** Filter by report type */
  type?: ReportType;
  /** Filter by job status */
  status?: JobStatus;
  /** Filter by creator user ID */
  createdBy?: string;
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of reports to include in each page.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface GetReportGroupsParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of report groups to include in each page.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * The ID of the report to retrieve groups for.
   *
   * * Must be a UUID
   */
  id: UUID;
}

export interface ListReportGroupAssetsParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * The ID of the report containing the group.
   *
   * * Must be a UUID
   */
  reportId: UUID;
  /**
   * The ID of the group to retrieve assets for.
   *
   * * Must be a UUID
   */
  groupId: UUID;
}

export interface DownloadReportParams {
  /** Format of the download. Supports 'csv' for CSV files and 'xlsx' for Excel files. */
  format: "csv" | "xlsx";
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * The ID of the report to download.
   *
   * * Must be a UUID
   */
  id: UUID;
}

export interface ListMetadataFieldsParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of metadata fields to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The ID of the tenant to list metadata fields for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface DeleteMetadataFieldParams {
  /**
   * When true, forces deletion even if assets have values for this field.
   * All metadata values for this field will be removed from assets.
   * @default false
   */
  force?: boolean;
  /**
   * The ID of the tenant to delete the metadata field for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * The ID of the metadata field.
   *
   * * Must be a UUID
   */
  fieldId: UUID;
}

export interface ListAssetsUsingMetadataFieldParams {
  /**
   * The page number to return.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to return per page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The ID of the tenant to list assets for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * The ID of the metadata field.
   *
   * * Must be a UUID
   */
  fieldId: UUID;
}

export interface ListFoldersParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of folders to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface ListRootContentsParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of folders to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The type of content to include in the response.
   *
   * * Must be a string
   *
   * * Default value*: 'all'
   * @default "all"
   */
  contentType?: "all" | "assets" | "folders";
  /**
   * Field to sort by. Allowed values: 'folderNameAndAssetPath', 'name', 'path', 'createdAt', 'createdBy'
   *
   * - 'folderNameAndAssetPath': Sorts folders by name and assets by path (only valid when contentType is 'all')
   * - 'name': Valid for folders only
   * - 'path': Valid for assets only
   * - 'createdAt' and 'createdBy': Valid for both folders and assets
   *
   * When not provided, defaults to:
   * - 'name' for folders
   * - 'createdAt' for assets
   *
   * If a sort field is provided that doesn't exist for the given contentType (e.g., 'path' when contentType is 'folders'),
   * that contentType will fall back to its default sort.
   */
  sortBy?: FolderContentsSortField;
  /**
   * Sort order. Allowed values: 'ASC', 'DESC'
   *
   * When not provided, defaults to 'ASC'.
   */
  sortOrder?: SortOrder;
  /** Sort by a metadata field name. When provided, takes precedence over sortBy for asset ordering. */
  sortByMetadataField?: string;
  /**
   * JSON string of filters for filtering by name, created date, creator, and metadata.
   *
   * Each filter has an `operator` and `value`. Optionally include `"negated": true` to invert the condition.
   * Use `"operator": "isEmpty"` (no value required) to match empty/null fields; combine with `"negated": true` for non-empty.
   *
   * Format:
   * ```json
   * {
   *   "name": [{ "operator": "contains", "value": "part" }],
   *   "createdAt": [{ "operator": "gte", "value": "2024-01-01T00:00:00Z" }],
   *   "creator": [{ "operator": "contains", "value": "john", "negated": true }],
   *   "metadata": {
   *     "material": [{ "operator": "eq", "value": "steel" }],
   *     "location": [{ "operator": "isEmpty" }]
   *   }
   * }
   * ```
   */
  filters?: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface ListFolderContentsParams {
  /**
   * A one-based page number used in conjunction with `perPage`
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of items to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The type of content to include in the response.
   *
   * * Must be a string
   *
   * * Default value*: 'all'
   * @default "all"
   */
  contentType?: "all" | "assets" | "folders";
  /**
   * Field to sort by. Allowed values: 'folderNameAndAssetPath', 'name', 'path', 'createdAt', 'createdBy'
   *
   * - 'folderNameAndAssetPath': Sorts folders by name and assets by path (only valid when contentType is 'all')
   * - 'name': Valid for folders only
   * - 'path': Valid for assets only
   * - 'createdAt' and 'createdBy': Valid for both folders and assets
   *
   * When not provided, defaults to:
   * - 'name' for folders
   * - 'createdAt' for assets
   *
   * If a sort field is provided that doesn't exist for the given contentType (e.g., 'path' when contentType is 'folders'),
   * that contentType will fall back to its default sort.
   */
  sortBy?: FolderContentsSortField;
  /**
   * Sort order. Allowed values: 'ASC', 'DESC'
   *
   * When not provided, defaults to 'ASC'.
   */
  sortOrder?: SortOrder;
  /** Sort by a metadata field name. When provided, takes precedence over sortBy for asset ordering. */
  sortByMetadataField?: string;
  /**
   * JSON string of filters for filtering by name, created date, creator, and metadata.
   *
   * Each filter has an `operator` and `value`. Optionally include `"negated": true` to invert the condition.
   * Use `"operator": "isEmpty"` (no value required) to match empty/null fields; combine with `"negated": true` for non-empty.
   *
   * Format:
   * ```json
   * {
   *   "name": [{ "operator": "contains", "value": "part" }],
   *   "createdAt": [{ "operator": "gte", "value": "2024-01-01T00:00:00Z" }],
   *   "creator": [{ "operator": "contains", "value": "john", "negated": true }],
   *   "metadata": {
   *     "material": [{ "operator": "eq", "value": "steel" }],
   *     "location": [{ "operator": "isEmpty" }]
   *   }
   * }
   * ```
   */
  filters?: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * The ID of the folder.
   *
   * * Must be a UUID
   *
   * * Default value*: undefined
   */
  folderId: UUID;
}

export interface ListRecentFailuresParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of failures to include in each page.
   * @format int32
   * @min 1
   * @max 100
   * @default 20
   */
  perPage?: number;
  /**
   * Comma-separated kinds to include: `asset`, `report`, `part-finder-report`.
   * Omit to include every kind.
   */
  kinds?: string;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface GetFailureRemediationPlanParams {
  /** The kind of failure to plan for. */
  kind: RemediableFailureKind;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface CreateAssetPayload {
  /**
   *
   * A document, image or 3D file.
   * <br><br>
   * | File type | File extension  |
   * |------------|-------------|
   * | Document | `.csv` `.docx` `.json` `.log` `.md` `.odp` `.ods` `.odt` `.pdf` `.plmxml` `.pptx` `.qif` `.rtf` `.tsv` `.txt` `.xlsx` `.xml` `.yaml` `.yml` |
   * | 2D drawing | `.catdrawing` `.dft` `.drw` `.dwg` `.dxf` `.idw` `.slddrw` `.tif` `.tiff` |
   * | Archive | `.7z` `.gz` `.tar` `.tgz` `.zip` |
   * | Image | `.gif` `.jpeg` `.jpg` `.png` |
   * | 3D | `.3ds` `.asm` `.catpart` `.catproduct` `.glb` `.gltf` `.iam` `.iges` `.igs` `.ipt` `.jt` `.obj` `.p21` `.par` `.prt` `.sab` `.sat` `.sldasm` `.sldprt` `.stl` `.step` `.stp` `.stpz` `.usd` `.usdz` `.x_b` `.x_t` `.xmt_bin` `.xmt_txt` |
   * | Scan | `.bpf` `.copc` `.e57` `.las` `.laz` `.npy` `.npz` `.pcd` `.ply` |
   *
   * <br><br>
   * `.drw` also accepts a Creo version suffix, for example `bracket.drw.3`.
   *
   * <br><br>
   * Archives are stored as uploaded and never extracted.
   *
   * <br><br>
   * A `.gltf` must be self-contained: its buffers and textures embedded, not separate files.
   *
   * <br><br>
   * `.usd` and `.usdz` are accepted only for tenants with USD ingestion enabled. Without it the
   * upload is rejected as an unsupported file type, the same as any extension not listed above.
   *
   * <br><br>
   * Scan files are accepted only for tenants with scene ingestion enabled. Without it the upload
   * is rejected with `400 Bad Request`.
   *
   * <br><br>
   * | Invalid file name characters: |
   * |------------------------------|
   * ```
   * \ / : * ? " < > | \n \r \t
   * ```
   * @format binary
   */
  file: File;
  /**
   * The path to the file you are uploading.
   *
   * When creating a new 3D asset with dependencies, such as an assembly, the Asset path created must mirror the file system.
   * Path folder name(s), file name, extension and character casing must match the file system.
   * <br><br>
   * Example:
   *
   * File system structure
   * ```
   * project/
   * ├── example assembly.sldasm
   * └── parts/
   *     ├── example part1.SLDPRT
   *     └── example part2.SLDPRT
   * ```
   *
   * Create three assets with a path that mirrors the file system
   *
   * <br>
   * * Asset 1 path: `project/my assembly.sldasm`<br><br>
   *
   * * Asset 2 path: `project/parts/example part1.SLDPRT`<br><br>
   *
   * * Asset 3 path: `project/parts/example part2.SLDPRT`<br><br>
   *
   * *Default value*: undefined
   */
  path: string;
  /**
   * JSON object that annotates the asset. JSON properties are called [metadata fields](#/Metadata/CreateMetadataField) and must be created before you can set their values on an asset.
   *
   * <br>Example metadata:
   * ```
   * { "material": "copper", "price": 100 }
   * ```
   */
  metadata?: string;
  /**
   * Create folders in the asset path.
   *
   * <br>Example creating asset with path: "project/parts/part 1.sldprt":
   *
   * * Send `true` to create the "project" and "parts" folders
   *
   * * Sending `false` will cause an error if any folders in the path do not exist
   *
   * <br>Example creating asset with path: "project/parts/part 1.sldprt":
   *
   * | | |
   * | --- | --- |
   * | `true` | to create the "project" and "parts" folders |
   * | `false` | Returns error message if folders in the path were not created |
   */
  createMissingFolders?: string;
  /**
   * Optional, case-insensitive semantic type for a supported 3D asset. Allowed
   * values are `scene` and `mold`. `mold` accepts only STEP/STP files. Omit or
   * leave this field empty to infer the asset type from its extension. Override
   * `scene` requires a scan file (.bpf/.copc/.e57/.las/.laz/.npy/.npz/.pcd/.ply).
   * @pattern ^([Ss][Cc][Ee][Nn][Ee]|[Mm][Oo][Ll][Dd])?$
   */
  assetType?: string;
  /**
   * Operator-only: fulfill generation from artifacts already staged at the asset's
   * generated-assets prefix instead of invoking asset generation. Used by the tenant-copy
   * tooling; the pregenerated artifacts must be staged before this call or indexing fails.
   */
  pregenerated?: string;
}

export interface ListAssetsParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * Cannot be combined with `cursor`: requests that supply a non-default `page` together with
   * `cursor` are rejected with 400.
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * Opaque pagination cursor. When supplied, the endpoint switches to stable-cursor pagination:
   * page boundaries are anchored to asset identity and are not affected by concurrent inserts
   * or deletes. Pass the `nextCursor` value from the previous response to fetch the next page.
   *
   * To start a cursor-mode traversal, pass `cursor` as an empty string (`cursor=`). The response
   * will contain the first page of assets plus a `nextCursor` that the client uses to advance.
   * The traversal is complete when the response does not contain `nextCursor`.
   *
   * Recommended for full-tenant enumeration. Cannot be combined with `page`: requests that
   * supply both `cursor` and a non-default `page` are rejected with 400. Cursor-mode responses
   * omit `pageData` entirely — consume `nextCursor` and stop when it is absent.
   */
  cursor?: string;
  /**
   * The ID of the tenant to list assets for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

/** Manifest definition with path, dependencies, standards, and optional metadata. */
export interface CreateManifestAssetPayload {
  /**
   * Create folders in the asset path.
   * @default false
   * @example true
   */
  createMissingFolders?: boolean;
  /**
   * JSON object that annotates the asset. JSON properties are called metadata fields and must be created before you can set their values on an asset.
   * @example {"material":"steel","project":"assembly-1"}
   */
  metadata?: Record<string, MetadataValue>;
  /**
   * Standards for the manifest asset with steel buffer and gate counts.
   * @example {"mmSteelBuffer":2.5,"directGate":2,"edgeGate":1}
   */
  standards: ManifestStandards;
  /**
   * Array of dependencies with their occurrence count in the layout.  Occurrences can be from 1 to 100.
   * @maxItems 100
   * @example [{"path":"part1.sldprt","occurrences":1},{"path":"subfolder/part2.step","occurrences":2}]
   */
  dependencies: ManifestDependency[];
  /**
   * The path to the manifest file.
   * Must end with .json extension and be 1024 characters or less.
   * @minLength 1
   * @maxLength 1024
   * @example "project/assembly-manifest.json"
   */
  path: string;
}

export interface UpdateManifestAssetPayload {
  /**
   * Associate a MOLD Asset with this manifest.
   * @format uuid
   */
  moldAssetId?: UUID;
  /**
   * Update manufacturing standards. Individual fields are merged with existing values.
   * @example {"mmSteelBuffer":3}
   */
  standards?: PartialManifestStandards;
  /**
   * Replace the full dependency list. Each dependency must have a path and occurrence count.
   * @maxItems 100
   * @example [{"path":"part1.sldprt","occurrences":1},{"path":"subfolder/part2.step","occurrences":2}]
   */
  dependencies?: ManifestDependency[];
}

/** The mold analysis data including block dimensions and actions. */
export interface CreateMoldAnalysisResultPayload {
  /** The actions (lifters, slides, etc.) that belong to the mold */
  actions: {
    /** Which side of the mold (core or cavity) */
    moldSide?: "core" | "cavity";
    mmDimensions: {
      /** @format double */
      depth: number;
      /** @format double */
      height: number;
      /** @format double */
      width: number;
    };
    /**
     * The quantity of the given action type in the mold
     * @format int32
     * @min 1
     */
    quantity: number;
    /**
     * The type of action (lifter, slide, etc.)
     * @minLength 1
     * @maxLength 100
     */
    type: string;
  }[];
  /** The dimensions of the mold block (mm) */
  mmBlockDimensions: {
    /** @format double */
    depth: number;
    /** @format double */
    height: number;
    /** @format double */
    width: number;
  };
}

export interface GetAssetStateCountsParams {
  /** Comma-separated list of folder paths to filter by. */
  folders?: string;
  /**
   * Exclude demo assets uploaded by Physna from counts.
   * @default true
   */
  onlyIncludeUserGeneratedAssets?: boolean;
  /**
   * The ID of the tenant to get asset state counts for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface GetAssetTypeCountsParams {
  /**
   * Exclude demo assets uploaded by Physna from counts.
   * @default true
   */
  onlyIncludeUserGeneratedAssets?: boolean;
  /**
   * The ID of the tenant to get asset type counts for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface GetAssetFileTypeCountsParams {
  /**
   * Exclude demo assets uploaded by Physna from counts.
   * @default true
   */
  onlyIncludeUserGeneratedAssets?: boolean;
  /**
   * The ID of the tenant to get asset file type counts for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface ListAssetsWithoutMetadataParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /** Comma-separated list of folder paths to filter by. */
  folders?: string;
  /** Comma-separated list of file extensions to filter by. */
  extensions?: string;
  /**
   * The ID of the tenant to list assets for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface ListAssetsWithoutLabelsParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /** Comma-separated list of folder paths to filter by. */
  folders?: string;
  /** Comma-separated list of file extensions to filter by. */
  extensions?: string;
  /**
   * The ID of the tenant to list assets for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
}

export interface ListAssetsByStateParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /** Comma-separated list of folder paths to filter by. */
  folders?: string;
  /** Comma-separated list of file extensions to filter by. */
  extensions?: string;
  /**
   * Exclude demo assets uploaded by Physna from counts.
   * @default true
   */
  onlyIncludeUserGeneratedAssets?: boolean;
  /**
   * The order to return assets in.
   *
   * * `oldest-first` orders by upload time, oldest first (the default)
   *
   * * `recently-updated-first` orders by last state change, newest first
   */
  sort?: AssetsByStateSort;
  /**
   * The ID of the tenant to list assets for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * The asset state to filter by.
   *
   * * Must be one of: indexing, finished, failed, unsupported, no-3d-data, missing-dependencies
   */
  assetState: AssetState;
}

export interface ReplaceAssetFilePayload {
  /**
   * The replacement file. Must have the same extension as the asset's existing path.
   * @format binary
   */
  file: File;
}

export interface GetAssetDependenciesParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The ID of the tenant to get the asset dependencies for.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * An [encoded](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI) asset path of a 3D file with dependencies.
   *
   * <br>This form encodes the path so you can enter unencoded text. Example path "my assembly/file1.asm" should be entered as:
   * ```
   * my assembly/file1.asm
   * ```
   */
  assetPath: AssetPath;
}

export interface GetAssetDependenciesByIdParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of dependencies to include in each page.
   *
   * * Must be an integer
   * * Must be greater than or equal to 1
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * When true, includes `excludedResolveTargetIds` in the response — the set of asset IDs
   * that would create a circular dependency if selected as a resolution target.
   * @default false
   */
  includeExcludedResolveTargets?: boolean;
  /**
   * Limits the returned dependencies by their status.
   *
   * * `all` (default): every direct dependency
   * * `missing`: dependencies whose target asset is missing, or whose resolved/matched asset
   *   itself contains missing descendants — useful for drilling into broken assemblies
   * * `available`: dependencies whose target asset is present and has no missing descendants
   */
  filter?: DependencyFilter;
  /**
   * Field to sort dependencies by.
   *
   * * `status` (default): orders MISSING first, then rows with missing descendants, then RESOLVED, then MATCHED
   * * `name`: alphabetical by filename (basename of the dependency path)
   * * `path`: alphabetical by full dependency path
   * * `occurrences`: by how many times the dependency is referenced
   */
  sortBy?: DependencySortField;
  /** Sort direction. Defaults to `DESC` for `status` and `occurrences`, `ASC` otherwise. */
  sortOrder?: SortOrder;
  /**
   * The ID of the tenant.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * The ID of the asset to get dependencies for.
   *
   * * Must be a UUID
   */
  assetId: UUID;
}

export interface ResolveDependencyPayload {
  /**
   * The ID of an existing asset to use as the resolved file for this dependency.
   * The asset must have a matching file extension.
   */
  resolvedAssetId: UUID;
  /**
   * The path of the missing dependency as reported by the assembly.
   * This is the `dependencyPath` value from the assembly's dependency list.
   * @minLength 1
   */
  dependencyPath: string;
}

export interface AssetVisualSearchParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format int32
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The ID of the tenant to search for visual matches.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * The ID of the asset to search for visual matches.
   *
   * * Must be a UUID
   *
   * *Default value*: undefined
   */
  assetId: UUID;
}

export interface AssetGeometricSearchExportParams {
  /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
  format: "csv" | "xlsx";
  /**
   * Tenant that owns the source asset, when different from the search tenant (cross-tenant search).
   * Defaults to the path tenantId.
   */
  assetTenantId?: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  assetId: UUID;
}

export interface AssetPartSearchExportParams {
  /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
  format: "csv" | "xlsx";
  /** Tenant that owns the source asset, when different from the search tenant. */
  assetTenantId?: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  assetId: UUID;
}

export interface AssetVisualSearchExportParams {
  /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
  format: "csv" | "xlsx";
  /** Tenant that owns the source asset, when different from the search tenant. */
  assetTenantId?: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  assetId: UUID;
}

export interface TextSearchExportParams {
  /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
  format: "csv" | "xlsx";
  /**
   * Stringified UUIDv4 or UUIDv5.
   * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
   */
  tenantId: UUID;
}

export interface AssetCompositeSearchParams {
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   * @format double
   * @default 1
   */
  page?: number;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * * Must be less than or equal to 1000
   * @format int32
   * @min 1
   * @max 1000
   * @default 20
   */
  perPage?: number;
  /**
   * The ID of the tenant to search for composite matches.
   *
   * * Must be a UUID
   */
  tenantId: UUID;
  /**
   * The ID of the asset to search for composite matches.
   *
   * * Must be a UUID
   *
   * *Default value*: undefined
   */
  assetId: UUID;
}

export interface VisualSearchPayload {
  /**
   * Search with up to 10 image files. Supported extensions:
   * <br><br>
   * `.gif` `.jpeg` `.jpg` `.png`
   * <br><br>
   * Searching with multiple images usually returns better results.
   */
  files: File[];
  /**
   * @deprecated
   * @format binary
   */
  file?: File;
  /**
   * Text search query to filter the results. Maximum 1000 characters.
   *
   * <br>Example: Find assets that have "copper" in path, folder, or metadata field or value.
   * ```
   * copper
   * ```
   *
   * *Default value*: undefined
   */
  searchQuery?: string;
  /**
   * JSON object containing metadata field values to filter by. Maximum 10000 characters.
   *
   * <br>Example filter by metadata to include copper material that is in stock.
   * ```
   * { "material": "copper", "inStock": true }
   * ```
   *
   * *Default value*: undefined
   */
  metadataFilters?: string;
  /**
   * Stringified array of folders to filter by. Maximum 5000 characters. Each folder path must be 1024 characters or less.
   *
   * <br>Example: Find assets in folder "my/folder" and folder "your/folder".
   * ```
   * '["my/folder","your/folder"]'
   * ```
   *
   * *Default value*: undefined
   */
  folders?: string;
  /**
   * Stringified array of folder IDs to filter by. Maximum 5000 characters. Includes assets in the specified folders and all subfolders.
   *
   * <br>Example: Find assets in folder ID "abc123" and folder ID "def456".
   * ```
   * '["abc123","def456"]'
   * ```
   *
   * *Default value*: undefined
   */
  folderIds?: string;
  /**
   * Stringified array of file extensions to filter by. Maximum 1000 characters.
   *
   * <br>Example: Find assets with ".step" and ".stp" extensions.
   * ```
   * '[".step",".stp"]'
   * ```
   *
   * *Default value*: undefined
   */
  extensions?: string;
  /**
   * Stringified array of label names to filter by. Maximum 5000 characters.
   *
   * <br>Example: Find assets labeled "Servo Motors" or "AC Motors".
   * ```
   * '["Servo Motors","AC Motors"]'
   * ```
   *
   * *Default value*: undefined
   */
  labels?: string;
  /**
   * A one-based page number used in conjunction with `perPage`.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * *Default value*: 1
   * @min 1
   */
  page?: string;
  /**
   * The number of assets to include in each page.
   *
   * * Must be an integer
   *
   * * Must be greater than or equal to 1
   *
   * *Default value*: 20
   * @min 1
   * @max 1000
   */
  perPage?: string;
}

export interface SegmentImagePayload {
  /**
   * An image file (JPEG, PNG, etc). Maximum 20 MB.
   * @format binary
   */
  file: File;
  /**
   * Number of regions to segment the image into (2–64).
   * @min 1
   * @max 64
   */
  pointsPerSide?: string;
  /**
   * Boundary precision (0–100). Higher values follow edges more closely.
   * @min 0
   * @max 100
   */
  sensitivity?: string;
}

export namespace Viewer {
  /**
   * @description ## Request html for the embeddable asset viewer This endpoint enables embedding a viewer for a single asset. Our viewer supports the different assets we support: 3d models, images/gifs, and PDF and plain-text documents. Other documents, such as Office files, show their file name without a preview; download them with [Download asset](#/Assets/AssetDownload). The viewer is chosen from the asset's type. Scans and scenes are ingestible but not viewable, and this endpoint reports them as such. The viewer works by setting the src of an iframe to this endpoint. ### Theming Use the `theme` query parameter (`light` or `dark`) to set the viewer's initial color scheme. Defaults to `light`. To switch themes at runtime without reloading the iframe, also include the optional `parentOrigin` query parameter. Set it to the origin of the page that is embedding the viewer (the scheme and host, for example `https://app.example.com`). Without `parentOrigin`, the theme can only be changed by reloading the iframe with a new `theme` value. <br> Example: ``` <iframe id="viewer"></iframe> <script> const tenantId = 'cc9e68d7-7621-427f-8468-a9c26c80a7e5'; const assetId = '123e4567-e89b-12d3-a456-426614174000'; const token = await fetch(https://api.physna.com/v3/viewer/token).then(res => res.json()); const viewer = document.getElementById('viewer'); viewer.src = `https://api.physna.com/v3/tenants/${tenantId}/viewer/asset?assetId=${assetId}&token=${token}&theme=dark&parentOrigin=${window.location.origin}`; </script> ```
   * @tags Viewer
   * @name ModelViewer
   * @request GET:/tenants/{tenantId}/viewer/asset
   * @response `204` `void` No content
   */
  export namespace ModelViewer {
    export type RequestParams = {
      /**
       * The ID of the tenant for the asset.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * The ID of the asset to embed.
       *
       * * Must be a UUID
       */
      assetId: UUID;
      /** The token returned from the `/viewer/token` endpoint. */
      token: string;
      /** Color scheme for the viewer. Defaults to `light`. */
      _theme?: "light" | "dark";
      /**
       * Origin of the parent window embedding this viewer iframe.
       * Used for secure cross-origin postMessage communication.
       */
      parentOrigin?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Request html for the embeddable comparison viewer This endpoint enables embedding a comparison viewer to compare two different 3d assets. Side by side supports 3d models and manifests. The overlay and heatmap comparisons need two finished 3d models. The viewer works by setting the src of an iframe to this endpoint. ### Theming Use the `theme` query parameter (`light` or `dark`) to set the viewer's initial color scheme. Defaults to `light`. To switch themes at runtime without reloading the iframe, also include the optional `parentOrigin` query parameter. Set it to the origin of the page that is embedding the viewer (the scheme and host, for example `https://app.example.com`). Without `parentOrigin`, the theme can only be changed by reloading the iframe with a new `theme` value. <br> Example: ``` <iframe id="viewer"></iframe> <script> const tenantId = 'cc9e68d7-7621-427f-8468-a9c26c80a7e5'; const asset1Id = '123e4567-e89b-12d3-a456-426614174000'; const asset2Id = '123e4567-e89b-12d3-a456-426614174000'; const token = await fetch(https://api.physna.com/v3/viewer/token).then(res => res.json()); const viewer = document.getElementById('viewer'); viewer.src = `https://api.physna.com/v3/tenants/${tenantId}/viewer/comparison?asset1Id=${asset1Id}&asset2Id=${asset2Id}&token=${token}&theme=dark&parentOrigin=${window.location.origin}`; </script> ```
   * @tags Viewer
   * @name Comparison
   * @request GET:/tenants/{tenantId}/viewer/comparison
   * @response `200` `void` The embeddable comparison viewer HTML
   */
  export namespace Comparison {
    export type RequestParams = {
      /**
       * The ID of the tenant for the first asset.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * The ID of the first asset to compare.
       *
       * * Must be a UUID
       */
      asset1Id: UUID;
      /**
       * The ID of the second asset to compare.
       *
       * * Must be a UUID
       */
      asset2Id: UUID;
      /** The token returned from the `/viewer/token` endpoint. */
      token: string;
      /**
       * Optional ID of a second tenant if the second asset is not in the same tenant as the first.
       *
       * * Must be a UUID
       */
      tenant2Id?: UUID;
      /** Color scheme for the viewer. Defaults to `light`. */
      _theme?: "light" | "dark";
      /**
       * Origin of the parent window embedding this viewer iframe.
       * Used for secure cross-origin postMessage communication.
       */
      parentOrigin?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
 * @description ## Request a viewer token Viewer tokens are used to access the viewer UI. A valid token needs to be added to the viewer request query string.
 * @tags Viewer
 * @name ViewerToken
 * @request POST:/viewer/token
 * @secure
 * @response `200` `{
    token: string,

}` Ok
*/
  export namespace ViewerToken {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      token: string;
    };
  }
}

export namespace Users {
  /**
 * @description ## Create a new user Creates a new user with the specified email address.
 * @tags Users
 * @name CreateUser
 * @request POST:/tenants/{tenantId}/users
 * @secure
 * @response `200` `{
    user: User,

}` Ok
*/
  export namespace CreateUser {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateUserRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      user: User;
    };
  }

  /**
 * @description ## List tenant users Returns a paginated list of users.
 * @tags Users
 * @name ListTenantUsers
 * @request GET:/tenants/{tenantId}/users
 * @secure
 * @response `200` `{
    pageData: PageData,
    users: (User)[],

}` Ok
*/
  export namespace ListTenantUsers {
    export type RequestParams = {
      /** The ID of the tenant. */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format double
       * @default 1
       */
      page?: number;
      /**
       * The number of users to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format double
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      pageData: PageData;
      users: User[];
    };
  }

  /**
 * @description ## Get a user Retrieves a user by their ID.
 * @tags Users
 * @name GetUser
 * @request GET:/tenants/{tenantId}/users/{userId}
 * @secure
 * @response `200` `{
    user: User,

}` Ok
*/
  export namespace GetUser {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      userId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      user: User;
    };
  }

  /**
 * @description ## Update a user Updates a user's tenant role and/or enabled status. At least one of tenantRole or enabled must be provided.
 * @tags Users
 * @name UpdateUser
 * @request PATCH:/tenants/{tenantId}/users/{userId}
 * @secure
 * @response `200` `{
    user: User,

}` Ok
*/
  export namespace UpdateUser {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      userId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateUserRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      user: User;
    };
  }

  /**
   * @description ## Delete a user Deletes a user's tenant role. If the user has no remaining tenant roles, the user will be completely deleted from the system.
   * @tags Users
   * @name DeleteUser
   * @request DELETE:/tenants/{tenantId}/users/{userId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteUser {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      userId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
 * @description ## Get my user information Retrieves your user information.
 * @tags Users
 * @name GetCurrentUser
 * @request GET:/users/me
 * @secure
 * @response `200` `{
    user: MyUser,

}` Ok
*/
  export namespace GetCurrentUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      user: MyUser;
    };
  }

  /**
 * @description ## Create a user service account Creates a user service account for the specified user.
 * @tags Users
 * @name CreateUserServiceAccount
 * @request POST:/users/me/service-accounts
 * @secure
 * @response `200` `{
    serviceAccount: UserServiceAccountWithSecret,

}` Ok
*/
  export namespace CreateUserServiceAccount {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateUserServiceAccountRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      serviceAccount: UserServiceAccountWithSecret;
    };
  }

  /**
 * @description ## List user service accounts Retrieves all service accounts for a specific user within a tenant.
 * @tags Users
 * @name ListUserServiceAccounts
 * @request GET:/users/me/service-accounts
 * @secure
 * @response `200` `{
    serviceAccounts?: UserServiceAccount,

}` Ok
*/
  export namespace ListUserServiceAccounts {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      serviceAccounts?: UserServiceAccount;
    };
  }

  /**
 * @description ## Get a user service account Retrieves a specific service account for a user by its ID.
 * @tags Users
 * @name GetUserServiceAccount
 * @request GET:/users/me/service-accounts/{serviceAccountId}
 * @secure
 * @response `200` `{
    serviceAccount: UserServiceAccount,

}` Ok
*/
  export namespace GetUserServiceAccount {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      serviceAccountId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      serviceAccount: UserServiceAccount;
    };
  }

  /**
   * @description ## Delete a user service account Deletes a user service account by its ID.
   * @tags Users
   * @name DeleteUserServiceAccount
   * @request DELETE:/users/me/service-accounts/{serviceAccountId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteUserServiceAccount {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      serviceAccountId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace TenantDashboard {
  /**
   * @description ## Get dashboard version Returns a token that changes when the tenant's dashboard data changes. Poll this instead of re-running every panel's aggregation, and refetch the panels only when the token moves. The token is opaque and only meaningful compared against a previous value from the same tenant.
   * @tags Tenant Dashboard
   * @name GetDashboardVersion
   * @request GET:/tenants/{tenantId}/dashboard-version
   * @secure
   * @response `200` `DashboardVersionResponse` Ok
   */
  export namespace GetDashboardVersion {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DashboardVersionResponse;
  }
}

export namespace TenantActivityMetrics {
  /**
   * @description ## Get activity metrics Returns how much a tenant used Physna between `from` and `to`, inclusive, counted per UTC day: searches, compares, downloads, uploads, reports and distinct active users, as totals plus a daily series, and a per-feature usage count covering folder browsing and management, metadata edits, 3D viewer opens and taxonomy work as well. Active users are counts only; no user is identified. The range must not exceed 366 days. Action counting starts when the feature is deployed; uploads and reports are read from their own records and cover all history. Requires the tenant admin role.
   * @tags Tenant Activity Metrics
   * @name GetTenantActivityMetrics
   * @request GET:/tenants/{tenantId}/activity-metrics
   * @secure
   * @response `200` `TenantActivityMetricsResponse` Ok
   */
  export namespace GetTenantActivityMetrics {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * First UTC day of the range, `YYYY-MM-DD`.
       * @pattern ^\d{4}-\d{2}-\d{2}$
       */
      from: string;
      /**
       * Last UTC day of the range, `YYYY-MM-DD`. Must not be before `from`.
       * @pattern ^\d{4}-\d{2}-\d{2}$
       */
      to: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenantActivityMetricsResponse;
  }
}

export namespace Taxonomy {
  /**
   * @description ## Create a taxonomy node Creates a new node in the taxonomy. Omit `parentNodeId` to create a root node. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name CreateTaxonomyNode
   * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes
   * @secure
   * @response `201` `CreateTaxonomyNodeResponse` Created
   */
  export namespace CreateTaxonomyNode {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateTaxonomyNodeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateTaxonomyNodeResponse;
  }

  /**
   * @description ## List taxonomy nodes Returns a paginated list of nodes in the taxonomy. Use `parentNodeId` to filter: pass `root` for root nodes only, or a node ID for children of that node. Omit to get all nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name ListTaxonomyNodes
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes
   * @secure
   * @response `200` `ListTaxonomyNodesResponse` Ok
   */
  export namespace ListTaxonomyNodes {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       * * Defaults to 1
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of nodes to include in each page.
       *
       * * Must be an integer
       * * Defaults to 20
       * * Must be between 1 and 100
       * @format int32
       * @min 1
       * @max 100
       * @default 20
       */
      perPage?: number;
      /**
       * Filter by parent node. Pass `root` to get only root nodes,
       * or a node ID to get children of that node. Omit to get all nodes.
       */
      parentNodeId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListTaxonomyNodesResponse;
  }

  /**
   * @description ## Import taxonomy nodes Bulk-creates a hierarchy of nodes in an empty taxonomy from a tree structure. The entire import is atomic — if any validation fails, no nodes are created. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name ImportTaxonomyNodes
   * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/import
   * @secure
   * @response `201` `ImportTaxonomyNodesResponse` Created
   */
  export namespace ImportTaxonomyNodes {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = ImportTaxonomyNodesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ImportTaxonomyNodesResponse;
  }

  /**
   * @description ## Reimport taxonomy nodes Replaces the taxonomy by applying a diff: adds new nodes, removes nodes not in the new tree (unless kept), and moves nodes to new parents. Labels on removed nodes are deleted. The entire operation is atomic. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name ReimportTaxonomyNodes
   * @request PUT:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/import
   * @secure
   * @response `200` `ReimportTaxonomyNodesResponse` Ok
   */
  export namespace ReimportTaxonomyNodes {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = ReimportTaxonomyNodesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ReimportTaxonomyNodesResponse;
  }

  /**
   * @description ## Diff taxonomy import Computes the diff between the provided CSV tree and the existing taxonomy. Returns additions, removals (with label counts), moves, and unchanged count. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name DiffTaxonomyImport
   * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/import/diff
   * @secure
   * @response `200` `DiffTaxonomyImportResponse` Ok
   */
  export namespace DiffTaxonomyImport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = DiffTaxonomyImportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DiffTaxonomyImportResponse;
  }

  /**
   * @description ## Search taxonomy nodes Searches for leaf nodes by name across all tree depths. Returns matching nodes with their ancestor paths for breadcrumb display. **Route ordering**: This method must be declared before `getTaxonomyNode` (`{nodeId}`) so that TSOA registers the literal `/search` route first, preventing Express from matching it as a `nodeId` parameter. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name SearchTaxonomyNodes
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/search
   * @secure
   * @response `200` `SearchTaxonomyNodesResponse` Ok
   */
  export namespace SearchTaxonomyNodes {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {
      /** The search text to match against node names (case-insensitive substring match). */
      query: string;
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       * * Defaults to 1
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of results to include in each page.
       *
       * * Must be an integer
       * * Defaults to 20
       * * Must be between 1 and 100
       * @format int32
       * @min 1
       * @max 100
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SearchTaxonomyNodesResponse;
  }

  /**
   * @description ## Export taxonomy nodes Exports all nodes in the taxonomy as a CSV or Excel file using the column-per-level format (Level 1, Level 2, ...). One row per leaf node. **Route ordering**: This method must be declared before `getTaxonomyNode` (`{nodeId}`) so that TSOA registers the literal `/export` route first, preventing Express from matching it as a `nodeId` parameter. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name ExportTaxonomyNodes
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/export
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace ExportTaxonomyNodes {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {
      /** Format of the export. Supports 'csv' for CSV files and 'xlsx' for Excel files. */
      format: "csv" | "xlsx";
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Get node ancestors Returns the ancestor path for a taxonomy node, from the node itself up to the root. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name GetNodeAncestors
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/ancestors
   * @secure
   * @response `200` `GetNodeAncestorsResponse` Ok
   */
  export namespace GetNodeAncestors {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      nodeId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetNodeAncestorsResponse;
  }

  /**
   * @description ## Get a taxonomy node Returns a single taxonomy node by ID. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name GetTaxonomyNode
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}
   * @secure
   * @response `200` `GetTaxonomyNodeResponse` Ok
   */
  export namespace GetTaxonomyNode {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      nodeId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetTaxonomyNodeResponse;
  }

  /**
   * @description ## Delete a taxonomy node Soft-deletes a taxonomy node and all its descendants. Fails if the node or any descendant has assigned labels. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name DeleteTaxonomyNode
   * @request DELETE:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace DeleteTaxonomyNode {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      nodeId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## List labels for a taxonomy node Returns a paginated list of labels assigned to this node. Use `includeDescendants` to also include labels from all descendant nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name ListLabelsByNode
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/labels
   * @secure
   * @response `200` `ListLabelsByNodeResponse` Ok
   */
  export namespace ListLabelsByNode {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      nodeId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       * * Defaults to 1
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of labels to include in each page.
       *
       * * Must be an integer
       * * Defaults to 20
       * * Must be between 1 and 100
       * @format int32
       * @min 1
       * @max 100
       * @default 20
       */
      perPage?: number;
      /**
       * When true, includes labels from all descendant nodes.
       * @default false
       */
      includeDescendants?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListLabelsByNodeResponse;
  }

  /**
   * @description ## Rename a taxonomy node Updates the node's name. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name RenameTaxonomyNode
   * @request PATCH:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/name
   * @secure
   * @response `200` `UpdateTaxonomyNodeResponse` Ok
   */
  export namespace RenameTaxonomyNode {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      nodeId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = RenameTaxonomyNodeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateTaxonomyNodeResponse;
  }

  /**
   * @description ## Move a taxonomy node Moves the node to a different parent. Pass `root` to move to root. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name MoveTaxonomyNode
   * @request PATCH:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/parent
   * @secure
   * @response `200` `UpdateTaxonomyNodeResponse` Ok
   */
  export namespace MoveTaxonomyNode {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      nodeId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = MoveTaxonomyNodeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateTaxonomyNodeResponse;
  }

  /**
   * @description ## Create a taxonomy Creates a new taxonomy for the tenant. Only one taxonomy is allowed per tenant. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name CreateTaxonomy
   * @request POST:/tenants/{tenantId}/taxonomies
   * @secure
   * @response `201` `CreateTaxonomyResponse` Created
   */
  export namespace CreateTaxonomy {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateTaxonomyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateTaxonomyResponse;
  }

  /**
   * @description ## List the tenant's taxonomies Returns every taxonomy belonging to the tenant. Today there is at most one taxonomy per tenant, so this returns either an empty array or a single-entry array. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name ListTaxonomies
   * @request GET:/tenants/{tenantId}/taxonomies
   * @secure
   * @response `200` `ListTaxonomiesResponse` Ok
   */
  export namespace ListTaxonomies {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListTaxonomiesResponse;
  }

  /**
   * @description ## Update a taxonomy Updates settings on an existing taxonomy. Supports renaming and toggling the auto-label opt-in flag. At least one field must be provided. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name UpdateTaxonomy
   * @request PATCH:/tenants/{tenantId}/taxonomies/{taxonomyId}
   * @secure
   * @response `200` `UpdateTaxonomyResponse` Ok
   */
  export namespace UpdateTaxonomy {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the taxonomy to update.
       *
       * * Must be a UUID
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateTaxonomyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateTaxonomyResponse;
  }

  /**
   * @description ## Get a taxonomy Returns a single taxonomy by ID. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name GetTaxonomy
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}
   * @secure
   * @response `200` `GetTaxonomyResponse` Ok
   */
  export namespace GetTaxonomy {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the taxonomy to fetch.
       *
       * * Must be a UUID
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetTaxonomyResponse;
  }

  /**
   * @description ## Delete a taxonomy Deletes a taxonomy by ID. The taxonomy must have no existing nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name DeleteTaxonomy
   * @request DELETE:/tenants/{tenantId}/taxonomies/{taxonomyId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteTaxonomy {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the taxonomy to delete.
       *
       * * Must be a UUID
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Start an auto-label library job Kicks off background classification of every finished asset in the tenant. Returns immediately with a job ID; the caller polls `GET .../auto-label-library/jobs/{jobId}` for progress. User-assigned labels are always preserved. Returns 409 if a job is already in progress for this taxonomy. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name StartAutoLabelLibrary
   * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/auto-label-library
   * @secure
   * @response `202` `StartAutoLabelLibraryResponse` Accepted
   */
  export namespace StartAutoLabelLibrary {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the taxonomy to classify assets against.
       *
       * * Must be a UUID
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = AutoLabelLibraryRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StartAutoLabelLibraryResponse;
  }

  /**
   * @description ## Get the active auto-label library job for the taxonomy Returns the currently active (PENDING or RUNNING) job for the taxonomy, or `{ job: undefined }` if none is in flight. Used by the UI on page mount to recover progress visibility for jobs that started in another session. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name GetActiveAutoLabelLibraryJob
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/auto-label-library
   * @secure
   * @response `200` `GetActiveAutoLabelLibraryJobResponse` Ok
   */
  export namespace GetActiveAutoLabelLibraryJob {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the taxonomy whose active job should be returned.
       *
       * * Must be a UUID
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetActiveAutoLabelLibraryJobResponse;
  }

  /**
   * @description ## Get an auto-label library job Returns the current status, progress, and counts for the given job. Used by the UI to poll until the job reaches a terminal state. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Taxonomy
   * @name GetAutoLabelLibraryJob
   * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/auto-label-library/jobs/{jobId}
   * @secure
   * @response `200` `GetAutoLabelLibraryJobResponse` Ok
   */
  export namespace GetAutoLabelLibraryJob {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the taxonomy the job belongs to.
       *
       * * Must be a UUID
       */
      taxonomyId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      jobId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAutoLabelLibraryJobResponse;
  }
}

export namespace Reports {
  /**
   * @description ## Create a new duplication report Creates a new duplication detection report with the specified threshold settings. Duplication reports help identify similar 3D assets in your catalog.
   * @tags Reports
   * @name CreateDuplicationReport
   * @request POST:/tenants/{tenantId}/reports/duplication
   * @secure
   * @response `201` `CreateReportResponse` Created
   */
  export namespace CreateDuplicationReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateDuplicationReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateReportResponse;
  }

  /**
   * @description ## Create a new simplification report Creates a new simplification detection report with the specified threshold settings. Simplification reports help identify simplified versions of 3D assets in your catalog.
   * @tags Reports
   * @name CreateSimplificationReport
   * @request POST:/tenants/{tenantId}/reports/simplification
   * @secure
   * @response `201` `CreateReportResponse` Created
   */
  export namespace CreateSimplificationReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateSimplificationReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateReportResponse;
  }

  /**
   * @description ## Create a new custom report Creates a new custom report with flexible parameters and the specified threshold settings. Custom reports allow for flexible analysis of 3D assets in your catalog.
   * @tags Reports
   * @name CreateCustomReport
   * @request POST:/tenants/{tenantId}/reports/custom
   * @secure
   * @response `201` `CreateReportResponse` Created
   */
  export namespace CreateCustomReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateCustomReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateReportResponse;
  }

  /**
   * @description ## List reports Returns a paginated list of reports with optional filtering.
   * @tags Reports
   * @name ListReports
   * @request GET:/tenants/{tenantId}/reports
   * @secure
   * @response `200` `ListReportsResponse` Ok
   */
  export namespace ListReports {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /** Filter by report type */
      type?: ReportType;
      /** Filter by job status */
      status?: JobStatus;
      /** Filter by creator user ID */
      createdBy?: string;
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of reports to include in each page.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListReportsResponse;
  }

  /**
   * @description ## Get a report Returns a report by ID.
   * @tags Reports
   * @name GetReport
   * @request GET:/tenants/{tenantId}/reports/{id}
   * @secure
   * @response `200` `GetReportResponse` Ok
   */
  export namespace GetReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to retrieve.
       *
       * * Must be a UUID
       */
      id: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetReportResponse;
  }

  /**
   * @description ## Rename a report Updates the name of a report.
   * @tags Reports
   * @name UpdateReport
   * @request PATCH:/tenants/{tenantId}/reports/{id}
   * @secure
   * @response `200` `UpdateReportResponse` Ok
   */
  export namespace UpdateReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to update.
       *
       * * Must be a UUID
       */
      id: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateReportResponse;
  }

  /**
   * @description ## Delete a report Deletes a report by ID. This operation cannot be undone. All associated report groups and group assets will also be deleted.
   * @tags Reports
   * @name DeleteReport
   * @request DELETE:/tenants/{tenantId}/reports/{id}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace DeleteReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to delete.
       *
       * * Must be a UUID
       */
      id: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Get failure diagnostics for a report Looks up why a failed report failed by searching the job service logs on demand. Nothing is persisted; the answer is only as durable as log retention.
   * @tags Reports
   * @name GetReportFailureDiagnostics
   * @request GET:/tenants/{tenantId}/reports/{id}/failure-diagnostics
   * @secure
   * @response `200` `FailureDiagnosticsResponse` Ok
   */
  export namespace GetReportFailureDiagnostics {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to diagnose.
       *
       * * Must be a UUID
       */
      id: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FailureDiagnosticsResponse;
  }

  /**
   * @description ## Get report groups Returns a paginated list of report groups for a specific report. Each group contains related assets identified by the report analysis.
   * @tags Reports
   * @name GetReportGroups
   * @request GET:/tenants/{tenantId}/reports/{id}/groups
   * @secure
   * @response `200` `ListReportGroupsResponse` Ok
   */
  export namespace GetReportGroups {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to retrieve groups for.
       *
       * * Must be a UUID
       */
      id: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of report groups to include in each page.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListReportGroupsResponse;
  }

  /**
   * @description ## Create report group Creates a new empty report group. Groups organize assets within a report for easier management. Use the add asset endpoint to add assets to the group.
   * @tags Reports
   * @name CreateReportGroup
   * @request POST:/tenants/{tenantId}/reports/{reportId}/groups
   * @secure
   * @response `201` `CreateReportGroupResponse` Created
   */
  export namespace CreateReportGroup {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to create the group in.
       *
       * * Must be a UUID
       */
      reportId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateReportGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateReportGroupResponse;
  }

  /**
   * @description ## Update report group name Updates the name of a report group. Group names provide meaningful context for asset collections identified by the report analysis.
   * @tags Reports
   * @name UpdateReportGroupName
   * @request PATCH:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}
   * @secure
   * @response `200` `UpdateReportGroupResponse` Ok
   */
  export namespace UpdateReportGroupName {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report containing the group.
       *
       * * Must be a UUID
       */
      reportId: UUID;
      /**
       * The ID of the group to update.
       *
       * * Must be a UUID
       */
      groupId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateReportGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateReportGroupResponse;
  }

  /**
   * @description ## Delete report group Deletes a report group and all associated assets. This operation cannot be undone.
   * @tags Reports
   * @name DeleteReportGroup
   * @request DELETE:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace DeleteReportGroup {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report containing the group.
       *
       * * Must be a UUID
       */
      reportId: UUID;
      /**
       * The ID of the group to delete.
       *
       * * Must be a UUID
       */
      groupId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## List report group assets Returns a paginated list of assets for a specific report group.
   * @tags Reports
   * @name ListReportGroupAssets
   * @request GET:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}/assets
   * @secure
   * @response `200` `ListReportGroupAssetsResponse` Ok
   */
  export namespace ListReportGroupAssets {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report containing the group.
       *
       * * Must be a UUID
       */
      reportId: UUID;
      /**
       * The ID of the group to retrieve assets for.
       *
       * * Must be a UUID
       */
      groupId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListReportGroupAssetsResponse;
  }

  /**
   * @description ## Add asset to report group Adds an asset to a report group. The asset can be in another group or not in any group. To move an asset between groups, first remove it from the source group, then add it to the target group.
   * @tags Reports
   * @name AddAssetToReportGroup
   * @request POST:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}/assets
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AddAssetToReportGroup {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report containing the group.
       *
       * * Must be a UUID
       */
      reportId: UUID;
      /**
       * The ID of the group to add the asset to.
       *
       * * Must be a UUID
       */
      groupId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = AddAssetToGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Remove asset from report group Removes an asset from a report group. The group will remain even if it becomes empty.
   * @tags Reports
   * @name RemoveAssetFromReportGroup
   * @request DELETE:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}/assets/{assetId}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace RemoveAssetFromReportGroup {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report containing the group.
       *
       * * Must be a UUID
       */
      reportId: UUID;
      /**
       * The ID of the group containing the asset.
       *
       * * Must be a UUID
       */
      groupId: UUID;
      /**
       * The ID of the asset to remove from the group.
       *
       * * Must be a UUID
       */
      assetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Download report file Downloads the report data as a CSV or XLSX file. The report must be in COMPLETED status.
   * @tags Reports
   * @name DownloadReport
   * @request GET:/tenants/{tenantId}/reports/{id}/file
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace DownloadReport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the report to download.
       *
       * * Must be a UUID
       */
      id: UUID;
    };
    export type RequestQuery = {
      /** Format of the download. Supports 'csv' for CSV files and 'xlsx' for Excel files. */
      format: "csv" | "xlsx";
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }
}

export namespace Metadata {
  /**
   * @description ## Create a new metadata field Metadata fields are used to annotate assets for [multi-modal searching](#/Assets/AssetVisualSearch). To create a metadata field, provide a JSON object with a unique name and a type.
   * @tags Metadata
   * @name CreateMetadataField
   * @request POST:/tenants/{tenantId}/metadata-fields
   * @secure
   * @response `200` `CreateMetadataFieldResponse` Ok
   */
  export namespace CreateMetadataField {
    export type RequestParams = {
      /**
       * The ID of the tenant to create the metadata field for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateMetadataFieldRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateMetadataFieldResponse;
  }

  /**
   * @description ## List metadata fields Returns a paginated list of all metadata fields.
   * @tags Metadata
   * @name ListMetadataFields
   * @request GET:/tenants/{tenantId}/metadata-fields
   * @secure
   * @response `200` `ListMetadataFieldsResponse` Ok
   */
  export namespace ListMetadataFields {
    export type RequestParams = {
      /**
       * The ID of the tenant to list metadata fields for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of metadata fields to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListMetadataFieldsResponse;
  }

  /**
   * @description ## Get a metadata field Returns the metadata field name and type.
   * @tags Metadata
   * @name GetMetadataField
   * @request GET:/tenants/{tenantId}/metadata-fields/{fieldId}
   * @secure
   * @response `200` `GetMetadataFieldResponse` Ok
   */
  export namespace GetMetadataField {
    export type RequestParams = {
      /**
       * The ID of the tenant to get the metadata field for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the metadata field.
       *
       * * Must be a UUID
       */
      fieldId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetMetadataFieldResponse;
  }

  /**
   * @description ## Delete a metadata field Deletes a metadata field by ID. By default, this will return an error when a metadata field is used by assets. Use the `force` query parameter to delete the field and remove all associated metadata values from assets.
   * @tags Metadata
   * @name DeleteMetadataField
   * @request DELETE:/tenants/{tenantId}/metadata-fields/{fieldId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteMetadataField {
    export type RequestParams = {
      /**
       * The ID of the tenant to delete the metadata field for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the metadata field.
       *
       * * Must be a UUID
       */
      fieldId: UUID;
    };
    export type RequestQuery = {
      /**
       * When true, forces deletion even if assets have values for this field.
       * All metadata values for this field will be removed from assets.
       * @default false
       */
      force?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Update a metadata field name Updates a metadata field's name by field ID.
   * @tags Metadata
   * @name UpdateMetadataField
   * @request PATCH:/tenants/{tenantId}/metadata-fields/{fieldId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace UpdateMetadataField {
    export type RequestParams = {
      /**
       * The ID of the tenant to update the metadata field for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the metadata field.
       *
       * * Must be a UUID
       */
      fieldId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateMetadataFieldRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## List assets using a metadata field Returns a paginated list of assets that have a value assigned to the metadata field.
   * @tags Metadata
   * @name ListAssetsUsingMetadataField
   * @request GET:/tenants/{tenantId}/metadata-fields/{fieldId}/assets
   * @secure
   * @response `200` `ListAssetsUsingMetadataFieldResponse` Ok
   */
  export namespace ListAssetsUsingMetadataField {
    export type RequestParams = {
      /**
       * The ID of the tenant to list assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the metadata field.
       *
       * * Must be a UUID
       */
      fieldId: UUID;
    };
    export type RequestQuery = {
      /**
       * The page number to return.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to return per page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListAssetsUsingMetadataFieldResponse;
  }
}

export namespace Label {
  /**
   * @description ## Get label for an asset Returns the full taxonomy label assigned to an asset, or 204 No Content if none is assigned. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Label
   * @name GetLabelForAsset
   * @request GET:/tenants/{tenantId}/assets/{assetId}/label
   * @secure
   * @response `200` `(GetLabelResponse)` OK
   * @response `204` `void` No Content
   */
  export namespace GetLabelForAsset {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetLabelResponse;
  }

  /**
   * @description ## Assign a label Assigns or reassigns a taxonomy label to an asset. If a label already exists for this asset in this taxonomy, it is replaced (upsert). Labels can only be assigned to leaf nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Label
   * @name AssignLabel
   * @request PUT:/tenants/{tenantId}/assets/{assetId}/label/{taxonomyId}
   * @secure
   * @response `200` `AssignLabelResponse` Ok
   */
  export namespace AssignLabel {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = AssignLabelRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssignLabelResponse;
  }

  /**
   * @description ## Unassign a label Removes a taxonomy label from an asset. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Label
   * @name UnassignLabel
   * @request DELETE:/tenants/{tenantId}/assets/{assetId}/label/{taxonomyId}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UnassignLabel {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      taxonomyId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Auto-label an asset Re-runs AI classification on an asset on demand. Clears any existing physna-generated label, resets labelingStatus to pending, and delegates to the classifier. Rejects assets with a user-assigned label — the caller must unassign first. Only runs the classifier when the tenant's taxonomy has `autoLabelOptedIn = true`. Otherwise returns 404, matching the ingest-time gate. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
   * @tags Label
   * @name AutoLabelAsset
   * @request POST:/tenants/{tenantId}/assets/{assetId}/label/auto
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AutoLabelAsset {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Folders {
  /**
   * @description ## Create a new folder Folders are used to organize assets like files in a filesystem.
   * @tags Folders
   * @name CreateFolder
   * @request POST:/tenants/{tenantId}/folders
   * @secure
   * @response `200` `CreateFolderResponse` Ok
   */
  export namespace CreateFolder {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateFolderRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CreateFolderResponse;
  }

  /**
   * @description ## List folders Returns a paginated list of folders.
   * @tags Folders
   * @name ListFolders
   * @request GET:/tenants/{tenantId}/folders
   * @secure
   * @response `200` `ListFoldersResponse` Ok
   */
  export namespace ListFolders {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of folders to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListFoldersResponse;
  }

  /**
   * @description ## Get a folder Returns a folder by folder ID.
   * @tags Folders
   * @name GetFolder
   * @request GET:/tenants/{tenantId}/folders/{folderId}
   * @secure
   * @response `200` `GetFolderResponse` Ok
   */
  export namespace GetFolder {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder.
       *
       * * Must be a UUID
       */
      folderId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetFolderResponse;
  }

  /**
   * @description Delete a folder and all of its contents (subfolders and assets).
   * @tags Folders
   * @name DeleteFolder
   * @request DELETE:/tenants/{tenantId}/folders/{folderId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteFolder {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder to delete.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      folderId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Rename a folder Updates the folder's name and adjusts paths for all descendant folders.
   * @tags Folders
   * @name RenameFolder
   * @request PATCH:/tenants/{tenantId}/folders/{folderId}/name
   * @secure
   * @response `200` `RenameFolderResponse` Ok
   */
  export namespace RenameFolder {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder to rename.
       *
       * * Must be a UUID
       */
      folderId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = RenameFolderRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RenameFolderResponse;
  }

  /**
   * @description ## Move a folder Moves the folder to a different parent folder and adjusts paths for all descendants.
   * @tags Folders
   * @name MoveFolder
   * @request PATCH:/tenants/{tenantId}/folders/{folderId}/parent
   * @secure
   * @response `200` `MoveFolderResponse` Ok
   */
  export namespace MoveFolder {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder to move.
       *
       * * Must be a UUID
       */
      folderId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = MoveFolderRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MoveFolderResponse;
  }

  /**
   * @description ## Update a folder's description Sets or replaces the folder's description. Use DELETE to remove the description.
   * @tags Folders
   * @name UpdateFolderDescription
   * @request PATCH:/tenants/{tenantId}/folders/{folderId}/description
   * @secure
   * @response `200` `UpdateFolderDescriptionResponse` Ok
   */
  export namespace UpdateFolderDescription {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder to update.
       *
       * * Must be a UUID
       */
      folderId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateFolderDescriptionRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateFolderDescriptionResponse;
  }

  /**
   * @description ## Remove a folder's description Clears the folder's description.
   * @tags Folders
   * @name DeleteFolderDescription
   * @request DELETE:/tenants/{tenantId}/folders/{folderId}/description
   * @secure
   * @response `200` `DeleteFolderDescriptionResponse` Ok
   */
  export namespace DeleteFolderDescription {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder to update.
       *
       * * Must be a UUID
       */
      folderId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeleteFolderDescriptionResponse;
  }

  /**
   * @description List the contents of the root including subfolders and assets.
   * @tags Folders
   * @name ListRootContents
   * @request GET:/tenants/{tenantId}/folders/root/contents
   * @secure
   * @response `200` `ListFolderContentsResponse` Ok
   */
  export namespace ListRootContents {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of folders to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /**
       * The type of content to include in the response.
       *
       * * Must be a string
       *
       * * Default value*: 'all'
       * @default "all"
       */
      contentType?: "all" | "assets" | "folders";
      /**
       * Field to sort by. Allowed values: 'folderNameAndAssetPath', 'name', 'path', 'createdAt', 'createdBy'
       *
       * - 'folderNameAndAssetPath': Sorts folders by name and assets by path (only valid when contentType is 'all')
       * - 'name': Valid for folders only
       * - 'path': Valid for assets only
       * - 'createdAt' and 'createdBy': Valid for both folders and assets
       *
       * When not provided, defaults to:
       * - 'name' for folders
       * - 'createdAt' for assets
       *
       * If a sort field is provided that doesn't exist for the given contentType (e.g., 'path' when contentType is 'folders'),
       * that contentType will fall back to its default sort.
       */
      sortBy?: FolderContentsSortField;
      /**
       * Sort order. Allowed values: 'ASC', 'DESC'
       *
       * When not provided, defaults to 'ASC'.
       */
      sortOrder?: SortOrder;
      /** Sort by a metadata field name. When provided, takes precedence over sortBy for asset ordering. */
      sortByMetadataField?: string;
      /**
       * JSON string of filters for filtering by name, created date, creator, and metadata.
       *
       * Each filter has an `operator` and `value`. Optionally include `"negated": true` to invert the condition.
       * Use `"operator": "isEmpty"` (no value required) to match empty/null fields; combine with `"negated": true` for non-empty.
       *
       * Format:
       * ```json
       * {
       *   "name": [{ "operator": "contains", "value": "part" }],
       *   "createdAt": [{ "operator": "gte", "value": "2024-01-01T00:00:00Z" }],
       *   "creator": [{ "operator": "contains", "value": "john", "negated": true }],
       *   "metadata": {
       *     "material": [{ "operator": "eq", "value": "steel" }],
       *     "location": [{ "operator": "isEmpty" }]
       *   }
       * }
       * ```
       */
      filters?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListFolderContentsResponse;
  }

  /**
   * @description List the contents of a folder including subfolders and assets.
   * @tags Folders
   * @name ListFolderContents
   * @request GET:/tenants/{tenantId}/folders/{folderId}/contents
   * @secure
   * @response `200` `ListFolderContentsResponse` Ok
   */
  export namespace ListFolderContents {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * The ID of the folder.
       *
       * * Must be a UUID
       *
       * * Default value*: undefined
       */
      folderId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of items to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /**
       * The type of content to include in the response.
       *
       * * Must be a string
       *
       * * Default value*: 'all'
       * @default "all"
       */
      contentType?: "all" | "assets" | "folders";
      /**
       * Field to sort by. Allowed values: 'folderNameAndAssetPath', 'name', 'path', 'createdAt', 'createdBy'
       *
       * - 'folderNameAndAssetPath': Sorts folders by name and assets by path (only valid when contentType is 'all')
       * - 'name': Valid for folders only
       * - 'path': Valid for assets only
       * - 'createdAt' and 'createdBy': Valid for both folders and assets
       *
       * When not provided, defaults to:
       * - 'name' for folders
       * - 'createdAt' for assets
       *
       * If a sort field is provided that doesn't exist for the given contentType (e.g., 'path' when contentType is 'folders'),
       * that contentType will fall back to its default sort.
       */
      sortBy?: FolderContentsSortField;
      /**
       * Sort order. Allowed values: 'ASC', 'DESC'
       *
       * When not provided, defaults to 'ASC'.
       */
      sortOrder?: SortOrder;
      /** Sort by a metadata field name. When provided, takes precedence over sortBy for asset ordering. */
      sortByMetadataField?: string;
      /**
       * JSON string of filters for filtering by name, created date, creator, and metadata.
       *
       * Each filter has an `operator` and `value`. Optionally include `"negated": true` to invert the condition.
       * Use `"operator": "isEmpty"` (no value required) to match empty/null fields; combine with `"negated": true` for non-empty.
       *
       * Format:
       * ```json
       * {
       *   "name": [{ "operator": "contains", "value": "part" }],
       *   "createdAt": [{ "operator": "gte", "value": "2024-01-01T00:00:00Z" }],
       *   "creator": [{ "operator": "contains", "value": "john", "negated": true }],
       *   "metadata": {
       *     "material": [{ "operator": "eq", "value": "steel" }],
       *     "location": [{ "operator": "isEmpty" }]
       *   }
       * }
       * ```
       */
      filters?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListFolderContentsResponse;
  }
}

export namespace Failures {
  /**
   * @description ## List recent failures Returns failed assets, reports and part finder reports for a tenant as one list, newest first, so a caller does not have to page three surfaces separately.
   * @tags Failures
   * @name ListRecentFailures
   * @request GET:/tenants/{tenantId}/failures
   * @secure
   * @response `200` `ListRecentFailuresResponse` Ok
   */
  export namespace ListRecentFailures {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of failures to include in each page.
       * @format int32
       * @min 1
       * @max 100
       * @default 20
       */
      perPage?: number;
      /**
       * Comma-separated kinds to include: `asset`, `report`, `part-finder-report`.
       * Omit to include every kind.
       */
      kinds?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListRecentFailuresResponse;
  }

  /**
   * @description ## Plan a self-service fix Classifies the most recent failures of a kind not yet tried, so the caller can say how many a fix would re-queue and which are file problems it would leave alone.
   * @tags Failures
   * @name GetFailureRemediationPlan
   * @request GET:/tenants/{tenantId}/failures/remediation-plan
   * @secure
   * @response `200` `FailureRemediationPlanResponse` Ok
   */
  export namespace GetFailureRemediationPlan {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /** The kind of failure to plan for. */
      kind: RemediableFailureKind;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FailureRemediationPlanResponse;
  }

  /**
   * @description ## Run a self-service fix Reprocesses failed assets or retries failed Part Finder searches, skipping failures classified as file problems, and records the batch so failures that fail again are recognised as already tried.
   * @tags Failures
   * @name CreateFailureRemediation
   * @request POST:/tenants/{tenantId}/failures/remediations
   * @secure
   * @response `201` `FailureRemediationResponse` Created
   */
  export namespace CreateFailureRemediation {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateFailureRemediationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = FailureRemediationResponse;
  }
}

export namespace Authentication {
  /**
   * No description
   * @tags Authentication
   * @name Login
   * @request POST:/auth/token
   * @secure
   * @response `200` `TokenResponse` Ok
   */
  export namespace Login {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TokenResponse;
  }
}

export namespace Assets {
  /**
   * @description ## Create a new asset An asset is the core resource of the platform. Assets can be used to search with and assets are search results. Every asset has a file associated with it. It can be a document, image or a 3D model. Assets can be annotated with [metadata](#/Metadata/CreateMetadataField) for multi-modal searching and organized into [folders](#/Folders/CreateFolder) like files in a filesystem.
   * @tags Assets
   * @name CreateAsset
   * @request POST:/tenants/{tenantId}/assets
   * @secure
   * @response `200` `Asset` Ok
   */
  export namespace CreateAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant to create the asset for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateAssetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Asset;
  }

  /**
   * @description ## List assets Returns a paginated list of assets. Two pagination modes are supported: 1. **Offset (`page` + `perPage`)** — default. Returns `pageData` with totals and page numbers. Not safe under concurrent writes: a delete that occurs while a client is paginating can cause records to be silently skipped on subsequent pages. 2. **Stable cursor (`cursor` + `perPage`)** — recommended for full-tenant enumeration. Pass the `nextCursor` value from the previous response to fetch the next page. Page boundaries are anchored to asset identity and are not affected by concurrent inserts or deletes. The response omits `pageData` entirely in cursor mode; consume `nextCursor`, and stop when it is absent. Cursor mode cannot be combined with offset: requests that supply both `cursor` and a non-default `page` are rejected with 400.
   * @tags Assets
   * @name ListAssets
   * @request GET:/tenants/{tenantId}/assets
   * @secure
   * @response `200` `ListAssetsResponse` Ok
   */
  export namespace ListAssets {
    export type RequestParams = {
      /**
       * The ID of the tenant to list assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * Cannot be combined with `cursor`: requests that supply a non-default `page` together with
       * `cursor` are rejected with 400.
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /**
       * Opaque pagination cursor. When supplied, the endpoint switches to stable-cursor pagination:
       * page boundaries are anchored to asset identity and are not affected by concurrent inserts
       * or deletes. Pass the `nextCursor` value from the previous response to fetch the next page.
       *
       * To start a cursor-mode traversal, pass `cursor` as an empty string (`cursor=`). The response
       * will contain the first page of assets plus a `nextCursor` that the client uses to advance.
       * The traversal is complete when the response does not contain `nextCursor`.
       *
       * Recommended for full-tenant enumeration. Cannot be combined with `page`: requests that
       * supply both `cursor` and a non-default `page` are rejected with 400. Cursor-mode responses
       * omit `pageData` entirely — consume `nextCursor` and stop when it is absent.
       */
      cursor?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListAssetsResponse;
  }

  /**
   * @description ## Create a manifest asset A manifest asset defines a collection of other assets that are related to each other.  It provides a list of required assets necessary for the bundle to be "complete", providing a mechanism for multi-file analysis. The manifest supports partial indexing and will automatically re-index as dependencies become available. Dependencies are defined as relative paths from the manifest path. Example: ``` { "path": "project/assembly-manifest.json", "dependencies": [{"path": "part1.sldprt", "occurrences": 1}, {"path": "subfolder/part2.step", "occurrences": 2}], "standards": { "mmSteelBuffer": 2.5, "directGate": 2, "edgeGate": 1 }, "metadata": { "material": "steel", "project": "assembly-1" } } ``` This example would create a manifest asset with the path `project/assembly-manifest.json`.  The manifest file exists in the `project` folder and the dependencies are relative to the manifest path.  For the manifest to be "complete", the dependencies `project/part1.sldprt` and `project/subfolder/part2.step` must exist. Occurrences are the number of times the dependency appears in the manifest layout. Manifests can be created within any pre-existing folder, but when `createMissingFolders` is `true`, folders on the manifest path will be created if they do not exist. _Note that this feature is not enabled by default. Please contact support to enable it._
   * @tags Assets
   * @name CreateManifestAsset
   * @request POST:/tenants/{tenantId}/assets/manifest
   * @secure
   * @response `200` `Asset` Ok
   */
  export namespace CreateManifestAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant to create the manifest asset for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateManifestAssetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Asset;
  }

  /**
   * @description ## Update manifest asset Partially updates the content of a manifest asset. Accepts optional `dependencies`, `standards`, and `moldAssetId` fields. When `dependencies` is provided, the full dependency list is replaced and dependency flags are recalculated. When `standards` is provided, individual fields are deep-merged with existing values. When `moldAssetId` is provided, the MOLD Asset is associated with the manifest. Changing `dependencies` or `standards` deletes stale mold analysis and reprocesses it. Changing only `moldAssetId` does neither. _Note that this feature is not enabled by default. Please contact support to enable it._
   * @tags Assets
   * @name UpdateManifestAsset
   * @request PATCH:/tenants/{tenantId}/assets/{assetId}/manifest
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UpdateManifestAsset {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateManifestAssetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Creates a ground truth mold analysis for a manifest asset with supplied analysis data. This is stored separately from Physna-computed results and does not override them. The analysis is versioned, and the version will always be 1 greater than the highest existing version.  Results in a new supplemental asset associated with the manifest asset, and the new asset id is returned as `analysisAssetId` at the `path` indicated. <br>Example request body: ``` { "mmBlockDimensions": { "x": 100, "y": 200, "z": 300 }, "actions": [ { "type": "Small Angled Lifter w/o Water", "quantity": 3 }, { "type": "Medium Mechanical Slide w/ Water", "quantity": 2 } ] } ```
   * @tags Assets
   * @name CreateMoldAnalysisResult
   * @request POST:/tenants/{tenantId}/assets/{assetId}/mold-analysis-result
   * @secure
   * @response `200` `MoldAnalysisResultResponse` Ok
   */
  export namespace CreateMoldAnalysisResult {
    export type RequestParams = {
      /**
       * The ID of the tenant to create the mold analysis result for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the manifest asset to create the mold analysis result for.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateMoldAnalysisResultPayload;
    export type RequestHeaders = {};
    export type ResponseBody = MoldAnalysisResultResponse;
  }

  /**
   * @description Retrieves the latest mold analysis result for a manifest asset. Returns the parsed analysis data as JSON including block dimensions and actions. The latest version is automatically selected when multiple analysis results exist. _Note that this feature is not enabled by default. Please contact support to enable it._
   * @tags Assets
   * @name FetchMoldAnalysisResult
   * @request GET:/tenants/{tenantId}/assets/{assetId}/mold-analysis-result
   * @secure
   * @response `200` `GetMoldAnalysisResponse` Ok
   */
  export namespace FetchMoldAnalysisResult {
    export type RequestParams = {
      /**
       * The ID of the tenant.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the manifest asset to get the mold analysis result for.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetMoldAnalysisResponse;
  }

  /**
   * @description ## Get assets by IDs (batch) Returns assets for the provided asset IDs. This endpoint is designed for retrieving large numbers of assets (up to 1000) efficiently.
   * @tags Assets
   * @name BatchGetAssets
   * @request POST:/tenants/{tenantId}/assets/batch
   * @secure
   * @response `200` `BatchGetAssetsResponse` Ok
   */
  export namespace BatchGetAssets {
    export type RequestParams = {
      /**
       * The ID of the tenant to get assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = BatchGetAssetsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = BatchGetAssetsResponse;
  }

  /**
   * @description ## Find existing asset paths Returns which of the provided paths already hold an asset. Call it before a large upload to skip files that [create an asset](#/Assets/CreateAsset) would reject as duplicates, instead of sending them. A path matches when an asset with the same file name exists in the same folder. The match is case-sensitive. Paths in folders that do not exist are never returned.
   * @tags Assets
   * @name FindExistingAssetPaths
   * @request POST:/tenants/{tenantId}/assets/existing-paths
   * @secure
   * @response `200` `FindExistingAssetPathsResponse` Ok
   */
  export namespace FindExistingAssetPaths {
    export type RequestParams = {
      /**
       * The ID of the tenant to check paths in.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = FindExistingAssetPathsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = FindExistingAssetPathsResponse;
  }

  /**
   * @description ## Reprocess a single asset Triggers reprocessing for a single asset. The asset state is set to INDEXING and a reprocess event is emitted. Assets can be reprocessed regardless of their current state.
   * @tags Assets
   * @name ReprocessAsset
   * @request POST:/tenants/{tenantId}/assets/{assetId}/reprocess
   * @secure
   * @response `204` `void` No content
   */
  export namespace ReprocessAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant the asset belongs to.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to reprocess.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Get asset state counts Returns counts of assets grouped by their state (indexing, finished, failed, unsupported, no-3d-data).
   * @tags Assets
   * @name GetAssetStateCounts
   * @request GET:/tenants/{tenantId}/assets/state
   * @secure
   * @response `200` `AssetStateCountsResponse` Ok
   */
  export namespace GetAssetStateCounts {
    export type RequestParams = {
      /**
       * The ID of the tenant to get asset state counts for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /** Comma-separated list of folder paths to filter by. */
      folders?: string;
      /**
       * Exclude demo assets uploaded by Physna from counts.
       * @default true
       */
      onlyIncludeUserGeneratedAssets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AssetStateCountsResponse;
  }

  /**
   * @description ## Get asset type counts Returns counts of assets grouped by their type (model, image, document, manifest, scan, scene, mold). Types belonging to a feature the tenant does not have enabled are omitted from the response.
   * @tags Assets
   * @name GetAssetTypeCounts
   * @request GET:/tenants/{tenantId}/assets/type-counts
   * @secure
   * @response `200` `AssetTypeCountsResponse` Ok
   */
  export namespace GetAssetTypeCounts {
    export type RequestParams = {
      /**
       * The ID of the tenant to get asset type counts for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * Exclude demo assets uploaded by Physna from counts.
       * @default true
       */
      onlyIncludeUserGeneratedAssets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AssetTypeCountsResponse;
  }

  /**
   * @description ## Get asset file type counts Returns counts of assets grouped by file format (STEP, Parasolid, SolidWorks, ...), derived from each asset's file extension. Aliased extensions such as `.stp` and `.step` count together. The counts plus `unrecognized` add up to the asset state counts total for the same filter.
   * @tags Assets
   * @name GetAssetFileTypeCounts
   * @request GET:/tenants/{tenantId}/assets/file-type-counts
   * @secure
   * @response `200` `AssetFileTypeCountsResponse` Ok
   */
  export namespace GetAssetFileTypeCounts {
    export type RequestParams = {
      /**
       * The ID of the tenant to get asset file type counts for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * Exclude demo assets uploaded by Physna from counts.
       * @default true
       */
      onlyIncludeUserGeneratedAssets?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AssetFileTypeCountsResponse;
  }

  /**
   * @description ## Get metadata coverage Returns how many of the tenant's assets have at least one metadata value, alongside the total asset count. Demo assets uploaded by Physna are excluded from both counts.
   * @tags Assets
   * @name GetMetadataCoverage
   * @request GET:/tenants/{tenantId}/metadata-coverage
   * @secure
   * @response `200` `MetadataCoverageResponse` Ok
   */
  export namespace GetMetadataCoverage {
    export type RequestParams = {
      /**
       * The ID of the tenant to get metadata coverage for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MetadataCoverageResponse;
  }

  /**
   * @description ## Get labeling coverage Returns how many of the tenant's assets carry at least one taxonomy label, alongside the total asset count. An asset labeled in several taxonomies counts once. Demo assets uploaded by Physna are excluded from both counts.
   * @tags Assets
   * @name GetLabelingCoverage
   * @request GET:/tenants/{tenantId}/labeling-coverage
   * @secure
   * @response `200` `LabelingCoverageResponse` Ok
   */
  export namespace GetLabelingCoverage {
    export type RequestParams = {
      /**
       * The ID of the tenant to get labeling coverage for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LabelingCoverageResponse;
  }

  /**
   * @description ## List assets without metadata Returns a paginated list of the tenant's assets that have no metadata values, oldest first. Demo assets uploaded by Physna are excluded.
   * @tags Assets
   * @name ListAssetsWithoutMetadata
   * @request GET:/tenants/{tenantId}/assets/without-metadata
   * @secure
   * @response `200` `ListAssetsWithoutMetadataResponse` Ok
   */
  export namespace ListAssetsWithoutMetadata {
    export type RequestParams = {
      /**
       * The ID of the tenant to list assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /** Comma-separated list of folder paths to filter by. */
      folders?: string;
      /** Comma-separated list of file extensions to filter by. */
      extensions?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListAssetsWithoutMetadataResponse;
  }

  /**
   * @description ## List assets without labels Returns a paginated list of the tenant's assets that carry no taxonomy label, oldest first. Demo assets uploaded by Physna are excluded.
   * @tags Assets
   * @name ListAssetsWithoutLabels
   * @request GET:/tenants/{tenantId}/assets/without-labels
   * @secure
   * @response `200` `ListAssetsWithoutLabelsResponse` Ok
   */
  export namespace ListAssetsWithoutLabels {
    export type RequestParams = {
      /**
       * The ID of the tenant to list assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /** Comma-separated list of folder paths to filter by. */
      folders?: string;
      /** Comma-separated list of file extensions to filter by. */
      extensions?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListAssetsWithoutLabelsResponse;
  }

  /**
   * @description ## List assets by state Returns a paginated list of assets filtered by their state.
   * @tags Assets
   * @name ListAssetsByState
   * @request GET:/tenants/{tenantId}/assets/state/{assetState}
   * @secure
   * @response `200` `ListAssetsByStateResponse` Ok
   */
  export namespace ListAssetsByState {
    export type RequestParams = {
      /**
       * The ID of the tenant to list assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The asset state to filter by.
       *
       * * Must be one of: indexing, finished, failed, unsupported, no-3d-data, missing-dependencies
       */
      assetState: AssetState;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /** Comma-separated list of folder paths to filter by. */
      folders?: string;
      /** Comma-separated list of file extensions to filter by. */
      extensions?: string;
      /**
       * Exclude demo assets uploaded by Physna from counts.
       * @default true
       */
      onlyIncludeUserGeneratedAssets?: boolean;
      /**
       * The order to return assets in.
       *
       * * `oldest-first` orders by upload time, oldest first (the default)
       *
       * * `recently-updated-first` orders by last state change, newest first
       */
      sort?: AssetsByStateSort;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListAssetsByStateResponse;
  }

  /**
   * @description ## Is failure diagnostics lookup available here Reports whether this environment has failure log search configured, so a client can decide up front whether to offer the lookup at all rather than showing a control that can only ever answer `unavailable`.
   * @tags Assets
   * @name GetFailureDiagnosticsAvailability
   * @request GET:/tenants/{tenantId}/failure-diagnostics/availability
   * @secure
   * @response `200` `FailureDiagnosticsAvailabilityResponse` Ok
   */
  export namespace GetFailureDiagnosticsAvailability {
    export type RequestParams = {
      /**
       * The ID of the tenant whose dashboard is asking. Scopes authorisation only: availability
       * is a property of the deployment, not of the tenant.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FailureDiagnosticsAvailabilityResponse;
  }

  /**
   * @description ## Get failure diagnostics for an asset Looks up why a failed asset failed by searching the ingestion service logs on demand. Nothing is persisted; the answer is only as durable as log retention. Returns a `status` of `found`, `not-found` (asset is not failed, or the log entry has aged out), or `unavailable` (log search is not configured for this environment).
   * @tags Assets
   * @name GetAssetFailureDiagnostics
   * @request GET:/tenants/{tenantId}/assets/{assetId}/failure-diagnostics
   * @secure
   * @response `200` `FailureDiagnosticsResponse` Ok
   */
  export namespace GetAssetFailureDiagnostics {
    export type RequestParams = {
      /**
       * The ID of the tenant that owns the asset.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to diagnose.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FailureDiagnosticsResponse;
  }

  /**
   * @description ## Get an asset Returns an asset by ID.
   * @tags Assets
   * @name GetAsset
   * @request GET:/tenants/{tenantId}/assets/{assetId}
   * @secure
   * @response `200` `GetAssetResponse` Ok
   */
  export namespace GetAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant to list assets for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to retrieve.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssetResponse;
  }

  /**
   * @description ## Delete an asset Deleting an asset by ID is a permanent operation. * The asset file uploaded and files generated when it was created are deleted from the platform * Deleting an asset that is a dependency of another asset will not change the dependent asset in any way
   * @tags Assets
   * @name DeleteAsset
   * @request DELETE:/tenants/{tenantId}/assets/{assetId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant to delete the asset for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to delete.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Decorate assets with supplemental assets IDs and metadata``` Assign string, boolean or number values to asset metadata fields by asset ID.
   * @tags Assets
   * @name UpdateAsset
   * @request PATCH:/tenants/{tenantId}/assets/{assetId}
   * @secure
   * @response `204` `void` No content
   */
  export namespace UpdateAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant to update the asset for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to update.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateAssetRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Replace an asset's file Replaces the file content of an existing asset. The asset keeps its ID, path, and metadata, but is re-indexed with the new file. The file extension must match the asset's existing path. This is the recommended way to update an asset's file content without deleting and re-creating it.
   * @tags Assets
   * @name ReplaceAssetFile
   * @request PUT:/tenants/{tenantId}/assets/{assetId}/file
   * @secure
   * @response `200` `Asset` Ok
   */
  export namespace ReplaceAssetFile {
    export type RequestParams = {
      /**
       * The ID of the tenant.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to replace the file for.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = ReplaceAssetFilePayload;
    export type RequestHeaders = {};
    export type ResponseBody = Asset;
  }

  /**
   * @description ## Download an asset file Download the file that was uploaded when the asset was created by asset ID. When a file has dependencies, the file and its dependencies will be downloaded as a zip file.
   * @tags Assets
   * @name AssetDownload
   * @request GET:/tenants/{tenantId}/assets/{assetId}/file
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace AssetDownload {
    export type RequestParams = {
      /**
       * The ID of the tenant to download the asset for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to download.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Move an asset to a different folder Moves the asset to a different folder or to the root level.
   * @tags Assets
   * @name MoveAsset
   * @request PATCH:/tenants/{tenantId}/assets/{assetId}/folder
   * @secure
   * @response `200` `MoveAssetResponse` Ok
   */
  export namespace MoveAsset {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = MoveAssetRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MoveAssetResponse;
  }

  /**
   * @description ## Download an asset thumbnail Download the thumbnail generated when the asset was created by asset ID. Assets with an image or 3D file have a thumbnail. Assets with a document file do not.
   * @tags Assets
   * @name AssetThumbnail
   * @request GET:/tenants/{tenantId}/assets/{assetId}/thumbnail.png
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace AssetThumbnail {
    export type RequestParams = {
      /**
       * The ID of the tenant to download the asset for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset associated with the thumbnail you want to download.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Get 3D file dependencies
   * @tags Assets
   * @name GetAssetDependencies
   * @request GET:/tenants/{tenantId}/assets/{assetPath}/dependencies
   * @deprecated
   * @secure
   * @response `200` `GetAssetDependenciesResponse` Ok
   */
  export namespace GetAssetDependencies {
    export type RequestParams = {
      /**
       * The ID of the tenant to get the asset dependencies for.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * An [encoded](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI) asset path of a 3D file with dependencies.
       *
       * <br>This form encodes the path so you can enter unencoded text. Example path "my assembly/file1.asm" should be entered as:
       * ```
       * my assembly/file1.asm
       * ```
       */
      assetPath: AssetPath;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssetDependenciesResponse;
  }

  /**
   * @description ## Get 3D file dependencies by asset ID Returns a paginated list of child dependencies for an asset by its ID. This endpoint uses the asset's stored path internally, ensuring consistent dependency lookups even when folders have been moved or renamed.
   * @tags Assets
   * @name GetAssetDependenciesById
   * @request GET:/tenants/{tenantId}/assets/{assetId}/dependencies-by-id
   * @secure
   * @response `200` `GetAssetDependenciesResponse` Ok
   */
  export namespace GetAssetDependenciesById {
    export type RequestParams = {
      /**
       * The ID of the tenant.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to get dependencies for.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of dependencies to include in each page.
       *
       * * Must be an integer
       * * Must be greater than or equal to 1
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
      /**
       * When true, includes `excludedResolveTargetIds` in the response — the set of asset IDs
       * that would create a circular dependency if selected as a resolution target.
       * @default false
       */
      includeExcludedResolveTargets?: boolean;
      /**
       * Limits the returned dependencies by their status.
       *
       * * `all` (default): every direct dependency
       * * `missing`: dependencies whose target asset is missing, or whose resolved/matched asset
       *   itself contains missing descendants — useful for drilling into broken assemblies
       * * `available`: dependencies whose target asset is present and has no missing descendants
       */
      filter?: DependencyFilter;
      /**
       * Field to sort dependencies by.
       *
       * * `status` (default): orders MISSING first, then rows with missing descendants, then RESOLVED, then MATCHED
       * * `name`: alphabetical by filename (basename of the dependency path)
       * * `path`: alphabetical by full dependency path
       * * `occurrences`: by how many times the dependency is referenced
       */
      sortBy?: DependencySortField;
      /** Sort direction. Defaults to `DESC` for `status` and `occurrences`, `ASC` otherwise. */
      sortOrder?: SortOrder;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssetDependenciesResponse;
  }

  /**
   * @description ## Resolve a missing dependency Links a missing dependency to an existing asset. When resolved, the assembly is re-indexed with the resolved dependency.
   * @tags Assets
   * @name ResolveDependency
   * @request POST:/tenants/{tenantId}/assets/{assetId}/resolve-dependency
   * @secure
   * @response `204` `void`
   */
  export namespace ResolveDependency {
    export type RequestParams = {
      /**
       * The ID of the tenant.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the assembly asset that has the missing dependency.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = ResolveDependencyPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ## Delete metadata from an asset Delete metadata by metadata field name from an asset by asset ID.
   * @tags Assets
   * @name DeleteMetadataFromAsset
   * @request DELETE:/tenants/{tenantId}/assets/{assetId}/metadata
   * @secure
   * @response `204` `void` No content
   */
  export namespace DeleteMetadataFromAsset {
    export type RequestParams = {
      /**
       * The ID of the tenant to delete metadata from.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to delete metadata from.
       *
       * * Must be a UUID
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = DeleteMetadataFromAssetRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Find geometric matches for an asset. `matchPercentage` measures how similar is the asset to the match. A 100% match means the asset is the match.
   * @tags Assets
   * @name AssetGeometricSearch
   * @request POST:/tenants/{tenantId}/assets/{assetId}/geometric-search
   * @secure
   * @response `200` `GeometricSearchResponse` Ok
   */
  export namespace AssetGeometricSearch {
    export type RequestParams = {
      /**
       * The ID of the tenant to search for geometric matches.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to search for geometric matches.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = GeometricSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = GeometricSearchResponse;
  }

  /**
   * @description Get pairwise match scores between two assets. Returns geometric match percentages comparing how similar two 3D models are to each other. When enabled, volumetric results include a similarity percentage and may include unmatched holes, the total distance between matched hole centers, and a breakdown of mismatch volumes. Source refers to assetId and target to targetAssetId. Distances are in millimeters and volumes are in cubic millimeters. Missing detail fields indicate that the detail was not returned. Volumetric match scores must be explicitly enabled. Contact sales for more info. Both assets must be 3D models in FINISHED state.
   * @tags Assets
   * @name GetMatchScores
   * @request GET:/tenants/{tenantId}/assets/{assetId}/match-scores/{targetAssetId}
   * @secure
   * @response `200` `MatchScoresResponse` Ok
   */
  export namespace GetMatchScores {
    export type RequestParams = {
      /**
       * The ID of the tenant.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the source asset.
       *
       * * Must be a UUID
       */
      assetId: UUID;
      /**
       * The ID of the target asset to compare against.
       *
       * * Must be a UUID
       */
      targetAssetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MatchScoresResponse;
  }

  /**
   * @description Find part matches for an asset. `forwardMatchPercentage` measures how much of the asset exists in the match. A 100% forward match means 100% of the asset's geometry was found in the match; Ie. the asset is a part of the match. <br><br> `reverseMatchPercentage` measures how much of the match was found in the asset. A 100% reverse match means 100% of the match's geometry was found in the asset; Ie. the match is a part of the asset.
   * @tags Assets
   * @name AssetPartSearch
   * @request POST:/tenants/{tenantId}/assets/{assetId}/part-search
   * @secure
   * @response `200` `PartSearchResponse` Ok
   */
  export namespace AssetPartSearch {
    export type RequestParams = {
      /**
       * The ID of the tenant to search for part matches.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to search for part matches.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = PartSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PartSearchResponse;
  }

  /**
   * @description ## Search for visual matches by asset A multi-modal search that returns a list of assets that visually match the given asset ID.
   * @tags Assets
   * @name AssetVisualSearch
   * @request POST:/tenants/{tenantId}/assets/{assetId}/visual-search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace AssetVisualSearch {
    export type RequestParams = {
      /**
       * The ID of the tenant to search for visual matches.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to search for visual matches.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format int32
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = AssetVisualSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }

  /**
   * @description ## Download geometric search results Server-side export of geometric search results as CSV or XLSX. The request body matches the geometric-search endpoint so the export reflects exactly the filters the user is viewing.
   * @tags Assets
   * @name AssetGeometricSearchExport
   * @request POST:/tenants/{tenantId}/assets/{assetId}/geometric-search/file
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace AssetGeometricSearchExport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {
      /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
      format: "csv" | "xlsx";
      /**
       * Tenant that owns the source asset, when different from the search tenant (cross-tenant search).
       * Defaults to the path tenantId.
       */
      assetTenantId?: UUID;
    };
    export type RequestBody = GeometricSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Download part search results Server-side export of part search results as CSV or XLSX.
   * @tags Assets
   * @name AssetPartSearchExport
   * @request POST:/tenants/{tenantId}/assets/{assetId}/part-search/file
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace AssetPartSearchExport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {
      /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
      format: "csv" | "xlsx";
      /** Tenant that owns the source asset, when different from the search tenant. */
      assetTenantId?: UUID;
    };
    export type RequestBody = PartSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Download visual search results Server-side export of visual search results as CSV or XLSX.
   * @tags Assets
   * @name AssetVisualSearchExport
   * @request POST:/tenants/{tenantId}/assets/{assetId}/visual-search/file
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace AssetVisualSearchExport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      assetId: UUID;
    };
    export type RequestQuery = {
      /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
      format: "csv" | "xlsx";
      /** Tenant that owns the source asset, when different from the search tenant. */
      assetTenantId?: UUID;
    };
    export type RequestBody = AssetVisualSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Download text search results Server-side export of text search results as CSV or XLSX. Text search matches a query rather than a source asset, so the file holds one row per matched asset: no reference columns, no match percentages and no comparison link.
   * @tags Assets
   * @name TextSearchExport
   * @request POST:/tenants/{tenantId}/assets/text-search/file
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace TextSearchExport {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {
      /** Format of the download. 'csv' for CSV files and 'xlsx' for Excel files. */
      format: "csv" | "xlsx";
    };
    export type RequestBody = SearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }

  /**
   * @description ## Composite Search Multi-modal search that combines geometric, visual, and other search modalities to find the most relevant matches.
   * @tags Assets
   * @name AssetCompositeSearch
   * @request POST:/tenants/{tenantId}/assets/{assetId}/search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace AssetCompositeSearch {
    export type RequestParams = {
      /**
       * The ID of the tenant to search for composite matches.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
      /**
       * The ID of the asset to search for composite matches.
       *
       * * Must be a UUID
       *
       * *Default value*: undefined
       */
      assetId: UUID;
    };
    export type RequestQuery = {
      /**
       * A one-based page number used in conjunction with `perPage`.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       * @format double
       * @default 1
       */
      page?: number;
      /**
       * The number of assets to include in each page.
       *
       * * Must be an integer
       *
       * * Must be greater than or equal to 1
       *
       * * Must be less than or equal to 1000
       * @format int32
       * @min 1
       * @max 1000
       * @default 20
       */
      perPage?: number;
    };
    export type RequestBody = SearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }

  /**
   * @description ## Segment an image into regions Analyzes an image and divides it into distinct regions using automatic segmentation. Each region is assigned a unique ID and pixel count. The response includes a base64-encoded region map (`Uint16Array`) where each pixel maps to its region ID. ### Region map The `regionMap` field is a base64-encoded binary buffer. Decode it to a `Uint16Array` of length `width * height`. Each element is the region ID for that pixel in row-major order. ``` const bytes = Uint8Array.from(atob(regionMap), c => c.charCodeAt(0)); const map = new Uint16Array(bytes.buffer); const regionIdAtXY = map[y * width + x]; ``` ### Parameters - **pointsPerSide** controls how many regions the image is divided into (2–64, default 32). Lower values produce fewer, larger regions. - **sensitivity** controls how precisely region boundaries follow edges (0–100, default 50). Higher values produce tighter boundaries. ### Constraints - File must be an image (`image/*` MIME type) - Maximum file size: 20 MB
   * @tags Assets
   * @name SegmentImage
   * @request POST:/tenants/{tenantId}/assets/segment
   * @secure
   * @response `200` `SegmentationResult` Ok
   */
  export namespace SegmentImage {
    export type RequestParams = {
      /** The ID of the tenant. */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = SegmentImagePayload;
    export type RequestHeaders = {};
    export type ResponseBody = SegmentationResult;
  }
}

export namespace CrossTenant {
  /**
   * @description ## Search Asset keyword search with filters.
   * @tags Cross-tenant, Assets
   * @name TextSearch
   * @request POST:/tenants/{tenantId}/assets/text-search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace TextSearch {
    export type RequestParams = {
      /**
       * The ID of the tenant to search for text matches.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = SearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }

  /**
   * @description ## Search for assets matching uploaded image files A multi-modal search that returns a list of assets that visually match the image files uploaded. Supports single or multiple image uploads for combined visual search.
   * @tags Cross-tenant, Assets
   * @name VisualSearch
   * @request POST:/tenants/{tenantId}/assets/visual-search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace VisualSearch {
    export type RequestParams = {
      /**
       * The ID of the tenant to search for visual matches.
       *
       * * Must be a UUID
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = VisualSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }

  /**
   * @description ## Cross-tenant visual search for an asset A multi-modal search that returns a list of assets that visually match the given asset ID.
   * @tags Cross-tenant, Assets
   * @name CrossTenantVisualSearch
   * @request POST:/tenants/assets/visual-search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace CrossTenantVisualSearch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CrossTenantAssetVisualSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }

  /**
   * @description ## Cross-tenant geometric search for an asset A multi-modal search that returns a list of assets that geometrically match the given asset ID.
   * @tags Cross-tenant, Assets
   * @name CrossTenantGeometricSearch
   * @request POST:/tenants/assets/geometric-search
   * @secure
   * @response `200` `GeometricSearchResponse` Ok
   */
  export namespace CrossTenantGeometricSearch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CrossTenantGeometricSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = GeometricSearchResponse;
  }

  /**
   * @description ## Cross-tenant part search for an asset A multi-modal search that returns a list of assets that part match the given asset ID.
   * @tags Cross-tenant, Assets
   * @name CrossTenantPartSearch
   * @request POST:/tenants/assets/part-search
   * @secure
   * @response `200` `PartSearchResponse` Ok
   */
  export namespace CrossTenantPartSearch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CrossTenantPartSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PartSearchResponse;
  }

  /**
   * @description ## Cross-tenant metadata search for an asset
   * @tags Cross-tenant, Assets
   * @name CrossTenantMetadataSearch
   * @request POST:/tenants/assets/metadata-search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace CrossTenantMetadataSearch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CrossTenantSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }

  /**
   * @description ## Cross-tenant Composite Search Multi-modal search that combines geometric, visual, and other search modalities to find the most relevant matches.
   * @tags Cross-tenant, Assets
   * @name CrossTenantCompositeSearch
   * @request POST:/tenants/assets/search
   * @secure
   * @response `200` `AssetSearchResponse` Ok
   */
  export namespace CrossTenantCompositeSearch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CrossTenantSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AssetSearchResponse;
  }
}

export namespace ArchiveDownloads {
  /**
   * @description ## Preview an archive download Returns the file and subfolder counts that a matching [archive download](#/Archive%20downloads/DownloadArchive) would produce for the given selection. Use this to show a confirmation UI before starting the download. Selected folders are included recursively; selected assets are included individually. The response also includes the hard caps (2,000 files, 2 GiB total size) enforced at download time.
   * @tags Archive downloads
   * @name PreviewArchiveDownload
   * @request POST:/tenants/{tenantId}/archive-downloads/preview
   * @secure
   * @response `200` `ArchiveDownloadPreviewResponse` Ok
   */
  export namespace PreviewArchiveDownload {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = ArchiveDownloadRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ArchiveDownloadPreviewResponse;
  }

  /**
   * @description ## Download a ZIP archive Streams a ZIP archive of the selected folders and assets. Folders are included recursively; assemblies are archived as their dependency bundle, or as the raw source file when a bundle is not available. Selections are capped at 2,000 files and 2 GiB total size; larger selections are rejected before streaming begins.
   * @tags Archive downloads
   * @name DownloadArchive
   * @request POST:/tenants/{tenantId}/archive-downloads
   * @secure
   * @response `200` `UUID` Ok
   */
  export namespace DownloadArchive {
    export type RequestParams = {
      /**
       * Stringified UUIDv4 or UUIDv5.
       * See [RFC 4112](https://tools.ietf.org/html/rfc4122)
       */
      tenantId: UUID;
    };
    export type RequestQuery = {};
    export type RequestBody = ArchiveDownloadRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UUID;
  }
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "/v3",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Physna API
 * @version 1.0.40
 * @license UNLICENSED
 * @baseUrl /v3
 * @contact Support <support@physna.com>
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  viewer = {
    /**
     * @description ## Request html for the embeddable asset viewer This endpoint enables embedding a viewer for a single asset. Our viewer supports the different assets we support: 3d models, images/gifs, and PDF and plain-text documents. Other documents, such as Office files, show their file name without a preview; download them with [Download asset](#/Assets/AssetDownload). The viewer is chosen from the asset's type. Scans and scenes are ingestible but not viewable, and this endpoint reports them as such. The viewer works by setting the src of an iframe to this endpoint. ### Theming Use the `theme` query parameter (`light` or `dark`) to set the viewer's initial color scheme. Defaults to `light`. To switch themes at runtime without reloading the iframe, also include the optional `parentOrigin` query parameter. Set it to the origin of the page that is embedding the viewer (the scheme and host, for example `https://app.example.com`). Without `parentOrigin`, the theme can only be changed by reloading the iframe with a new `theme` value. <br> Example: ``` <iframe id="viewer"></iframe> <script> const tenantId = 'cc9e68d7-7621-427f-8468-a9c26c80a7e5'; const assetId = '123e4567-e89b-12d3-a456-426614174000'; const token = await fetch(https://api.physna.com/v3/viewer/token).then(res => res.json()); const viewer = document.getElementById('viewer'); viewer.src = `https://api.physna.com/v3/tenants/${tenantId}/viewer/asset?assetId=${assetId}&token=${token}&theme=dark&parentOrigin=${window.location.origin}`; </script> ```
     *
     * @tags Viewer
     * @name ModelViewer
     * @request GET:/tenants/{tenantId}/viewer/asset
     * @response `204` `void` No content
     */
    modelViewer: (
      { tenantId, ...query }: ModelViewerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/viewer/asset`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description ## Request html for the embeddable comparison viewer This endpoint enables embedding a comparison viewer to compare two different 3d assets. Side by side supports 3d models and manifests. The overlay and heatmap comparisons need two finished 3d models. The viewer works by setting the src of an iframe to this endpoint. ### Theming Use the `theme` query parameter (`light` or `dark`) to set the viewer's initial color scheme. Defaults to `light`. To switch themes at runtime without reloading the iframe, also include the optional `parentOrigin` query parameter. Set it to the origin of the page that is embedding the viewer (the scheme and host, for example `https://app.example.com`). Without `parentOrigin`, the theme can only be changed by reloading the iframe with a new `theme` value. <br> Example: ``` <iframe id="viewer"></iframe> <script> const tenantId = 'cc9e68d7-7621-427f-8468-a9c26c80a7e5'; const asset1Id = '123e4567-e89b-12d3-a456-426614174000'; const asset2Id = '123e4567-e89b-12d3-a456-426614174000'; const token = await fetch(https://api.physna.com/v3/viewer/token).then(res => res.json()); const viewer = document.getElementById('viewer'); viewer.src = `https://api.physna.com/v3/tenants/${tenantId}/viewer/comparison?asset1Id=${asset1Id}&asset2Id=${asset2Id}&token=${token}&theme=dark&parentOrigin=${window.location.origin}`; </script> ```
     *
     * @tags Viewer
     * @name Comparison
     * @request GET:/tenants/{tenantId}/viewer/comparison
     * @response `200` `void` The embeddable comparison viewer HTML
     */
    comparison: (
      { tenantId, ...query }: ComparisonParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/viewer/comparison`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
 * @description ## Request a viewer token Viewer tokens are used to access the viewer UI. A valid token needs to be added to the viewer request query string.
 *
 * @tags Viewer
 * @name ViewerToken
 * @request POST:/viewer/token
 * @secure
 * @response `200` `{
    token: string,

}` Ok
 */
    viewerToken: (params: RequestParams = {}) =>
      this.http.request<
        {
          token: string;
        },
        any
      >({
        path: `/viewer/token`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
 * @description ## Create a new user Creates a new user with the specified email address.
 *
 * @tags Users
 * @name CreateUser
 * @request POST:/tenants/{tenantId}/users
 * @secure
 * @response `200` `{
    user: User,

}` Ok
 */
    createUser: (
      tenantId: UUID,
      data: CreateUserRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        {
          user: User;
        },
        any
      >({
        path: `/tenants/${tenantId}/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description ## List tenant users Returns a paginated list of users.
 *
 * @tags Users
 * @name ListTenantUsers
 * @request GET:/tenants/{tenantId}/users
 * @secure
 * @response `200` `{
    pageData: PageData,
    users: (User)[],

}` Ok
 */
    listTenantUsers: (
      { tenantId, ...query }: ListTenantUsersParams,
      params: RequestParams = {},
    ) =>
      this.http.request<
        {
          pageData: PageData;
          users: User[];
        },
        any
      >({
        path: `/tenants/${tenantId}/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description ## Get a user Retrieves a user by their ID.
 *
 * @tags Users
 * @name GetUser
 * @request GET:/tenants/{tenantId}/users/{userId}
 * @secure
 * @response `200` `{
    user: User,

}` Ok
 */
    getUser: (tenantId: UUID, userId: UUID, params: RequestParams = {}) =>
      this.http.request<
        {
          user: User;
        },
        any
      >({
        path: `/tenants/${tenantId}/users/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description ## Update a user Updates a user's tenant role and/or enabled status. At least one of tenantRole or enabled must be provided.
 *
 * @tags Users
 * @name UpdateUser
 * @request PATCH:/tenants/{tenantId}/users/{userId}
 * @secure
 * @response `200` `{
    user: User,

}` Ok
 */
    updateUser: (
      tenantId: UUID,
      userId: UUID,
      data: UpdateUserRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        {
          user: User;
        },
        any
      >({
        path: `/tenants/${tenantId}/users/${userId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete a user Deletes a user's tenant role. If the user has no remaining tenant roles, the user will be completely deleted from the system.
     *
     * @tags Users
     * @name DeleteUser
     * @request DELETE:/tenants/{tenantId}/users/{userId}
     * @secure
     * @response `204` `void` No content
     */
    deleteUser: (tenantId: UUID, userId: UUID, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/users/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
 * @description ## Get my user information Retrieves your user information.
 *
 * @tags Users
 * @name GetCurrentUser
 * @request GET:/users/me
 * @secure
 * @response `200` `{
    user: MyUser,

}` Ok
 */
    getCurrentUser: (params: RequestParams = {}) =>
      this.http.request<
        {
          user: MyUser;
        },
        any
      >({
        path: `/users/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description ## Create a user service account Creates a user service account for the specified user.
 *
 * @tags Users
 * @name CreateUserServiceAccount
 * @request POST:/users/me/service-accounts
 * @secure
 * @response `200` `{
    serviceAccount: UserServiceAccountWithSecret,

}` Ok
 */
    createUserServiceAccount: (
      data: CreateUserServiceAccountRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        {
          serviceAccount: UserServiceAccountWithSecret;
        },
        any
      >({
        path: `/users/me/service-accounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description ## List user service accounts Retrieves all service accounts for a specific user within a tenant.
 *
 * @tags Users
 * @name ListUserServiceAccounts
 * @request GET:/users/me/service-accounts
 * @secure
 * @response `200` `{
    serviceAccounts?: UserServiceAccount,

}` Ok
 */
    listUserServiceAccounts: (params: RequestParams = {}) =>
      this.http.request<
        {
          serviceAccounts?: UserServiceAccount;
        },
        any
      >({
        path: `/users/me/service-accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description ## Get a user service account Retrieves a specific service account for a user by its ID.
 *
 * @tags Users
 * @name GetUserServiceAccount
 * @request GET:/users/me/service-accounts/{serviceAccountId}
 * @secure
 * @response `200` `{
    serviceAccount: UserServiceAccount,

}` Ok
 */
    getUserServiceAccount: (
      serviceAccountId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<
        {
          serviceAccount: UserServiceAccount;
        },
        any
      >({
        path: `/users/me/service-accounts/${serviceAccountId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete a user service account Deletes a user service account by its ID.
     *
     * @tags Users
     * @name DeleteUserServiceAccount
     * @request DELETE:/users/me/service-accounts/{serviceAccountId}
     * @secure
     * @response `204` `void` No content
     */
    deleteUserServiceAccount: (
      serviceAccountId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/users/me/service-accounts/${serviceAccountId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  tenantDashboard = {
    /**
     * @description ## Get dashboard version Returns a token that changes when the tenant's dashboard data changes. Poll this instead of re-running every panel's aggregation, and refetch the panels only when the token moves. The token is opaque and only meaningful compared against a previous value from the same tenant.
     *
     * @tags Tenant Dashboard
     * @name GetDashboardVersion
     * @request GET:/tenants/{tenantId}/dashboard-version
     * @secure
     * @response `200` `DashboardVersionResponse` Ok
     */
    getDashboardVersion: (tenantId: UUID, params: RequestParams = {}) =>
      this.http.request<DashboardVersionResponse, any>({
        path: `/tenants/${tenantId}/dashboard-version`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tenantActivityMetrics = {
    /**
     * @description ## Get activity metrics Returns how much a tenant used Physna between `from` and `to`, inclusive, counted per UTC day: searches, compares, downloads, uploads, reports and distinct active users, as totals plus a daily series, and a per-feature usage count covering folder browsing and management, metadata edits, 3D viewer opens and taxonomy work as well. Active users are counts only; no user is identified. The range must not exceed 366 days. Action counting starts when the feature is deployed; uploads and reports are read from their own records and cover all history. Requires the tenant admin role.
     *
     * @tags Tenant Activity Metrics
     * @name GetTenantActivityMetrics
     * @request GET:/tenants/{tenantId}/activity-metrics
     * @secure
     * @response `200` `TenantActivityMetricsResponse` Ok
     */
    getTenantActivityMetrics: (
      { tenantId, ...query }: GetTenantActivityMetricsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<TenantActivityMetricsResponse, any>({
        path: `/tenants/${tenantId}/activity-metrics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  taxonomy = {
    /**
     * @description ## Create a taxonomy node Creates a new node in the taxonomy. Omit `parentNodeId` to create a root node. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name CreateTaxonomyNode
     * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes
     * @secure
     * @response `201` `CreateTaxonomyNodeResponse` Created
     */
    createTaxonomyNode: (
      tenantId: UUID,
      taxonomyId: UUID,
      data: CreateTaxonomyNodeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateTaxonomyNodeResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List taxonomy nodes Returns a paginated list of nodes in the taxonomy. Use `parentNodeId` to filter: pass `root` for root nodes only, or a node ID for children of that node. Omit to get all nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name ListTaxonomyNodes
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes
     * @secure
     * @response `200` `ListTaxonomyNodesResponse` Ok
     */
    listTaxonomyNodes: (
      { tenantId, taxonomyId, ...query }: ListTaxonomyNodesParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListTaxonomyNodesResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Import taxonomy nodes Bulk-creates a hierarchy of nodes in an empty taxonomy from a tree structure. The entire import is atomic — if any validation fails, no nodes are created. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name ImportTaxonomyNodes
     * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/import
     * @secure
     * @response `201` `ImportTaxonomyNodesResponse` Created
     */
    importTaxonomyNodes: (
      tenantId: UUID,
      taxonomyId: UUID,
      data: ImportTaxonomyNodesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ImportTaxonomyNodesResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Reimport taxonomy nodes Replaces the taxonomy by applying a diff: adds new nodes, removes nodes not in the new tree (unless kept), and moves nodes to new parents. Labels on removed nodes are deleted. The entire operation is atomic. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name ReimportTaxonomyNodes
     * @request PUT:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/import
     * @secure
     * @response `200` `ReimportTaxonomyNodesResponse` Ok
     */
    reimportTaxonomyNodes: (
      tenantId: UUID,
      taxonomyId: UUID,
      data: ReimportTaxonomyNodesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ReimportTaxonomyNodesResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/import`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Diff taxonomy import Computes the diff between the provided CSV tree and the existing taxonomy. Returns additions, removals (with label counts), moves, and unchanged count. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name DiffTaxonomyImport
     * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/import/diff
     * @secure
     * @response `200` `DiffTaxonomyImportResponse` Ok
     */
    diffTaxonomyImport: (
      tenantId: UUID,
      taxonomyId: UUID,
      data: DiffTaxonomyImportRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DiffTaxonomyImportResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/import/diff`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Search taxonomy nodes Searches for leaf nodes by name across all tree depths. Returns matching nodes with their ancestor paths for breadcrumb display. **Route ordering**: This method must be declared before `getTaxonomyNode` (`{nodeId}`) so that TSOA registers the literal `/search` route first, preventing Express from matching it as a `nodeId` parameter. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name SearchTaxonomyNodes
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/search
     * @secure
     * @response `200` `SearchTaxonomyNodesResponse` Ok
     */
    searchTaxonomyNodes: (
      { tenantId, taxonomyId, ...query }: SearchTaxonomyNodesParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SearchTaxonomyNodesResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Export taxonomy nodes Exports all nodes in the taxonomy as a CSV or Excel file using the column-per-level format (Level 1, Level 2, ...). One row per leaf node. **Route ordering**: This method must be declared before `getTaxonomyNode` (`{nodeId}`) so that TSOA registers the literal `/export` route first, preventing Express from matching it as a `nodeId` parameter. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name ExportTaxonomyNodes
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/export
     * @secure
     * @response `200` `UUID` Ok
     */
    exportTaxonomyNodes: (
      { tenantId, taxonomyId, ...query }: ExportTaxonomyNodesParams,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ## Get node ancestors Returns the ancestor path for a taxonomy node, from the node itself up to the root. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name GetNodeAncestors
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/ancestors
     * @secure
     * @response `200` `GetNodeAncestorsResponse` Ok
     */
    getNodeAncestors: (
      tenantId: UUID,
      taxonomyId: UUID,
      nodeId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetNodeAncestorsResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/${nodeId}/ancestors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get a taxonomy node Returns a single taxonomy node by ID. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name GetTaxonomyNode
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}
     * @secure
     * @response `200` `GetTaxonomyNodeResponse` Ok
     */
    getTaxonomyNode: (
      tenantId: UUID,
      taxonomyId: UUID,
      nodeId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetTaxonomyNodeResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/${nodeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete a taxonomy node Soft-deletes a taxonomy node and all its descendants. Fails if the node or any descendant has assigned labels. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name DeleteTaxonomyNode
     * @request DELETE:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}
     * @secure
     * @response `204` `void` No Content
     */
    deleteTaxonomyNode: (
      tenantId: UUID,
      taxonomyId: UUID,
      nodeId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/${nodeId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## List labels for a taxonomy node Returns a paginated list of labels assigned to this node. Use `includeDescendants` to also include labels from all descendant nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name ListLabelsByNode
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/labels
     * @secure
     * @response `200` `ListLabelsByNodeResponse` Ok
     */
    listLabelsByNode: (
      { tenantId, taxonomyId, nodeId, ...query }: ListLabelsByNodeParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListLabelsByNodeResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/${nodeId}/labels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Rename a taxonomy node Updates the node's name. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name RenameTaxonomyNode
     * @request PATCH:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/name
     * @secure
     * @response `200` `UpdateTaxonomyNodeResponse` Ok
     */
    renameTaxonomyNode: (
      tenantId: UUID,
      taxonomyId: UUID,
      nodeId: UUID,
      data: RenameTaxonomyNodeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UpdateTaxonomyNodeResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/${nodeId}/name`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Move a taxonomy node Moves the node to a different parent. Pass `root` to move to root. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name MoveTaxonomyNode
     * @request PATCH:/tenants/{tenantId}/taxonomies/{taxonomyId}/nodes/{nodeId}/parent
     * @secure
     * @response `200` `UpdateTaxonomyNodeResponse` Ok
     */
    moveTaxonomyNode: (
      tenantId: UUID,
      taxonomyId: UUID,
      nodeId: UUID,
      data: MoveTaxonomyNodeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UpdateTaxonomyNodeResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/nodes/${nodeId}/parent`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Create a taxonomy Creates a new taxonomy for the tenant. Only one taxonomy is allowed per tenant. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name CreateTaxonomy
     * @request POST:/tenants/{tenantId}/taxonomies
     * @secure
     * @response `201` `CreateTaxonomyResponse` Created
     */
    createTaxonomy: (
      tenantId: UUID,
      data: CreateTaxonomyRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateTaxonomyResponse, any>({
        path: `/tenants/${tenantId}/taxonomies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List the tenant's taxonomies Returns every taxonomy belonging to the tenant. Today there is at most one taxonomy per tenant, so this returns either an empty array or a single-entry array. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name ListTaxonomies
     * @request GET:/tenants/{tenantId}/taxonomies
     * @secure
     * @response `200` `ListTaxonomiesResponse` Ok
     */
    listTaxonomies: (tenantId: UUID, params: RequestParams = {}) =>
      this.http.request<ListTaxonomiesResponse, any>({
        path: `/tenants/${tenantId}/taxonomies`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Update a taxonomy Updates settings on an existing taxonomy. Supports renaming and toggling the auto-label opt-in flag. At least one field must be provided. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name UpdateTaxonomy
     * @request PATCH:/tenants/{tenantId}/taxonomies/{taxonomyId}
     * @secure
     * @response `200` `UpdateTaxonomyResponse` Ok
     */
    updateTaxonomy: (
      tenantId: UUID,
      taxonomyId: UUID,
      data: UpdateTaxonomyRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UpdateTaxonomyResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get a taxonomy Returns a single taxonomy by ID. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name GetTaxonomy
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}
     * @secure
     * @response `200` `GetTaxonomyResponse` Ok
     */
    getTaxonomy: (
      tenantId: UUID,
      taxonomyId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetTaxonomyResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete a taxonomy Deletes a taxonomy by ID. The taxonomy must have no existing nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name DeleteTaxonomy
     * @request DELETE:/tenants/{tenantId}/taxonomies/{taxonomyId}
     * @secure
     * @response `204` `void` No content
     */
    deleteTaxonomy: (
      tenantId: UUID,
      taxonomyId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Start an auto-label library job Kicks off background classification of every finished asset in the tenant. Returns immediately with a job ID; the caller polls `GET .../auto-label-library/jobs/{jobId}` for progress. User-assigned labels are always preserved. Returns 409 if a job is already in progress for this taxonomy. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name StartAutoLabelLibrary
     * @request POST:/tenants/{tenantId}/taxonomies/{taxonomyId}/auto-label-library
     * @secure
     * @response `202` `StartAutoLabelLibraryResponse` Accepted
     */
    startAutoLabelLibrary: (
      tenantId: UUID,
      taxonomyId: UUID,
      data?: AutoLabelLibraryRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<StartAutoLabelLibraryResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/auto-label-library`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get the active auto-label library job for the taxonomy Returns the currently active (PENDING or RUNNING) job for the taxonomy, or `{ job: undefined }` if none is in flight. Used by the UI on page mount to recover progress visibility for jobs that started in another session. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name GetActiveAutoLabelLibraryJob
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/auto-label-library
     * @secure
     * @response `200` `GetActiveAutoLabelLibraryJobResponse` Ok
     */
    getActiveAutoLabelLibraryJob: (
      tenantId: UUID,
      taxonomyId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetActiveAutoLabelLibraryJobResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/auto-label-library`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get an auto-label library job Returns the current status, progress, and counts for the given job. Used by the UI to poll until the job reaches a terminal state. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Taxonomy
     * @name GetAutoLabelLibraryJob
     * @request GET:/tenants/{tenantId}/taxonomies/{taxonomyId}/auto-label-library/jobs/{jobId}
     * @secure
     * @response `200` `GetAutoLabelLibraryJobResponse` Ok
     */
    getAutoLabelLibraryJob: (
      tenantId: UUID,
      taxonomyId: UUID,
      jobId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetAutoLabelLibraryJobResponse, any>({
        path: `/tenants/${tenantId}/taxonomies/${taxonomyId}/auto-label-library/jobs/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * @description ## Create a new duplication report Creates a new duplication detection report with the specified threshold settings. Duplication reports help identify similar 3D assets in your catalog.
     *
     * @tags Reports
     * @name CreateDuplicationReport
     * @request POST:/tenants/{tenantId}/reports/duplication
     * @secure
     * @response `201` `CreateReportResponse` Created
     */
    createDuplicationReport: (
      tenantId: UUID,
      data: CreateDuplicationReportRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateReportResponse, any>({
        path: `/tenants/${tenantId}/reports/duplication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Create a new simplification report Creates a new simplification detection report with the specified threshold settings. Simplification reports help identify simplified versions of 3D assets in your catalog.
     *
     * @tags Reports
     * @name CreateSimplificationReport
     * @request POST:/tenants/{tenantId}/reports/simplification
     * @secure
     * @response `201` `CreateReportResponse` Created
     */
    createSimplificationReport: (
      tenantId: UUID,
      data: CreateSimplificationReportRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateReportResponse, any>({
        path: `/tenants/${tenantId}/reports/simplification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Create a new custom report Creates a new custom report with flexible parameters and the specified threshold settings. Custom reports allow for flexible analysis of 3D assets in your catalog.
     *
     * @tags Reports
     * @name CreateCustomReport
     * @request POST:/tenants/{tenantId}/reports/custom
     * @secure
     * @response `201` `CreateReportResponse` Created
     */
    createCustomReport: (
      tenantId: UUID,
      data: CreateCustomReportRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateReportResponse, any>({
        path: `/tenants/${tenantId}/reports/custom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List reports Returns a paginated list of reports with optional filtering.
     *
     * @tags Reports
     * @name ListReports
     * @request GET:/tenants/{tenantId}/reports
     * @secure
     * @response `200` `ListReportsResponse` Ok
     */
    listReports: (
      { tenantId, ...query }: ListReportsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListReportsResponse, any>({
        path: `/tenants/${tenantId}/reports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get a report Returns a report by ID.
     *
     * @tags Reports
     * @name GetReport
     * @request GET:/tenants/{tenantId}/reports/{id}
     * @secure
     * @response `200` `GetReportResponse` Ok
     */
    getReport: (tenantId: UUID, id: UUID, params: RequestParams = {}) =>
      this.http.request<GetReportResponse, any>({
        path: `/tenants/${tenantId}/reports/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Rename a report Updates the name of a report.
     *
     * @tags Reports
     * @name UpdateReport
     * @request PATCH:/tenants/{tenantId}/reports/{id}
     * @secure
     * @response `200` `UpdateReportResponse` Ok
     */
    updateReport: (
      tenantId: UUID,
      id: UUID,
      data: UpdateReportRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UpdateReportResponse, any>({
        path: `/tenants/${tenantId}/reports/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete a report Deletes a report by ID. This operation cannot be undone. All associated report groups and group assets will also be deleted.
     *
     * @tags Reports
     * @name DeleteReport
     * @request DELETE:/tenants/{tenantId}/reports/{id}
     * @secure
     * @response `204` `void` No Content
     */
    deleteReport: (tenantId: UUID, id: UUID, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/reports/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Get failure diagnostics for a report Looks up why a failed report failed by searching the job service logs on demand. Nothing is persisted; the answer is only as durable as log retention.
     *
     * @tags Reports
     * @name GetReportFailureDiagnostics
     * @request GET:/tenants/{tenantId}/reports/{id}/failure-diagnostics
     * @secure
     * @response `200` `FailureDiagnosticsResponse` Ok
     */
    getReportFailureDiagnostics: (
      tenantId: UUID,
      id: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<FailureDiagnosticsResponse, any>({
        path: `/tenants/${tenantId}/reports/${id}/failure-diagnostics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get report groups Returns a paginated list of report groups for a specific report. Each group contains related assets identified by the report analysis.
     *
     * @tags Reports
     * @name GetReportGroups
     * @request GET:/tenants/{tenantId}/reports/{id}/groups
     * @secure
     * @response `200` `ListReportGroupsResponse` Ok
     */
    getReportGroups: (
      { tenantId, id, ...query }: GetReportGroupsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListReportGroupsResponse, any>({
        path: `/tenants/${tenantId}/reports/${id}/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Create report group Creates a new empty report group. Groups organize assets within a report for easier management. Use the add asset endpoint to add assets to the group.
     *
     * @tags Reports
     * @name CreateReportGroup
     * @request POST:/tenants/{tenantId}/reports/{reportId}/groups
     * @secure
     * @response `201` `CreateReportGroupResponse` Created
     */
    createReportGroup: (
      tenantId: UUID,
      reportId: UUID,
      data: CreateReportGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateReportGroupResponse, any>({
        path: `/tenants/${tenantId}/reports/${reportId}/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Update report group name Updates the name of a report group. Group names provide meaningful context for asset collections identified by the report analysis.
     *
     * @tags Reports
     * @name UpdateReportGroupName
     * @request PATCH:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}
     * @secure
     * @response `200` `UpdateReportGroupResponse` Ok
     */
    updateReportGroupName: (
      tenantId: UUID,
      reportId: UUID,
      groupId: UUID,
      data: UpdateReportGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UpdateReportGroupResponse, any>({
        path: `/tenants/${tenantId}/reports/${reportId}/groups/${groupId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete report group Deletes a report group and all associated assets. This operation cannot be undone.
     *
     * @tags Reports
     * @name DeleteReportGroup
     * @request DELETE:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}
     * @secure
     * @response `204` `void` No Content
     */
    deleteReportGroup: (
      tenantId: UUID,
      reportId: UUID,
      groupId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/reports/${reportId}/groups/${groupId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## List report group assets Returns a paginated list of assets for a specific report group.
     *
     * @tags Reports
     * @name ListReportGroupAssets
     * @request GET:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}/assets
     * @secure
     * @response `200` `ListReportGroupAssetsResponse` Ok
     */
    listReportGroupAssets: (
      { tenantId, reportId, groupId, ...query }: ListReportGroupAssetsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListReportGroupAssetsResponse, any>({
        path: `/tenants/${tenantId}/reports/${reportId}/groups/${groupId}/assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Add asset to report group Adds an asset to a report group. The asset can be in another group or not in any group. To move an asset between groups, first remove it from the source group, then add it to the target group.
     *
     * @tags Reports
     * @name AddAssetToReportGroup
     * @request POST:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}/assets
     * @secure
     * @response `204` `void` No Content
     */
    addAssetToReportGroup: (
      tenantId: UUID,
      reportId: UUID,
      groupId: UUID,
      data: AddAssetToGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/reports/${reportId}/groups/${groupId}/assets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Remove asset from report group Removes an asset from a report group. The group will remain even if it becomes empty.
     *
     * @tags Reports
     * @name RemoveAssetFromReportGroup
     * @request DELETE:/tenants/{tenantId}/reports/{reportId}/groups/{groupId}/assets/{assetId}
     * @secure
     * @response `204` `void` No Content
     */
    removeAssetFromReportGroup: (
      tenantId: UUID,
      reportId: UUID,
      groupId: UUID,
      assetId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/reports/${reportId}/groups/${groupId}/assets/${assetId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Download report file Downloads the report data as a CSV or XLSX file. The report must be in COMPLETED status.
     *
     * @tags Reports
     * @name DownloadReport
     * @request GET:/tenants/{tenantId}/reports/{id}/file
     * @secure
     * @response `200` `UUID` Ok
     */
    downloadReport: (
      { tenantId, id, ...query }: DownloadReportParams,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/reports/${id}/file`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  metadata = {
    /**
     * @description ## Create a new metadata field Metadata fields are used to annotate assets for [multi-modal searching](#/Assets/AssetVisualSearch). To create a metadata field, provide a JSON object with a unique name and a type.
     *
     * @tags Metadata
     * @name CreateMetadataField
     * @request POST:/tenants/{tenantId}/metadata-fields
     * @secure
     * @response `200` `CreateMetadataFieldResponse` Ok
     */
    createMetadataField: (
      tenantId: UUID,
      data: CreateMetadataFieldRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateMetadataFieldResponse, any>({
        path: `/tenants/${tenantId}/metadata-fields`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List metadata fields Returns a paginated list of all metadata fields.
     *
     * @tags Metadata
     * @name ListMetadataFields
     * @request GET:/tenants/{tenantId}/metadata-fields
     * @secure
     * @response `200` `ListMetadataFieldsResponse` Ok
     */
    listMetadataFields: (
      { tenantId, ...query }: ListMetadataFieldsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListMetadataFieldsResponse, any>({
        path: `/tenants/${tenantId}/metadata-fields`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get a metadata field Returns the metadata field name and type.
     *
     * @tags Metadata
     * @name GetMetadataField
     * @request GET:/tenants/{tenantId}/metadata-fields/{fieldId}
     * @secure
     * @response `200` `GetMetadataFieldResponse` Ok
     */
    getMetadataField: (
      tenantId: UUID,
      fieldId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetMetadataFieldResponse, any>({
        path: `/tenants/${tenantId}/metadata-fields/${fieldId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete a metadata field Deletes a metadata field by ID. By default, this will return an error when a metadata field is used by assets. Use the `force` query parameter to delete the field and remove all associated metadata values from assets.
     *
     * @tags Metadata
     * @name DeleteMetadataField
     * @request DELETE:/tenants/{tenantId}/metadata-fields/{fieldId}
     * @secure
     * @response `204` `void` No content
     */
    deleteMetadataField: (
      { tenantId, fieldId, ...query }: DeleteMetadataFieldParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/metadata-fields/${fieldId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ## Update a metadata field name Updates a metadata field's name by field ID.
     *
     * @tags Metadata
     * @name UpdateMetadataField
     * @request PATCH:/tenants/{tenantId}/metadata-fields/{fieldId}
     * @secure
     * @response `204` `void` No content
     */
    updateMetadataField: (
      tenantId: UUID,
      fieldId: UUID,
      data: UpdateMetadataFieldRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/metadata-fields/${fieldId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## List assets using a metadata field Returns a paginated list of assets that have a value assigned to the metadata field.
     *
     * @tags Metadata
     * @name ListAssetsUsingMetadataField
     * @request GET:/tenants/{tenantId}/metadata-fields/{fieldId}/assets
     * @secure
     * @response `200` `ListAssetsUsingMetadataFieldResponse` Ok
     */
    listAssetsUsingMetadataField: (
      { tenantId, fieldId, ...query }: ListAssetsUsingMetadataFieldParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListAssetsUsingMetadataFieldResponse, any>({
        path: `/tenants/${tenantId}/metadata-fields/${fieldId}/assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  label = {
    /**
     * @description ## Get label for an asset Returns the full taxonomy label assigned to an asset, or 204 No Content if none is assigned. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Label
     * @name GetLabelForAsset
     * @request GET:/tenants/{tenantId}/assets/{assetId}/label
     * @secure
     * @response `200` `(GetLabelResponse)` OK
     * @response `204` `void` No Content
     */
    getLabelForAsset: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetLabelResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/label`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Assign a label Assigns or reassigns a taxonomy label to an asset. If a label already exists for this asset in this taxonomy, it is replaced (upsert). Labels can only be assigned to leaf nodes. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Label
     * @name AssignLabel
     * @request PUT:/tenants/{tenantId}/assets/{assetId}/label/{taxonomyId}
     * @secure
     * @response `200` `AssignLabelResponse` Ok
     */
    assignLabel: (
      tenantId: UUID,
      assetId: UUID,
      taxonomyId: UUID,
      data: AssignLabelRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssignLabelResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/label/${taxonomyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Unassign a label Removes a taxonomy label from an asset. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Label
     * @name UnassignLabel
     * @request DELETE:/tenants/{tenantId}/assets/{assetId}/label/{taxonomyId}
     * @secure
     * @response `204` `void` No Content
     */
    unassignLabel: (
      tenantId: UUID,
      assetId: UUID,
      taxonomyId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/label/${taxonomyId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Auto-label an asset Re-runs AI classification on an asset on demand. Clears any existing physna-generated label, resets labelingStatus to pending, and delegates to the classifier. Rejects assets with a user-assigned label — the caller must unassign first. Only runs the classifier when the tenant's taxonomy has `autoLabelOptedIn = true`. Otherwise returns 404, matching the ingest-time gate. **Availability:** This capability is sold as a per-tenant add-on. Contact sales to enable it for your tenant.
     *
     * @tags Label
     * @name AutoLabelAsset
     * @request POST:/tenants/{tenantId}/assets/{assetId}/label/auto
     * @secure
     * @response `204` `void` No Content
     */
    autoLabelAsset: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/label/auto`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  folders = {
    /**
     * @description ## Create a new folder Folders are used to organize assets like files in a filesystem.
     *
     * @tags Folders
     * @name CreateFolder
     * @request POST:/tenants/{tenantId}/folders
     * @secure
     * @response `200` `CreateFolderResponse` Ok
     */
    createFolder: (
      tenantId: UUID,
      data: CreateFolderRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateFolderResponse, any>({
        path: `/tenants/${tenantId}/folders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List folders Returns a paginated list of folders.
     *
     * @tags Folders
     * @name ListFolders
     * @request GET:/tenants/{tenantId}/folders
     * @secure
     * @response `200` `ListFoldersResponse` Ok
     */
    listFolders: (
      { tenantId, ...query }: ListFoldersParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListFoldersResponse, any>({
        path: `/tenants/${tenantId}/folders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get a folder Returns a folder by folder ID.
     *
     * @tags Folders
     * @name GetFolder
     * @request GET:/tenants/{tenantId}/folders/{folderId}
     * @secure
     * @response `200` `GetFolderResponse` Ok
     */
    getFolder: (tenantId: UUID, folderId: UUID, params: RequestParams = {}) =>
      this.http.request<GetFolderResponse, any>({
        path: `/tenants/${tenantId}/folders/${folderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a folder and all of its contents (subfolders and assets).
     *
     * @tags Folders
     * @name DeleteFolder
     * @request DELETE:/tenants/{tenantId}/folders/{folderId}
     * @secure
     * @response `204` `void` No content
     */
    deleteFolder: (
      tenantId: UUID,
      folderId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/folders/${folderId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Rename a folder Updates the folder's name and adjusts paths for all descendant folders.
     *
     * @tags Folders
     * @name RenameFolder
     * @request PATCH:/tenants/{tenantId}/folders/{folderId}/name
     * @secure
     * @response `200` `RenameFolderResponse` Ok
     */
    renameFolder: (
      tenantId: UUID,
      folderId: UUID,
      data: RenameFolderRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<RenameFolderResponse, any>({
        path: `/tenants/${tenantId}/folders/${folderId}/name`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Move a folder Moves the folder to a different parent folder and adjusts paths for all descendants.
     *
     * @tags Folders
     * @name MoveFolder
     * @request PATCH:/tenants/{tenantId}/folders/{folderId}/parent
     * @secure
     * @response `200` `MoveFolderResponse` Ok
     */
    moveFolder: (
      tenantId: UUID,
      folderId: UUID,
      data: MoveFolderRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MoveFolderResponse, any>({
        path: `/tenants/${tenantId}/folders/${folderId}/parent`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Update a folder's description Sets or replaces the folder's description. Use DELETE to remove the description.
     *
     * @tags Folders
     * @name UpdateFolderDescription
     * @request PATCH:/tenants/{tenantId}/folders/{folderId}/description
     * @secure
     * @response `200` `UpdateFolderDescriptionResponse` Ok
     */
    updateFolderDescription: (
      tenantId: UUID,
      folderId: UUID,
      data: UpdateFolderDescriptionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UpdateFolderDescriptionResponse, any>({
        path: `/tenants/${tenantId}/folders/${folderId}/description`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Remove a folder's description Clears the folder's description.
     *
     * @tags Folders
     * @name DeleteFolderDescription
     * @request DELETE:/tenants/{tenantId}/folders/{folderId}/description
     * @secure
     * @response `200` `DeleteFolderDescriptionResponse` Ok
     */
    deleteFolderDescription: (
      tenantId: UUID,
      folderId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<DeleteFolderDescriptionResponse, any>({
        path: `/tenants/${tenantId}/folders/${folderId}/description`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List the contents of the root including subfolders and assets.
     *
     * @tags Folders
     * @name ListRootContents
     * @request GET:/tenants/{tenantId}/folders/root/contents
     * @secure
     * @response `200` `ListFolderContentsResponse` Ok
     */
    listRootContents: (
      { tenantId, ...query }: ListRootContentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListFolderContentsResponse, any>({
        path: `/tenants/${tenantId}/folders/root/contents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List the contents of a folder including subfolders and assets.
     *
     * @tags Folders
     * @name ListFolderContents
     * @request GET:/tenants/{tenantId}/folders/{folderId}/contents
     * @secure
     * @response `200` `ListFolderContentsResponse` Ok
     */
    listFolderContents: (
      { tenantId, folderId, ...query }: ListFolderContentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListFolderContentsResponse, any>({
        path: `/tenants/${tenantId}/folders/${folderId}/contents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  failures = {
    /**
     * @description ## List recent failures Returns failed assets, reports and part finder reports for a tenant as one list, newest first, so a caller does not have to page three surfaces separately.
     *
     * @tags Failures
     * @name ListRecentFailures
     * @request GET:/tenants/{tenantId}/failures
     * @secure
     * @response `200` `ListRecentFailuresResponse` Ok
     */
    listRecentFailures: (
      { tenantId, ...query }: ListRecentFailuresParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListRecentFailuresResponse, any>({
        path: `/tenants/${tenantId}/failures`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Plan a self-service fix Classifies the most recent failures of a kind not yet tried, so the caller can say how many a fix would re-queue and which are file problems it would leave alone.
     *
     * @tags Failures
     * @name GetFailureRemediationPlan
     * @request GET:/tenants/{tenantId}/failures/remediation-plan
     * @secure
     * @response `200` `FailureRemediationPlanResponse` Ok
     */
    getFailureRemediationPlan: (
      { tenantId, ...query }: GetFailureRemediationPlanParams,
      params: RequestParams = {},
    ) =>
      this.http.request<FailureRemediationPlanResponse, any>({
        path: `/tenants/${tenantId}/failures/remediation-plan`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Run a self-service fix Reprocesses failed assets or retries failed Part Finder searches, skipping failures classified as file problems, and records the batch so failures that fail again are recognised as already tried.
     *
     * @tags Failures
     * @name CreateFailureRemediation
     * @request POST:/tenants/{tenantId}/failures/remediations
     * @secure
     * @response `201` `FailureRemediationResponse` Created
     */
    createFailureRemediation: (
      tenantId: UUID,
      data: CreateFailureRemediationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<FailureRemediationResponse, any>({
        path: `/tenants/${tenantId}/failures/remediations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  authentication = {
    /**
     * No description
     *
     * @tags Authentication
     * @name Login
     * @request POST:/auth/token
     * @secure
     * @response `200` `TokenResponse` Ok
     */
    login: (params: RequestParams = {}) =>
      this.http.request<TokenResponse, any>({
        path: `/auth/token`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  assets = {
    /**
     * @description ## Create a new asset An asset is the core resource of the platform. Assets can be used to search with and assets are search results. Every asset has a file associated with it. It can be a document, image or a 3D model. Assets can be annotated with [metadata](#/Metadata/CreateMetadataField) for multi-modal searching and organized into [folders](#/Folders/CreateFolder) like files in a filesystem.
     *
     * @tags Assets
     * @name CreateAsset
     * @request POST:/tenants/{tenantId}/assets
     * @secure
     * @response `200` `Asset` Ok
     */
    createAsset: (
      tenantId: UUID,
      data: CreateAssetPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<Asset, any>({
        path: `/tenants/${tenantId}/assets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List assets Returns a paginated list of assets. Two pagination modes are supported: 1. **Offset (`page` + `perPage`)** — default. Returns `pageData` with totals and page numbers. Not safe under concurrent writes: a delete that occurs while a client is paginating can cause records to be silently skipped on subsequent pages. 2. **Stable cursor (`cursor` + `perPage`)** — recommended for full-tenant enumeration. Pass the `nextCursor` value from the previous response to fetch the next page. Page boundaries are anchored to asset identity and are not affected by concurrent inserts or deletes. The response omits `pageData` entirely in cursor mode; consume `nextCursor`, and stop when it is absent. Cursor mode cannot be combined with offset: requests that supply both `cursor` and a non-default `page` are rejected with 400.
     *
     * @tags Assets
     * @name ListAssets
     * @request GET:/tenants/{tenantId}/assets
     * @secure
     * @response `200` `ListAssetsResponse` Ok
     */
    listAssets: (
      { tenantId, ...query }: ListAssetsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListAssetsResponse, any>({
        path: `/tenants/${tenantId}/assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Create a manifest asset A manifest asset defines a collection of other assets that are related to each other.  It provides a list of required assets necessary for the bundle to be "complete", providing a mechanism for multi-file analysis. The manifest supports partial indexing and will automatically re-index as dependencies become available. Dependencies are defined as relative paths from the manifest path. Example: ``` { "path": "project/assembly-manifest.json", "dependencies": [{"path": "part1.sldprt", "occurrences": 1}, {"path": "subfolder/part2.step", "occurrences": 2}], "standards": { "mmSteelBuffer": 2.5, "directGate": 2, "edgeGate": 1 }, "metadata": { "material": "steel", "project": "assembly-1" } } ``` This example would create a manifest asset with the path `project/assembly-manifest.json`.  The manifest file exists in the `project` folder and the dependencies are relative to the manifest path.  For the manifest to be "complete", the dependencies `project/part1.sldprt` and `project/subfolder/part2.step` must exist. Occurrences are the number of times the dependency appears in the manifest layout. Manifests can be created within any pre-existing folder, but when `createMissingFolders` is `true`, folders on the manifest path will be created if they do not exist. _Note that this feature is not enabled by default. Please contact support to enable it._
     *
     * @tags Assets
     * @name CreateManifestAsset
     * @request POST:/tenants/{tenantId}/assets/manifest
     * @secure
     * @response `200` `Asset` Ok
     */
    createManifestAsset: (
      tenantId: UUID,
      data: CreateManifestAssetPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<Asset, any>({
        path: `/tenants/${tenantId}/assets/manifest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Update manifest asset Partially updates the content of a manifest asset. Accepts optional `dependencies`, `standards`, and `moldAssetId` fields. When `dependencies` is provided, the full dependency list is replaced and dependency flags are recalculated. When `standards` is provided, individual fields are deep-merged with existing values. When `moldAssetId` is provided, the MOLD Asset is associated with the manifest. Changing `dependencies` or `standards` deletes stale mold analysis and reprocesses it. Changing only `moldAssetId` does neither. _Note that this feature is not enabled by default. Please contact support to enable it._
     *
     * @tags Assets
     * @name UpdateManifestAsset
     * @request PATCH:/tenants/{tenantId}/assets/{assetId}/manifest
     * @secure
     * @response `204` `void` No Content
     */
    updateManifestAsset: (
      tenantId: UUID,
      assetId: UUID,
      data: UpdateManifestAssetPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/manifest`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a ground truth mold analysis for a manifest asset with supplied analysis data. This is stored separately from Physna-computed results and does not override them. The analysis is versioned, and the version will always be 1 greater than the highest existing version.  Results in a new supplemental asset associated with the manifest asset, and the new asset id is returned as `analysisAssetId` at the `path` indicated. <br>Example request body: ``` { "mmBlockDimensions": { "x": 100, "y": 200, "z": 300 }, "actions": [ { "type": "Small Angled Lifter w/o Water", "quantity": 3 }, { "type": "Medium Mechanical Slide w/ Water", "quantity": 2 } ] } ```
     *
     * @tags Assets
     * @name CreateMoldAnalysisResult
     * @request POST:/tenants/{tenantId}/assets/{assetId}/mold-analysis-result
     * @secure
     * @response `200` `MoldAnalysisResultResponse` Ok
     */
    createMoldAnalysisResult: (
      tenantId: UUID,
      assetId: UUID,
      data: CreateMoldAnalysisResultPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<MoldAnalysisResultResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/mold-analysis-result`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the latest mold analysis result for a manifest asset. Returns the parsed analysis data as JSON including block dimensions and actions. The latest version is automatically selected when multiple analysis results exist. _Note that this feature is not enabled by default. Please contact support to enable it._
     *
     * @tags Assets
     * @name FetchMoldAnalysisResult
     * @request GET:/tenants/{tenantId}/assets/{assetId}/mold-analysis-result
     * @secure
     * @response `200` `GetMoldAnalysisResponse` Ok
     */
    fetchMoldAnalysisResult: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<GetMoldAnalysisResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/mold-analysis-result`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get assets by IDs (batch) Returns assets for the provided asset IDs. This endpoint is designed for retrieving large numbers of assets (up to 1000) efficiently.
     *
     * @tags Assets
     * @name BatchGetAssets
     * @request POST:/tenants/{tenantId}/assets/batch
     * @secure
     * @response `200` `BatchGetAssetsResponse` Ok
     */
    batchGetAssets: (
      tenantId: UUID,
      data: BatchGetAssetsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BatchGetAssetsResponse, any>({
        path: `/tenants/${tenantId}/assets/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Find existing asset paths Returns which of the provided paths already hold an asset. Call it before a large upload to skip files that [create an asset](#/Assets/CreateAsset) would reject as duplicates, instead of sending them. A path matches when an asset with the same file name exists in the same folder. The match is case-sensitive. Paths in folders that do not exist are never returned.
     *
     * @tags Assets
     * @name FindExistingAssetPaths
     * @request POST:/tenants/{tenantId}/assets/existing-paths
     * @secure
     * @response `200` `FindExistingAssetPathsResponse` Ok
     */
    findExistingAssetPaths: (
      tenantId: UUID,
      data: FindExistingAssetPathsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<FindExistingAssetPathsResponse, any>({
        path: `/tenants/${tenantId}/assets/existing-paths`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Reprocess a single asset Triggers reprocessing for a single asset. The asset state is set to INDEXING and a reprocess event is emitted. Assets can be reprocessed regardless of their current state.
     *
     * @tags Assets
     * @name ReprocessAsset
     * @request POST:/tenants/{tenantId}/assets/{assetId}/reprocess
     * @secure
     * @response `204` `void` No content
     */
    reprocessAsset: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/reprocess`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Get asset state counts Returns counts of assets grouped by their state (indexing, finished, failed, unsupported, no-3d-data).
     *
     * @tags Assets
     * @name GetAssetStateCounts
     * @request GET:/tenants/{tenantId}/assets/state
     * @secure
     * @response `200` `AssetStateCountsResponse` Ok
     */
    getAssetStateCounts: (
      { tenantId, ...query }: GetAssetStateCountsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetStateCountsResponse, any>({
        path: `/tenants/${tenantId}/assets/state`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get asset type counts Returns counts of assets grouped by their type (model, image, document, manifest, scan, scene, mold). Types belonging to a feature the tenant does not have enabled are omitted from the response.
     *
     * @tags Assets
     * @name GetAssetTypeCounts
     * @request GET:/tenants/{tenantId}/assets/type-counts
     * @secure
     * @response `200` `AssetTypeCountsResponse` Ok
     */
    getAssetTypeCounts: (
      { tenantId, ...query }: GetAssetTypeCountsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetTypeCountsResponse, any>({
        path: `/tenants/${tenantId}/assets/type-counts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get asset file type counts Returns counts of assets grouped by file format (STEP, Parasolid, SolidWorks, ...), derived from each asset's file extension. Aliased extensions such as `.stp` and `.step` count together. The counts plus `unrecognized` add up to the asset state counts total for the same filter.
     *
     * @tags Assets
     * @name GetAssetFileTypeCounts
     * @request GET:/tenants/{tenantId}/assets/file-type-counts
     * @secure
     * @response `200` `AssetFileTypeCountsResponse` Ok
     */
    getAssetFileTypeCounts: (
      { tenantId, ...query }: GetAssetFileTypeCountsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetFileTypeCountsResponse, any>({
        path: `/tenants/${tenantId}/assets/file-type-counts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get metadata coverage Returns how many of the tenant's assets have at least one metadata value, alongside the total asset count. Demo assets uploaded by Physna are excluded from both counts.
     *
     * @tags Assets
     * @name GetMetadataCoverage
     * @request GET:/tenants/{tenantId}/metadata-coverage
     * @secure
     * @response `200` `MetadataCoverageResponse` Ok
     */
    getMetadataCoverage: (tenantId: UUID, params: RequestParams = {}) =>
      this.http.request<MetadataCoverageResponse, any>({
        path: `/tenants/${tenantId}/metadata-coverage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get labeling coverage Returns how many of the tenant's assets carry at least one taxonomy label, alongside the total asset count. An asset labeled in several taxonomies counts once. Demo assets uploaded by Physna are excluded from both counts.
     *
     * @tags Assets
     * @name GetLabelingCoverage
     * @request GET:/tenants/{tenantId}/labeling-coverage
     * @secure
     * @response `200` `LabelingCoverageResponse` Ok
     */
    getLabelingCoverage: (tenantId: UUID, params: RequestParams = {}) =>
      this.http.request<LabelingCoverageResponse, any>({
        path: `/tenants/${tenantId}/labeling-coverage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List assets without metadata Returns a paginated list of the tenant's assets that have no metadata values, oldest first. Demo assets uploaded by Physna are excluded.
     *
     * @tags Assets
     * @name ListAssetsWithoutMetadata
     * @request GET:/tenants/{tenantId}/assets/without-metadata
     * @secure
     * @response `200` `ListAssetsWithoutMetadataResponse` Ok
     */
    listAssetsWithoutMetadata: (
      { tenantId, ...query }: ListAssetsWithoutMetadataParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListAssetsWithoutMetadataResponse, any>({
        path: `/tenants/${tenantId}/assets/without-metadata`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List assets without labels Returns a paginated list of the tenant's assets that carry no taxonomy label, oldest first. Demo assets uploaded by Physna are excluded.
     *
     * @tags Assets
     * @name ListAssetsWithoutLabels
     * @request GET:/tenants/{tenantId}/assets/without-labels
     * @secure
     * @response `200` `ListAssetsWithoutLabelsResponse` Ok
     */
    listAssetsWithoutLabels: (
      { tenantId, ...query }: ListAssetsWithoutLabelsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListAssetsWithoutLabelsResponse, any>({
        path: `/tenants/${tenantId}/assets/without-labels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## List assets by state Returns a paginated list of assets filtered by their state.
     *
     * @tags Assets
     * @name ListAssetsByState
     * @request GET:/tenants/{tenantId}/assets/state/{assetState}
     * @secure
     * @response `200` `ListAssetsByStateResponse` Ok
     */
    listAssetsByState: (
      { tenantId, assetState, ...query }: ListAssetsByStateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ListAssetsByStateResponse, any>({
        path: `/tenants/${tenantId}/assets/state/${assetState}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Is failure diagnostics lookup available here Reports whether this environment has failure log search configured, so a client can decide up front whether to offer the lookup at all rather than showing a control that can only ever answer `unavailable`.
     *
     * @tags Assets
     * @name GetFailureDiagnosticsAvailability
     * @request GET:/tenants/{tenantId}/failure-diagnostics/availability
     * @secure
     * @response `200` `FailureDiagnosticsAvailabilityResponse` Ok
     */
    getFailureDiagnosticsAvailability: (
      tenantId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<FailureDiagnosticsAvailabilityResponse, any>({
        path: `/tenants/${tenantId}/failure-diagnostics/availability`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get failure diagnostics for an asset Looks up why a failed asset failed by searching the ingestion service logs on demand. Nothing is persisted; the answer is only as durable as log retention. Returns a `status` of `found`, `not-found` (asset is not failed, or the log entry has aged out), or `unavailable` (log search is not configured for this environment).
     *
     * @tags Assets
     * @name GetAssetFailureDiagnostics
     * @request GET:/tenants/{tenantId}/assets/{assetId}/failure-diagnostics
     * @secure
     * @response `200` `FailureDiagnosticsResponse` Ok
     */
    getAssetFailureDiagnostics: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<FailureDiagnosticsResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/failure-diagnostics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get an asset Returns an asset by ID.
     *
     * @tags Assets
     * @name GetAsset
     * @request GET:/tenants/{tenantId}/assets/{assetId}
     * @secure
     * @response `200` `GetAssetResponse` Ok
     */
    getAsset: (tenantId: UUID, assetId: UUID, params: RequestParams = {}) =>
      this.http.request<GetAssetResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Delete an asset Deleting an asset by ID is a permanent operation. * The asset file uploaded and files generated when it was created are deleted from the platform * Deleting an asset that is a dependency of another asset will not change the dependent asset in any way
     *
     * @tags Assets
     * @name DeleteAsset
     * @request DELETE:/tenants/{tenantId}/assets/{assetId}
     * @secure
     * @response `204` `void` No content
     */
    deleteAsset: (tenantId: UUID, assetId: UUID, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Decorate assets with supplemental assets IDs and metadata``` Assign string, boolean or number values to asset metadata fields by asset ID.
     *
     * @tags Assets
     * @name UpdateAsset
     * @request PATCH:/tenants/{tenantId}/assets/{assetId}
     * @secure
     * @response `204` `void` No content
     */
    updateAsset: (
      tenantId: UUID,
      assetId: UUID,
      data: UpdateAssetRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Replace an asset's file Replaces the file content of an existing asset. The asset keeps its ID, path, and metadata, but is re-indexed with the new file. The file extension must match the asset's existing path. This is the recommended way to update an asset's file content without deleting and re-creating it.
     *
     * @tags Assets
     * @name ReplaceAssetFile
     * @request PUT:/tenants/{tenantId}/assets/{assetId}/file
     * @secure
     * @response `200` `Asset` Ok
     */
    replaceAssetFile: (
      tenantId: UUID,
      assetId: UUID,
      data: ReplaceAssetFilePayload,
      params: RequestParams = {},
    ) =>
      this.http.request<Asset, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/file`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Download an asset file Download the file that was uploaded when the asset was created by asset ID. When a file has dependencies, the file and its dependencies will be downloaded as a zip file.
     *
     * @tags Assets
     * @name AssetDownload
     * @request GET:/tenants/{tenantId}/assets/{assetId}/file
     * @secure
     * @response `200` `UUID` Ok
     */
    assetDownload: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/file`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description ## Move an asset to a different folder Moves the asset to a different folder or to the root level.
     *
     * @tags Assets
     * @name MoveAsset
     * @request PATCH:/tenants/{tenantId}/assets/{assetId}/folder
     * @secure
     * @response `200` `MoveAssetResponse` Ok
     */
    moveAsset: (
      tenantId: UUID,
      assetId: UUID,
      data: MoveAssetRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MoveAssetResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/folder`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Download an asset thumbnail Download the thumbnail generated when the asset was created by asset ID. Assets with an image or 3D file have a thumbnail. Assets with a document file do not.
     *
     * @tags Assets
     * @name AssetThumbnail
     * @request GET:/tenants/{tenantId}/assets/{assetId}/thumbnail.png
     * @secure
     * @response `200` `UUID` Ok
     */
    assetThumbnail: (
      tenantId: UUID,
      assetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/thumbnail.png`,
        method: "GET",
        secure: true,
        format: "blob",
        ...params,
      }),

    /**
     * @description ## Get 3D file dependencies
     *
     * @tags Assets
     * @name GetAssetDependencies
     * @request GET:/tenants/{tenantId}/assets/{assetPath}/dependencies
     * @deprecated
     * @secure
     * @response `200` `GetAssetDependenciesResponse` Ok
     */
    getAssetDependencies: (
      { tenantId, assetPath, ...query }: GetAssetDependenciesParams,
      params: RequestParams = {},
    ) =>
      this.http.request<GetAssetDependenciesResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetPath}/dependencies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Get 3D file dependencies by asset ID Returns a paginated list of child dependencies for an asset by its ID. This endpoint uses the asset's stored path internally, ensuring consistent dependency lookups even when folders have been moved or renamed.
     *
     * @tags Assets
     * @name GetAssetDependenciesById
     * @request GET:/tenants/{tenantId}/assets/{assetId}/dependencies-by-id
     * @secure
     * @response `200` `GetAssetDependenciesResponse` Ok
     */
    getAssetDependenciesById: (
      { tenantId, assetId, ...query }: GetAssetDependenciesByIdParams,
      params: RequestParams = {},
    ) =>
      this.http.request<GetAssetDependenciesResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/dependencies-by-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Resolve a missing dependency Links a missing dependency to an existing asset. When resolved, the assembly is re-indexed with the resolved dependency.
     *
     * @tags Assets
     * @name ResolveDependency
     * @request POST:/tenants/{tenantId}/assets/{assetId}/resolve-dependency
     * @secure
     * @response `204` `void`
     */
    resolveDependency: (
      tenantId: UUID,
      assetId: UUID,
      data: ResolveDependencyPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/resolve-dependency`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Delete metadata from an asset Delete metadata by metadata field name from an asset by asset ID.
     *
     * @tags Assets
     * @name DeleteMetadataFromAsset
     * @request DELETE:/tenants/{tenantId}/assets/{assetId}/metadata
     * @secure
     * @response `204` `void` No content
     */
    deleteMetadataFromAsset: (
      tenantId: UUID,
      assetId: UUID,
      data: DeleteMetadataFromAssetRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/metadata`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find geometric matches for an asset. `matchPercentage` measures how similar is the asset to the match. A 100% match means the asset is the match.
     *
     * @tags Assets
     * @name AssetGeometricSearch
     * @request POST:/tenants/{tenantId}/assets/{assetId}/geometric-search
     * @secure
     * @response `200` `GeometricSearchResponse` Ok
     */
    assetGeometricSearch: (
      tenantId: UUID,
      assetId: UUID,
      data: GeometricSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GeometricSearchResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/geometric-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get pairwise match scores between two assets. Returns geometric match percentages comparing how similar two 3D models are to each other. When enabled, volumetric results include a similarity percentage and may include unmatched holes, the total distance between matched hole centers, and a breakdown of mismatch volumes. Source refers to assetId and target to targetAssetId. Distances are in millimeters and volumes are in cubic millimeters. Missing detail fields indicate that the detail was not returned. Volumetric match scores must be explicitly enabled. Contact sales for more info. Both assets must be 3D models in FINISHED state.
     *
     * @tags Assets
     * @name GetMatchScores
     * @request GET:/tenants/{tenantId}/assets/{assetId}/match-scores/{targetAssetId}
     * @secure
     * @response `200` `MatchScoresResponse` Ok
     */
    getMatchScores: (
      tenantId: UUID,
      assetId: UUID,
      targetAssetId: UUID,
      params: RequestParams = {},
    ) =>
      this.http.request<MatchScoresResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/match-scores/${targetAssetId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Find part matches for an asset. `forwardMatchPercentage` measures how much of the asset exists in the match. A 100% forward match means 100% of the asset's geometry was found in the match; Ie. the asset is a part of the match. <br><br> `reverseMatchPercentage` measures how much of the match was found in the asset. A 100% reverse match means 100% of the match's geometry was found in the asset; Ie. the match is a part of the asset.
     *
     * @tags Assets
     * @name AssetPartSearch
     * @request POST:/tenants/{tenantId}/assets/{assetId}/part-search
     * @secure
     * @response `200` `PartSearchResponse` Ok
     */
    assetPartSearch: (
      tenantId: UUID,
      assetId: UUID,
      data: PartSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<PartSearchResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/part-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Search for visual matches by asset A multi-modal search that returns a list of assets that visually match the given asset ID.
     *
     * @tags Assets
     * @name AssetVisualSearch
     * @request POST:/tenants/{tenantId}/assets/{assetId}/visual-search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    assetVisualSearch: (
      { tenantId, assetId, ...query }: AssetVisualSearchParams,
      data?: AssetVisualSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/visual-search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Download geometric search results Server-side export of geometric search results as CSV or XLSX. The request body matches the geometric-search endpoint so the export reflects exactly the filters the user is viewing.
     *
     * @tags Assets
     * @name AssetGeometricSearchExport
     * @request POST:/tenants/{tenantId}/assets/{assetId}/geometric-search/file
     * @secure
     * @response `200` `UUID` Ok
     */
    assetGeometricSearchExport: (
      { tenantId, assetId, ...query }: AssetGeometricSearchExportParams,
      data: GeometricSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/geometric-search/file`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Download part search results Server-side export of part search results as CSV or XLSX.
     *
     * @tags Assets
     * @name AssetPartSearchExport
     * @request POST:/tenants/{tenantId}/assets/{assetId}/part-search/file
     * @secure
     * @response `200` `UUID` Ok
     */
    assetPartSearchExport: (
      { tenantId, assetId, ...query }: AssetPartSearchExportParams,
      data: PartSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/part-search/file`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Download visual search results Server-side export of visual search results as CSV or XLSX.
     *
     * @tags Assets
     * @name AssetVisualSearchExport
     * @request POST:/tenants/{tenantId}/assets/{assetId}/visual-search/file
     * @secure
     * @response `200` `UUID` Ok
     */
    assetVisualSearchExport: (
      { tenantId, assetId, ...query }: AssetVisualSearchExportParams,
      data: AssetVisualSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/visual-search/file`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Download text search results Server-side export of text search results as CSV or XLSX. Text search matches a query rather than a source asset, so the file holds one row per matched asset: no reference columns, no match percentages and no comparison link.
     *
     * @tags Assets
     * @name TextSearchExport
     * @request POST:/tenants/{tenantId}/assets/text-search/file
     * @secure
     * @response `200` `UUID` Ok
     */
    textSearchExport: (
      { tenantId, ...query }: TextSearchExportParams,
      data: SearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/assets/text-search/file`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ## Composite Search Multi-modal search that combines geometric, visual, and other search modalities to find the most relevant matches.
     *
     * @tags Assets
     * @name AssetCompositeSearch
     * @request POST:/tenants/{tenantId}/assets/{assetId}/search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    assetCompositeSearch: (
      { tenantId, assetId, ...query }: AssetCompositeSearchParams,
      data?: SearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/${tenantId}/assets/${assetId}/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Segment an image into regions Analyzes an image and divides it into distinct regions using automatic segmentation. Each region is assigned a unique ID and pixel count. The response includes a base64-encoded region map (`Uint16Array`) where each pixel maps to its region ID. ### Region map The `regionMap` field is a base64-encoded binary buffer. Decode it to a `Uint16Array` of length `width * height`. Each element is the region ID for that pixel in row-major order. ``` const bytes = Uint8Array.from(atob(regionMap), c => c.charCodeAt(0)); const map = new Uint16Array(bytes.buffer); const regionIdAtXY = map[y * width + x]; ``` ### Parameters - **pointsPerSide** controls how many regions the image is divided into (2–64, default 32). Lower values produce fewer, larger regions. - **sensitivity** controls how precisely region boundaries follow edges (0–100, default 50). Higher values produce tighter boundaries. ### Constraints - File must be an image (`image/*` MIME type) - Maximum file size: 20 MB
     *
     * @tags Assets
     * @name SegmentImage
     * @request POST:/tenants/{tenantId}/assets/segment
     * @secure
     * @response `200` `SegmentationResult` Ok
     */
    segmentImage: (
      tenantId: UUID,
      data: SegmentImagePayload,
      params: RequestParams = {},
    ) =>
      this.http.request<SegmentationResult, any>({
        path: `/tenants/${tenantId}/assets/segment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  crossTenant = {
    /**
     * @description ## Search Asset keyword search with filters.
     *
     * @tags Cross-tenant, Assets
     * @name TextSearch
     * @request POST:/tenants/{tenantId}/assets/text-search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    textSearch: (
      tenantId: UUID,
      data: SearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/${tenantId}/assets/text-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Search for assets matching uploaded image files A multi-modal search that returns a list of assets that visually match the image files uploaded. Supports single or multiple image uploads for combined visual search.
     *
     * @tags Cross-tenant, Assets
     * @name VisualSearch
     * @request POST:/tenants/{tenantId}/assets/visual-search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    visualSearch: (
      tenantId: UUID,
      data: VisualSearchPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/${tenantId}/assets/visual-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Cross-tenant visual search for an asset A multi-modal search that returns a list of assets that visually match the given asset ID.
     *
     * @tags Cross-tenant, Assets
     * @name CrossTenantVisualSearch
     * @request POST:/tenants/assets/visual-search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    crossTenantVisualSearch: (
      data: CrossTenantAssetVisualSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/assets/visual-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Cross-tenant geometric search for an asset A multi-modal search that returns a list of assets that geometrically match the given asset ID.
     *
     * @tags Cross-tenant, Assets
     * @name CrossTenantGeometricSearch
     * @request POST:/tenants/assets/geometric-search
     * @secure
     * @response `200` `GeometricSearchResponse` Ok
     */
    crossTenantGeometricSearch: (
      data: CrossTenantGeometricSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GeometricSearchResponse, any>({
        path: `/tenants/assets/geometric-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Cross-tenant part search for an asset A multi-modal search that returns a list of assets that part match the given asset ID.
     *
     * @tags Cross-tenant, Assets
     * @name CrossTenantPartSearch
     * @request POST:/tenants/assets/part-search
     * @secure
     * @response `200` `PartSearchResponse` Ok
     */
    crossTenantPartSearch: (
      data: CrossTenantPartSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<PartSearchResponse, any>({
        path: `/tenants/assets/part-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Cross-tenant metadata search for an asset
     *
     * @tags Cross-tenant, Assets
     * @name CrossTenantMetadataSearch
     * @request POST:/tenants/assets/metadata-search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    crossTenantMetadataSearch: (
      data: CrossTenantSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/assets/metadata-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Cross-tenant Composite Search Multi-modal search that combines geometric, visual, and other search modalities to find the most relevant matches.
     *
     * @tags Cross-tenant, Assets
     * @name CrossTenantCompositeSearch
     * @request POST:/tenants/assets/search
     * @secure
     * @response `200` `AssetSearchResponse` Ok
     */
    crossTenantCompositeSearch: (
      data: CrossTenantSearchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<AssetSearchResponse, any>({
        path: `/tenants/assets/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  archiveDownloads = {
    /**
     * @description ## Preview an archive download Returns the file and subfolder counts that a matching [archive download](#/Archive%20downloads/DownloadArchive) would produce for the given selection. Use this to show a confirmation UI before starting the download. Selected folders are included recursively; selected assets are included individually. The response also includes the hard caps (2,000 files, 2 GiB total size) enforced at download time.
     *
     * @tags Archive downloads
     * @name PreviewArchiveDownload
     * @request POST:/tenants/{tenantId}/archive-downloads/preview
     * @secure
     * @response `200` `ArchiveDownloadPreviewResponse` Ok
     */
    previewArchiveDownload: (
      tenantId: UUID,
      data: ArchiveDownloadRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ArchiveDownloadPreviewResponse, any>({
        path: `/tenants/${tenantId}/archive-downloads/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Download a ZIP archive Streams a ZIP archive of the selected folders and assets. Folders are included recursively; assemblies are archived as their dependency bundle, or as the raw source file when a bundle is not available. Selections are capped at 2,000 files and 2 GiB total size; larger selections are rejected before streaming begins.
     *
     * @tags Archive downloads
     * @name DownloadArchive
     * @request POST:/tenants/{tenantId}/archive-downloads
     * @secure
     * @response `200` `UUID` Ok
     */
    downloadArchive: (
      tenantId: UUID,
      data: ArchiveDownloadRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<UUID, any>({
        path: `/tenants/${tenantId}/archive-downloads`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
